"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183, _184, _185, _186, _187, _188, _189, _190, _191, _192, _193, _194, _195, _196, _197, _198, _199, _200, _201, _202, _203, _204, _205, _206, _207, _208, _209, _210, _211, _212, _213, _214, _215, _216, _217, _218, _219, _220, _221, _222, _223, _224, _225, _226, _227, _228, _229, _230, _231, _232, _233, _234, _235, _236, _237, _238, _239, _240, _241, _242;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = (name) => (target, key) => {
    Reflect.defineMetadata('design:type', name, target, key);
};
exports.TypeArray = (name) => (target, key) => {
    Reflect.defineMetadata('design:type', 'Array', target, key);
    Reflect.defineMetadata('design:subtype', name, target, key);
};
require("reflect-metadata");
const LocalizedText_1 = __importDefault(require("./LocalizedText"));
const ExtensionObject_1 = __importDefault(require("./ExtensionObject"));
const Guid_1 = __importDefault(require("./Guid"));
const NodeId_1 = __importDefault(require("./NodeId"));
const ExpandedNodeId_1 = __importDefault(require("./ExpandedNodeId"));
const DiagnosticInfo_1 = __importDefault(require("./DiagnosticInfo"));
const QualifiedName_1 = __importDefault(require("./QualifiedName"));
const Variant_1 = __importDefault(require("./Variant"));
const DataValue_1 = __importDefault(require("./DataValue"));
const StatusCode_1 = require("./StatusCode");
exports.NodeIdTypeTwoByte = 0;
exports.NodeIdTypeFourByte = 1;
exports.NodeIdTypeNumeric = 2;
exports.NodeIdTypeString = 3;
exports.NodeIdTypeGuid = 4;
exports.NodeIdTypeByteString = 5;
exports.NamingRuleTypeMandatory = 1;
exports.NamingRuleTypeOptional = 2;
exports.NamingRuleTypeConstraint = 3;
exports.OpenFileModeRead = 1;
exports.OpenFileModeWrite = 2;
exports.OpenFileModeEraseExisting = 4;
exports.OpenFileModeAppend = 8;
exports.IdentityCriteriaTypeUserName = 1;
exports.IdentityCriteriaTypeThumbprint = 2;
exports.IdentityCriteriaTypeRole = 3;
exports.IdentityCriteriaTypeGroupId = 4;
exports.IdentityCriteriaTypeAnonymous = 5;
exports.IdentityCriteriaTypeAuthenticatedUser = 6;
exports.TrustListMasksNone = 0;
exports.TrustListMasksTrustedCertificates = 1;
exports.TrustListMasksTrustedCrls = 2;
exports.TrustListMasksIssuerCertificates = 4;
exports.TrustListMasksIssuerCrls = 8;
exports.TrustListMasksAll = 15;
exports.PubSubStateDisabled = 0;
exports.PubSubStatePaused = 1;
exports.PubSubStateOperational = 2;
exports.PubSubStateError = 3;
exports.DataSetFieldFlagsNone = 0;
exports.DataSetFieldFlagsPromotedField = 1;
exports.DataSetFieldContentMaskNone = 0;
exports.DataSetFieldContentMaskStatusCode = 1;
exports.DataSetFieldContentMaskSourceTimestamp = 2;
exports.DataSetFieldContentMaskServerTimestamp = 4;
exports.DataSetFieldContentMaskSourcePicoSeconds = 8;
exports.DataSetFieldContentMaskServerPicoSeconds = 16;
exports.DataSetFieldContentMaskRawData = 32;
exports.OverrideValueHandlingDisabled = 0;
exports.OverrideValueHandlingLastUsableValue = 1;
exports.OverrideValueHandlingOverrideValue = 2;
exports.DataSetOrderingTypeUndefined = 0;
exports.DataSetOrderingTypeAscendingWriterId = 1;
exports.DataSetOrderingTypeAscendingWriterIdSingle = 2;
exports.UadpNetworkMessageContentMaskNone = 0;
exports.UadpNetworkMessageContentMaskPublisherId = 1;
exports.UadpNetworkMessageContentMaskGroupHeader = 2;
exports.UadpNetworkMessageContentMaskWriterGroupId = 4;
exports.UadpNetworkMessageContentMaskGroupVersion = 8;
exports.UadpNetworkMessageContentMaskNetworkMessageNumber = 16;
exports.UadpNetworkMessageContentMaskSequenceNumber = 32;
exports.UadpNetworkMessageContentMaskPayloadHeader = 64;
exports.UadpNetworkMessageContentMaskTimestamp = 128;
exports.UadpNetworkMessageContentMaskPicoSeconds = 256;
exports.UadpNetworkMessageContentMaskDataSetClassId = 512;
exports.UadpNetworkMessageContentMaskPromotedFields = 1024;
exports.UadpDataSetMessageContentMaskNone = 0;
exports.UadpDataSetMessageContentMaskTimestamp = 1;
exports.UadpDataSetMessageContentMaskPicoSeconds = 2;
exports.UadpDataSetMessageContentMaskStatus = 4;
exports.UadpDataSetMessageContentMaskMajorVersion = 8;
exports.UadpDataSetMessageContentMaskMinorVersion = 16;
exports.UadpDataSetMessageContentMaskSequenceNumber = 32;
exports.JsonNetworkMessageContentMaskNone = 0;
exports.JsonNetworkMessageContentMaskNetworkMessageHeader = 1;
exports.JsonNetworkMessageContentMaskDataSetMessageHeader = 2;
exports.JsonNetworkMessageContentMaskSingleDataSetMessage = 4;
exports.JsonNetworkMessageContentMaskPublisherId = 8;
exports.JsonNetworkMessageContentMaskDataSetClassId = 16;
exports.JsonNetworkMessageContentMaskReplyTo = 32;
exports.JsonDataSetMessageContentMaskNone = 0;
exports.JsonDataSetMessageContentMaskDataSetWriterId = 1;
exports.JsonDataSetMessageContentMaskMetaDataVersion = 2;
exports.JsonDataSetMessageContentMaskSequenceNumber = 4;
exports.JsonDataSetMessageContentMaskTimestamp = 8;
exports.JsonDataSetMessageContentMaskStatus = 16;
exports.BrokerTransportQualityOfServiceNotSpecified = 0;
exports.BrokerTransportQualityOfServiceBestEffort = 1;
exports.BrokerTransportQualityOfServiceAtLeastOnce = 2;
exports.BrokerTransportQualityOfServiceAtMostOnce = 3;
exports.BrokerTransportQualityOfServiceExactlyOnce = 4;
exports.DiagnosticsLevelBasic = 0;
exports.DiagnosticsLevelAdvanced = 1;
exports.DiagnosticsLevelInfo = 2;
exports.DiagnosticsLevelLog = 3;
exports.DiagnosticsLevelDebug = 4;
exports.PubSubDiagnosticsCounterClassificationInformation = 0;
exports.PubSubDiagnosticsCounterClassificationError = 1;
exports.IdTypeNumeric = 0;
exports.IdTypeString = 1;
exports.IdTypeGuid = 2;
exports.IdTypeOpaque = 3;
exports.NodeClassUnspecified = 0;
exports.NodeClassObject = 1;
exports.NodeClassVariable = 2;
exports.NodeClassMethod = 4;
exports.NodeClassObjectType = 8;
exports.NodeClassVariableType = 16;
exports.NodeClassReferenceType = 32;
exports.NodeClassDataType = 64;
exports.NodeClassView = 128;
exports.PermissionTypeNone = 0;
exports.PermissionTypeBrowse = 1;
exports.PermissionTypeReadRolePermissions = 2;
exports.PermissionTypeWriteAttribute = 4;
exports.PermissionTypeWriteRolePermissions = 8;
exports.PermissionTypeWriteHistorizing = 16;
exports.PermissionTypeRead = 32;
exports.PermissionTypeWrite = 64;
exports.PermissionTypeReadHistory = 128;
exports.PermissionTypeInsertHistory = 256;
exports.PermissionTypeModifyHistory = 512;
exports.PermissionTypeDeleteHistory = 1024;
exports.PermissionTypeReceiveEvents = 2048;
exports.PermissionTypeCall = 4096;
exports.PermissionTypeAddReference = 8192;
exports.PermissionTypeRemoveReference = 16384;
exports.PermissionTypeDeleteNode = 32768;
exports.PermissionTypeAddNode = 65536;
exports.AccessLevelTypeNone = 0;
exports.AccessLevelTypeCurrentRead = 1;
exports.AccessLevelTypeCurrentWrite = 2;
exports.AccessLevelTypeHistoryRead = 4;
exports.AccessLevelTypeHistoryWrite = 8;
exports.AccessLevelTypeSemanticChange = 16;
exports.AccessLevelTypeStatusWrite = 32;
exports.AccessLevelTypeTimestampWrite = 64;
exports.AccessLevelExTypeNone = 0;
exports.AccessLevelExTypeCurrentRead = 1;
exports.AccessLevelExTypeCurrentWrite = 2;
exports.AccessLevelExTypeHistoryRead = 4;
exports.AccessLevelExTypeHistoryWrite = 8;
exports.AccessLevelExTypeSemanticChange = 16;
exports.AccessLevelExTypeStatusWrite = 32;
exports.AccessLevelExTypeTimestampWrite = 64;
exports.AccessLevelExTypeNonatomicRead = 256;
exports.AccessLevelExTypeNonatomicWrite = 512;
exports.AccessLevelExTypeWriteFullArrayOnly = 1024;
exports.EventNotifierTypeNone = 0;
exports.EventNotifierTypeSubscribeToEvents = 1;
exports.EventNotifierTypeHistoryRead = 4;
exports.EventNotifierTypeHistoryWrite = 8;
exports.AccessRestrictionTypeNone = 0;
exports.AccessRestrictionTypeSigningRequired = 1;
exports.AccessRestrictionTypeEncryptionRequired = 2;
exports.AccessRestrictionTypeSessionRequired = 4;
exports.StructureTypeStructure = 0;
exports.StructureTypeStructureWithOptionalFields = 1;
exports.StructureTypeUnion = 2;
exports.ApplicationTypeServer = 0;
exports.ApplicationTypeClient = 1;
exports.ApplicationTypeClientAndServer = 2;
exports.ApplicationTypeDiscoveryServer = 3;
exports.MessageSecurityModeInvalid = 0;
exports.MessageSecurityModeNone = 1;
exports.MessageSecurityModeSign = 2;
exports.MessageSecurityModeSignAndEncrypt = 3;
exports.UserTokenTypeAnonymous = 0;
exports.UserTokenTypeUserName = 1;
exports.UserTokenTypeCertificate = 2;
exports.UserTokenTypeIssuedToken = 3;
exports.SecurityTokenRequestTypeIssue = 0;
exports.SecurityTokenRequestTypeRenew = 1;
exports.NodeAttributesMaskNone = 0;
exports.NodeAttributesMaskAccessLevel = 1;
exports.NodeAttributesMaskArrayDimensions = 2;
exports.NodeAttributesMaskBrowseName = 4;
exports.NodeAttributesMaskContainsNoLoops = 8;
exports.NodeAttributesMaskDataType = 16;
exports.NodeAttributesMaskDescription = 32;
exports.NodeAttributesMaskDisplayName = 64;
exports.NodeAttributesMaskEventNotifier = 128;
exports.NodeAttributesMaskExecutable = 256;
exports.NodeAttributesMaskHistorizing = 512;
exports.NodeAttributesMaskInverseName = 1024;
exports.NodeAttributesMaskIsAbstract = 2048;
exports.NodeAttributesMaskMinimumSamplingInterval = 4096;
exports.NodeAttributesMaskNodeClass = 8192;
exports.NodeAttributesMaskNodeId = 16384;
exports.NodeAttributesMaskSymmetric = 32768;
exports.NodeAttributesMaskUserAccessLevel = 65536;
exports.NodeAttributesMaskUserExecutable = 131072;
exports.NodeAttributesMaskUserWriteMask = 262144;
exports.NodeAttributesMaskValueRank = 524288;
exports.NodeAttributesMaskWriteMask = 1048576;
exports.NodeAttributesMaskValue = 2097152;
exports.NodeAttributesMaskDataTypeDefinition = 4194304;
exports.NodeAttributesMaskRolePermissions = 8388608;
exports.NodeAttributesMaskAccessRestrictions = 16777216;
exports.NodeAttributesMaskAll = 33554431;
exports.NodeAttributesMaskBaseNode = 26501220;
exports.NodeAttributesMaskObject = 26501348;
exports.NodeAttributesMaskObjectType = 26503268;
exports.NodeAttributesMaskVariable = 26571383;
exports.NodeAttributesMaskVariableType = 28600438;
exports.NodeAttributesMaskMethod = 26632548;
exports.NodeAttributesMaskReferenceType = 26537060;
exports.NodeAttributesMaskView = 26501356;
exports.AttributeWriteMaskNone = 0;
exports.AttributeWriteMaskAccessLevel = 1;
exports.AttributeWriteMaskArrayDimensions = 2;
exports.AttributeWriteMaskBrowseName = 4;
exports.AttributeWriteMaskContainsNoLoops = 8;
exports.AttributeWriteMaskDataType = 16;
exports.AttributeWriteMaskDescription = 32;
exports.AttributeWriteMaskDisplayName = 64;
exports.AttributeWriteMaskEventNotifier = 128;
exports.AttributeWriteMaskExecutable = 256;
exports.AttributeWriteMaskHistorizing = 512;
exports.AttributeWriteMaskInverseName = 1024;
exports.AttributeWriteMaskIsAbstract = 2048;
exports.AttributeWriteMaskMinimumSamplingInterval = 4096;
exports.AttributeWriteMaskNodeClass = 8192;
exports.AttributeWriteMaskNodeId = 16384;
exports.AttributeWriteMaskSymmetric = 32768;
exports.AttributeWriteMaskUserAccessLevel = 65536;
exports.AttributeWriteMaskUserExecutable = 131072;
exports.AttributeWriteMaskUserWriteMask = 262144;
exports.AttributeWriteMaskValueRank = 524288;
exports.AttributeWriteMaskWriteMask = 1048576;
exports.AttributeWriteMaskValueForVariableType = 2097152;
exports.AttributeWriteMaskDataTypeDefinition = 4194304;
exports.AttributeWriteMaskRolePermissions = 8388608;
exports.AttributeWriteMaskAccessRestrictions = 16777216;
exports.AttributeWriteMaskAccessLevelEx = 33554432;
exports.BrowseDirectionForward = 0;
exports.BrowseDirectionInverse = 1;
exports.BrowseDirectionBoth = 2;
exports.BrowseDirectionInvalid = 3;
exports.BrowseResultMaskNone = 0;
exports.BrowseResultMaskReferenceTypeId = 1;
exports.BrowseResultMaskIsForward = 2;
exports.BrowseResultMaskNodeClass = 4;
exports.BrowseResultMaskBrowseName = 8;
exports.BrowseResultMaskDisplayName = 16;
exports.BrowseResultMaskTypeDefinition = 32;
exports.BrowseResultMaskAll = 63;
exports.BrowseResultMaskReferenceTypeInfo = 3;
exports.BrowseResultMaskTargetInfo = 60;
exports.FilterOperatorEquals = 0;
exports.FilterOperatorIsNull = 1;
exports.FilterOperatorGreaterThan = 2;
exports.FilterOperatorLessThan = 3;
exports.FilterOperatorGreaterThanOrEqual = 4;
exports.FilterOperatorLessThanOrEqual = 5;
exports.FilterOperatorLike = 6;
exports.FilterOperatorNot = 7;
exports.FilterOperatorBetween = 8;
exports.FilterOperatorInList = 9;
exports.FilterOperatorAnd = 10;
exports.FilterOperatorOr = 11;
exports.FilterOperatorCast = 12;
exports.FilterOperatorInView = 13;
exports.FilterOperatorOfType = 14;
exports.FilterOperatorRelatedTo = 15;
exports.FilterOperatorBitwiseAnd = 16;
exports.FilterOperatorBitwiseOr = 17;
exports.TimestampsToReturnSource = 0;
exports.TimestampsToReturnServer = 1;
exports.TimestampsToReturnBoth = 2;
exports.TimestampsToReturnNeither = 3;
exports.TimestampsToReturnInvalid = 4;
exports.HistoryUpdateTypeInsert = 1;
exports.HistoryUpdateTypeReplace = 2;
exports.HistoryUpdateTypeUpdate = 3;
exports.HistoryUpdateTypeDelete = 4;
exports.PerformUpdateTypeInsert = 1;
exports.PerformUpdateTypeReplace = 2;
exports.PerformUpdateTypeUpdate = 3;
exports.PerformUpdateTypeRemove = 4;
exports.MonitoringModeDisabled = 0;
exports.MonitoringModeSampling = 1;
exports.MonitoringModeReporting = 2;
exports.DataChangeTriggerStatus = 0;
exports.DataChangeTriggerStatusValue = 1;
exports.DataChangeTriggerStatusValueTimestamp = 2;
exports.DeadbandTypeNone = 0;
exports.DeadbandTypeAbsolute = 1;
exports.DeadbandTypePercent = 2;
exports.RedundancySupportNone = 0;
exports.RedundancySupportCold = 1;
exports.RedundancySupportWarm = 2;
exports.RedundancySupportHot = 3;
exports.RedundancySupportTransparent = 4;
exports.RedundancySupportHotAndMirrored = 5;
exports.ServerStateRunning = 0;
exports.ServerStateFailed = 1;
exports.ServerStateNoConfiguration = 2;
exports.ServerStateSuspended = 3;
exports.ServerStateShutdown = 4;
exports.ServerStateTest = 5;
exports.ServerStateCommunicationFault = 6;
exports.ServerStateUnknown = 7;
exports.ModelChangeStructureVerbMaskNodeAdded = 1;
exports.ModelChangeStructureVerbMaskNodeDeleted = 2;
exports.ModelChangeStructureVerbMaskReferenceAdded = 4;
exports.ModelChangeStructureVerbMaskReferenceDeleted = 8;
exports.ModelChangeStructureVerbMaskDataTypeChanged = 16;
exports.AxisScaleEnumerationLinear = 0;
exports.AxisScaleEnumerationLog = 1;
exports.AxisScaleEnumerationLn = 2;
exports.ExceptionDeviationFormatAbsoluteValue = 0;
exports.ExceptionDeviationFormatPercentOfValue = 1;
exports.ExceptionDeviationFormatPercentOfRange = 2;
exports.ExceptionDeviationFormatPercentOfEURange = 3;
exports.ExceptionDeviationFormatUnknown = 4;
class CurrencyUnitType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.NumericCode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.NumericCode, (_b !== null && _b !== void 0 ? _b : 0));
        this.Exponent = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Exponent, (_d !== null && _d !== void 0 ? _d : 0));
        this.AlphabeticCode = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.AlphabeticCode, (_f !== null && _f !== void 0 ? _f : ''));
        this.Currency = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.Currency, (_h !== null && _h !== void 0 ? _h : new LocalizedText_1.default()));
    }
}
__decorate([
    exports.Type('int16'),
    __metadata("design:type", typeof (_a = typeof int16 !== "undefined" && int16) === "function" ? _a : Object)
], CurrencyUnitType.prototype, "NumericCode", void 0);
__decorate([
    exports.Type('int8'),
    __metadata("design:type", typeof (_b = typeof int8 !== "undefined" && int8) === "function" ? _b : Object)
], CurrencyUnitType.prototype, "Exponent", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], CurrencyUnitType.prototype, "AlphabeticCode", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], CurrencyUnitType.prototype, "Currency", void 0);
exports.CurrencyUnitType = CurrencyUnitType;
class KeyValuePair {
    constructor(options) {
        var _a, _b, _c, _d;
        this.Key = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Key, (_b !== null && _b !== void 0 ? _b : new QualifiedName_1.default()));
        this.Value = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Value, (_d !== null && _d !== void 0 ? _d : new Variant_1.default()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", QualifiedName_1.default)
], KeyValuePair.prototype, "Key", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", Variant_1.default)
], KeyValuePair.prototype, "Value", void 0);
exports.KeyValuePair = KeyValuePair;
class AdditionalParametersType {
    constructor(options) {
        var _a, _b;
        this.Parameters = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Parameters, (_b !== null && _b !== void 0 ? _b : null));
    }
}
__decorate([
    exports.TypeArray('KeyValuePair'),
    __metadata("design:type", Object)
], AdditionalParametersType.prototype, "Parameters", void 0);
exports.AdditionalParametersType = AdditionalParametersType;
class EphemeralKeyType {
    constructor(options) {
        var _a, _b, _c, _d;
        this.PublicKey = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.PublicKey, (_b !== null && _b !== void 0 ? _b : new Uint8Array()));
        this.Signature = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Signature, (_d !== null && _d !== void 0 ? _d : new Uint8Array()));
    }
}
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_c = typeof ByteString !== "undefined" && ByteString) === "function" ? _c : Object)
], EphemeralKeyType.prototype, "PublicKey", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_d = typeof ByteString !== "undefined" && ByteString) === "function" ? _d : Object)
], EphemeralKeyType.prototype, "Signature", void 0);
exports.EphemeralKeyType = EphemeralKeyType;
class EndpointType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.EndpointUrl = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.EndpointUrl, (_b !== null && _b !== void 0 ? _b : ''));
        this.SecurityMode = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SecurityMode, (_d !== null && _d !== void 0 ? _d : exports.MessageSecurityModeInvalid));
        this.SecurityPolicyUri = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.SecurityPolicyUri, (_f !== null && _f !== void 0 ? _f : ''));
        this.TransportProfileUri = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.TransportProfileUri, (_h !== null && _h !== void 0 ? _h : ''));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], EndpointType.prototype, "EndpointUrl", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_e = typeof MessageSecurityMode !== "undefined" && MessageSecurityMode) === "function" ? _e : Object)
], EndpointType.prototype, "SecurityMode", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], EndpointType.prototype, "SecurityPolicyUri", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], EndpointType.prototype, "TransportProfileUri", void 0);
exports.EndpointType = EndpointType;
class RationalNumber {
    constructor(options) {
        var _a, _b, _c, _d;
        this.Numerator = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Numerator, (_b !== null && _b !== void 0 ? _b : 0));
        this.Denominator = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Denominator, (_d !== null && _d !== void 0 ? _d : 0));
    }
}
__decorate([
    exports.Type('int32'),
    __metadata("design:type", typeof (_f = typeof int32 !== "undefined" && int32) === "function" ? _f : Object)
], RationalNumber.prototype, "Numerator", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_g = typeof uint32 !== "undefined" && uint32) === "function" ? _g : Object)
], RationalNumber.prototype, "Denominator", void 0);
exports.RationalNumber = RationalNumber;
class IdentityMappingRuleType {
    constructor(options) {
        var _a, _b, _c, _d;
        this.CriteriaType = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.CriteriaType, (_b !== null && _b !== void 0 ? _b : exports.IdentityCriteriaTypeUserName));
        this.Criteria = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Criteria, (_d !== null && _d !== void 0 ? _d : ''));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_h = typeof IdentityCriteriaType !== "undefined" && IdentityCriteriaType) === "function" ? _h : Object)
], IdentityMappingRuleType.prototype, "CriteriaType", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], IdentityMappingRuleType.prototype, "Criteria", void 0);
exports.IdentityMappingRuleType = IdentityMappingRuleType;
class TrustListDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.SpecifiedLists = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.SpecifiedLists, (_b !== null && _b !== void 0 ? _b : 0));
        this.TrustedCertificates = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.TrustedCertificates, (_d !== null && _d !== void 0 ? _d : null));
        this.TrustedCrls = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.TrustedCrls, (_f !== null && _f !== void 0 ? _f : null));
        this.IssuerCertificates = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.IssuerCertificates, (_h !== null && _h !== void 0 ? _h : null));
        this.IssuerCrls = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.IssuerCrls, (_k !== null && _k !== void 0 ? _k : null));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_j = typeof uint32 !== "undefined" && uint32) === "function" ? _j : Object)
], TrustListDataType.prototype, "SpecifiedLists", void 0);
__decorate([
    exports.TypeArray('ByteString'),
    __metadata("design:type", Object)
], TrustListDataType.prototype, "TrustedCertificates", void 0);
__decorate([
    exports.TypeArray('ByteString'),
    __metadata("design:type", Object)
], TrustListDataType.prototype, "TrustedCrls", void 0);
__decorate([
    exports.TypeArray('ByteString'),
    __metadata("design:type", Object)
], TrustListDataType.prototype, "IssuerCertificates", void 0);
__decorate([
    exports.TypeArray('ByteString'),
    __metadata("design:type", Object)
], TrustListDataType.prototype, "IssuerCrls", void 0);
exports.TrustListDataType = TrustListDataType;
class DecimalDataType {
    constructor(options) {
        var _a, _b, _c, _d;
        this.Scale = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Scale, (_b !== null && _b !== void 0 ? _b : 0));
        this.Value = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Value, (_d !== null && _d !== void 0 ? _d : new Uint8Array()));
    }
}
__decorate([
    exports.Type('int16'),
    __metadata("design:type", typeof (_k = typeof int16 !== "undefined" && int16) === "function" ? _k : Object)
], DecimalDataType.prototype, "Scale", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_l = typeof ByteString !== "undefined" && ByteString) === "function" ? _l : Object)
], DecimalDataType.prototype, "Value", void 0);
exports.DecimalDataType = DecimalDataType;
class StructureField {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.Name = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Name, (_b !== null && _b !== void 0 ? _b : ''));
        this.Description = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Description, (_d !== null && _d !== void 0 ? _d : new LocalizedText_1.default()));
        this.DataType = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DataType, (_f !== null && _f !== void 0 ? _f : new NodeId_1.default()));
        this.ValueRank = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ValueRank, (_h !== null && _h !== void 0 ? _h : 0));
        this.ArrayDimensions = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.ArrayDimensions, (_k !== null && _k !== void 0 ? _k : null));
        this.MaxStringLength = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.MaxStringLength, (_m !== null && _m !== void 0 ? _m : 0));
        this.IsOptional = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.IsOptional, (_p !== null && _p !== void 0 ? _p : false));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], StructureField.prototype, "Name", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], StructureField.prototype, "Description", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], StructureField.prototype, "DataType", void 0);
__decorate([
    exports.Type('int32'),
    __metadata("design:type", typeof (_m = typeof int32 !== "undefined" && int32) === "function" ? _m : Object)
], StructureField.prototype, "ValueRank", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], StructureField.prototype, "ArrayDimensions", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_o = typeof uint32 !== "undefined" && uint32) === "function" ? _o : Object)
], StructureField.prototype, "MaxStringLength", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], StructureField.prototype, "IsOptional", void 0);
exports.StructureField = StructureField;
class StructureDefinition {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.DefaultEncodingId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.DefaultEncodingId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.BaseDataType = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.BaseDataType, (_d !== null && _d !== void 0 ? _d : new NodeId_1.default()));
        this.StructureType = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.StructureType, (_f !== null && _f !== void 0 ? _f : exports.StructureTypeStructure));
        this.Fields = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.Fields, (_h !== null && _h !== void 0 ? _h : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], StructureDefinition.prototype, "DefaultEncodingId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], StructureDefinition.prototype, "BaseDataType", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_p = typeof StructureType !== "undefined" && StructureType) === "function" ? _p : Object)
], StructureDefinition.prototype, "StructureType", void 0);
__decorate([
    exports.TypeArray('StructureField'),
    __metadata("design:type", Object)
], StructureDefinition.prototype, "Fields", void 0);
exports.StructureDefinition = StructureDefinition;
class StructureDescription {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.DataTypeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.DataTypeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.Name = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Name, (_d !== null && _d !== void 0 ? _d : new QualifiedName_1.default()));
        this.StructureDefinition = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.StructureDefinition, (_f !== null && _f !== void 0 ? _f : new StructureDefinition()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], StructureDescription.prototype, "DataTypeId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", QualifiedName_1.default)
], StructureDescription.prototype, "Name", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", StructureDefinition)
], StructureDescription.prototype, "StructureDefinition", void 0);
exports.StructureDescription = StructureDescription;
class EnumField {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.Value = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Value, (_b !== null && _b !== void 0 ? _b : BigInt(0)));
        this.DisplayName = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.DisplayName, (_d !== null && _d !== void 0 ? _d : new LocalizedText_1.default()));
        this.Description = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.Description, (_f !== null && _f !== void 0 ? _f : new LocalizedText_1.default()));
        this.Name = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.Name, (_h !== null && _h !== void 0 ? _h : ''));
    }
}
__decorate([
    exports.Type('int64'),
    __metadata("design:type", typeof (_q = typeof int64 !== "undefined" && int64) === "function" ? _q : Object)
], EnumField.prototype, "Value", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], EnumField.prototype, "DisplayName", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], EnumField.prototype, "Description", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], EnumField.prototype, "Name", void 0);
exports.EnumField = EnumField;
class EnumDefinition {
    constructor(options) {
        var _a, _b;
        this.Fields = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Fields, (_b !== null && _b !== void 0 ? _b : null));
    }
}
__decorate([
    exports.TypeArray('EnumField'),
    __metadata("design:type", Object)
], EnumDefinition.prototype, "Fields", void 0);
exports.EnumDefinition = EnumDefinition;
class EnumDescription {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.DataTypeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.DataTypeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.Name = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Name, (_d !== null && _d !== void 0 ? _d : new QualifiedName_1.default()));
        this.EnumDefinition = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.EnumDefinition, (_f !== null && _f !== void 0 ? _f : new EnumDefinition()));
        this.BuiltInType = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.BuiltInType, (_h !== null && _h !== void 0 ? _h : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], EnumDescription.prototype, "DataTypeId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", QualifiedName_1.default)
], EnumDescription.prototype, "Name", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", EnumDefinition)
], EnumDescription.prototype, "EnumDefinition", void 0);
__decorate([
    exports.Type('uint8'),
    __metadata("design:type", typeof (_r = typeof uint8 !== "undefined" && uint8) === "function" ? _r : Object)
], EnumDescription.prototype, "BuiltInType", void 0);
exports.EnumDescription = EnumDescription;
class SimpleTypeDescription {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.DataTypeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.DataTypeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.Name = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Name, (_d !== null && _d !== void 0 ? _d : new QualifiedName_1.default()));
        this.BaseDataType = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.BaseDataType, (_f !== null && _f !== void 0 ? _f : new NodeId_1.default()));
        this.BuiltInType = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.BuiltInType, (_h !== null && _h !== void 0 ? _h : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], SimpleTypeDescription.prototype, "DataTypeId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", QualifiedName_1.default)
], SimpleTypeDescription.prototype, "Name", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], SimpleTypeDescription.prototype, "BaseDataType", void 0);
__decorate([
    exports.Type('uint8'),
    __metadata("design:type", typeof (_s = typeof uint8 !== "undefined" && uint8) === "function" ? _s : Object)
], SimpleTypeDescription.prototype, "BuiltInType", void 0);
exports.SimpleTypeDescription = SimpleTypeDescription;
class DataTypeSchemaHeader {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.Namespaces = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Namespaces, (_b !== null && _b !== void 0 ? _b : null));
        this.StructureDataTypes = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.StructureDataTypes, (_d !== null && _d !== void 0 ? _d : null));
        this.EnumDataTypes = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.EnumDataTypes, (_f !== null && _f !== void 0 ? _f : null));
        this.SimpleDataTypes = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.SimpleDataTypes, (_h !== null && _h !== void 0 ? _h : null));
    }
}
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], DataTypeSchemaHeader.prototype, "Namespaces", void 0);
__decorate([
    exports.TypeArray('StructureDescription'),
    __metadata("design:type", Object)
], DataTypeSchemaHeader.prototype, "StructureDataTypes", void 0);
__decorate([
    exports.TypeArray('EnumDescription'),
    __metadata("design:type", Object)
], DataTypeSchemaHeader.prototype, "EnumDataTypes", void 0);
__decorate([
    exports.TypeArray('SimpleTypeDescription'),
    __metadata("design:type", Object)
], DataTypeSchemaHeader.prototype, "SimpleDataTypes", void 0);
exports.DataTypeSchemaHeader = DataTypeSchemaHeader;
class DataTypeDescription {
    constructor(options) {
        var _a, _b, _c, _d;
        this.DataTypeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.DataTypeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.Name = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Name, (_d !== null && _d !== void 0 ? _d : new QualifiedName_1.default()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], DataTypeDescription.prototype, "DataTypeId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", QualifiedName_1.default)
], DataTypeDescription.prototype, "Name", void 0);
exports.DataTypeDescription = DataTypeDescription;
class UABinaryFileDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.Namespaces = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Namespaces, (_b !== null && _b !== void 0 ? _b : null));
        this.StructureDataTypes = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.StructureDataTypes, (_d !== null && _d !== void 0 ? _d : null));
        this.EnumDataTypes = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.EnumDataTypes, (_f !== null && _f !== void 0 ? _f : null));
        this.SimpleDataTypes = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.SimpleDataTypes, (_h !== null && _h !== void 0 ? _h : null));
        this.SchemaLocation = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.SchemaLocation, (_k !== null && _k !== void 0 ? _k : ''));
        this.FileHeader = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.FileHeader, (_m !== null && _m !== void 0 ? _m : null));
        this.Body = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.Body, (_p !== null && _p !== void 0 ? _p : new Variant_1.default()));
    }
}
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], UABinaryFileDataType.prototype, "Namespaces", void 0);
__decorate([
    exports.TypeArray('StructureDescription'),
    __metadata("design:type", Object)
], UABinaryFileDataType.prototype, "StructureDataTypes", void 0);
__decorate([
    exports.TypeArray('EnumDescription'),
    __metadata("design:type", Object)
], UABinaryFileDataType.prototype, "EnumDataTypes", void 0);
__decorate([
    exports.TypeArray('SimpleTypeDescription'),
    __metadata("design:type", Object)
], UABinaryFileDataType.prototype, "SimpleDataTypes", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], UABinaryFileDataType.prototype, "SchemaLocation", void 0);
__decorate([
    exports.TypeArray('KeyValuePair'),
    __metadata("design:type", Object)
], UABinaryFileDataType.prototype, "FileHeader", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", Variant_1.default)
], UABinaryFileDataType.prototype, "Body", void 0);
exports.UABinaryFileDataType = UABinaryFileDataType;
class FieldMetaData {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        this.Name = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Name, (_b !== null && _b !== void 0 ? _b : ''));
        this.Description = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Description, (_d !== null && _d !== void 0 ? _d : new LocalizedText_1.default()));
        this.FieldFlags = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.FieldFlags, (_f !== null && _f !== void 0 ? _f : exports.DataSetFieldFlagsNone));
        this.BuiltInType = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.BuiltInType, (_h !== null && _h !== void 0 ? _h : 0));
        this.DataType = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.DataType, (_k !== null && _k !== void 0 ? _k : new NodeId_1.default()));
        this.ValueRank = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.ValueRank, (_m !== null && _m !== void 0 ? _m : 0));
        this.ArrayDimensions = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.ArrayDimensions, (_p !== null && _p !== void 0 ? _p : null));
        this.MaxStringLength = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.MaxStringLength, (_r !== null && _r !== void 0 ? _r : 0));
        this.DataSetFieldId = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.DataSetFieldId, (_t !== null && _t !== void 0 ? _t : new Guid_1.default()));
        this.Properties = (_v = (_u = options) === null || _u === void 0 ? void 0 : _u.Properties, (_v !== null && _v !== void 0 ? _v : null));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], FieldMetaData.prototype, "Name", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], FieldMetaData.prototype, "Description", void 0);
__decorate([
    exports.Type('uint16'),
    __metadata("design:type", typeof (_t = typeof DataSetFieldFlags !== "undefined" && DataSetFieldFlags) === "function" ? _t : Object)
], FieldMetaData.prototype, "FieldFlags", void 0);
__decorate([
    exports.Type('uint8'),
    __metadata("design:type", typeof (_u = typeof uint8 !== "undefined" && uint8) === "function" ? _u : Object)
], FieldMetaData.prototype, "BuiltInType", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], FieldMetaData.prototype, "DataType", void 0);
__decorate([
    exports.Type('int32'),
    __metadata("design:type", typeof (_v = typeof int32 !== "undefined" && int32) === "function" ? _v : Object)
], FieldMetaData.prototype, "ValueRank", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], FieldMetaData.prototype, "ArrayDimensions", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_w = typeof uint32 !== "undefined" && uint32) === "function" ? _w : Object)
], FieldMetaData.prototype, "MaxStringLength", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", Guid_1.default)
], FieldMetaData.prototype, "DataSetFieldId", void 0);
__decorate([
    exports.TypeArray('KeyValuePair'),
    __metadata("design:type", Object)
], FieldMetaData.prototype, "Properties", void 0);
exports.FieldMetaData = FieldMetaData;
class ConfigurationVersionDataType {
    constructor(options) {
        var _a, _b, _c, _d;
        this.MajorVersion = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.MajorVersion, (_b !== null && _b !== void 0 ? _b : 0));
        this.MinorVersion = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.MinorVersion, (_d !== null && _d !== void 0 ? _d : 0));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_x = typeof uint32 !== "undefined" && uint32) === "function" ? _x : Object)
], ConfigurationVersionDataType.prototype, "MajorVersion", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_y = typeof uint32 !== "undefined" && uint32) === "function" ? _y : Object)
], ConfigurationVersionDataType.prototype, "MinorVersion", void 0);
exports.ConfigurationVersionDataType = ConfigurationVersionDataType;
class DataSetMetaDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        this.Namespaces = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Namespaces, (_b !== null && _b !== void 0 ? _b : null));
        this.StructureDataTypes = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.StructureDataTypes, (_d !== null && _d !== void 0 ? _d : null));
        this.EnumDataTypes = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.EnumDataTypes, (_f !== null && _f !== void 0 ? _f : null));
        this.SimpleDataTypes = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.SimpleDataTypes, (_h !== null && _h !== void 0 ? _h : null));
        this.Name = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.Name, (_k !== null && _k !== void 0 ? _k : ''));
        this.Description = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.Description, (_m !== null && _m !== void 0 ? _m : new LocalizedText_1.default()));
        this.Fields = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.Fields, (_p !== null && _p !== void 0 ? _p : null));
        this.DataSetClassId = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.DataSetClassId, (_r !== null && _r !== void 0 ? _r : new Guid_1.default()));
        this.ConfigurationVersion = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.ConfigurationVersion, (_t !== null && _t !== void 0 ? _t : new ConfigurationVersionDataType()));
    }
}
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], DataSetMetaDataType.prototype, "Namespaces", void 0);
__decorate([
    exports.TypeArray('StructureDescription'),
    __metadata("design:type", Object)
], DataSetMetaDataType.prototype, "StructureDataTypes", void 0);
__decorate([
    exports.TypeArray('EnumDescription'),
    __metadata("design:type", Object)
], DataSetMetaDataType.prototype, "EnumDataTypes", void 0);
__decorate([
    exports.TypeArray('SimpleTypeDescription'),
    __metadata("design:type", Object)
], DataSetMetaDataType.prototype, "SimpleDataTypes", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], DataSetMetaDataType.prototype, "Name", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], DataSetMetaDataType.prototype, "Description", void 0);
__decorate([
    exports.TypeArray('FieldMetaData'),
    __metadata("design:type", Object)
], DataSetMetaDataType.prototype, "Fields", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", Guid_1.default)
], DataSetMetaDataType.prototype, "DataSetClassId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ConfigurationVersionDataType)
], DataSetMetaDataType.prototype, "ConfigurationVersion", void 0);
exports.DataSetMetaDataType = DataSetMetaDataType;
class PublishedDataSetDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.Name = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Name, (_b !== null && _b !== void 0 ? _b : ''));
        this.DataSetFolder = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.DataSetFolder, (_d !== null && _d !== void 0 ? _d : null));
        this.DataSetMetaData = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DataSetMetaData, (_f !== null && _f !== void 0 ? _f : new DataSetMetaDataType()));
        this.ExtensionFields = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ExtensionFields, (_h !== null && _h !== void 0 ? _h : null));
        this.DataSetSource = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.DataSetSource, (_k !== null && _k !== void 0 ? _k : new ExtensionObject_1.default()));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], PublishedDataSetDataType.prototype, "Name", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], PublishedDataSetDataType.prototype, "DataSetFolder", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", DataSetMetaDataType)
], PublishedDataSetDataType.prototype, "DataSetMetaData", void 0);
__decorate([
    exports.TypeArray('KeyValuePair'),
    __metadata("design:type", Object)
], PublishedDataSetDataType.prototype, "ExtensionFields", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], PublishedDataSetDataType.prototype, "DataSetSource", void 0);
exports.PublishedDataSetDataType = PublishedDataSetDataType;
class PublishedVariableDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        this.PublishedVariable = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.PublishedVariable, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.AttributeId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.AttributeId, (_d !== null && _d !== void 0 ? _d : 0));
        this.SamplingIntervalHint = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.SamplingIntervalHint, (_f !== null && _f !== void 0 ? _f : 0));
        this.DeadbandType = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.DeadbandType, (_h !== null && _h !== void 0 ? _h : 0));
        this.DeadbandValue = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.DeadbandValue, (_k !== null && _k !== void 0 ? _k : 0));
        this.IndexRange = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.IndexRange, (_m !== null && _m !== void 0 ? _m : ''));
        this.SubstituteValue = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.SubstituteValue, (_p !== null && _p !== void 0 ? _p : new Variant_1.default()));
        this.MetaDataProperties = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.MetaDataProperties, (_r !== null && _r !== void 0 ? _r : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], PublishedVariableDataType.prototype, "PublishedVariable", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_z = typeof uint32 !== "undefined" && uint32) === "function" ? _z : Object)
], PublishedVariableDataType.prototype, "AttributeId", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_0 = typeof float64 !== "undefined" && float64) === "function" ? _0 : Object)
], PublishedVariableDataType.prototype, "SamplingIntervalHint", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_1 = typeof uint32 !== "undefined" && uint32) === "function" ? _1 : Object)
], PublishedVariableDataType.prototype, "DeadbandType", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_2 = typeof float64 !== "undefined" && float64) === "function" ? _2 : Object)
], PublishedVariableDataType.prototype, "DeadbandValue", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], PublishedVariableDataType.prototype, "IndexRange", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", Variant_1.default)
], PublishedVariableDataType.prototype, "SubstituteValue", void 0);
__decorate([
    exports.TypeArray('QualifiedName'),
    __metadata("design:type", Object)
], PublishedVariableDataType.prototype, "MetaDataProperties", void 0);
exports.PublishedVariableDataType = PublishedVariableDataType;
class DataSetWriterDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        this.Name = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Name, (_b !== null && _b !== void 0 ? _b : ''));
        this.Enabled = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Enabled, (_d !== null && _d !== void 0 ? _d : false));
        this.DataSetWriterId = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DataSetWriterId, (_f !== null && _f !== void 0 ? _f : 0));
        this.DataSetFieldContentMask = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.DataSetFieldContentMask, (_h !== null && _h !== void 0 ? _h : exports.DataSetFieldContentMaskNone));
        this.KeyFrameCount = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.KeyFrameCount, (_k !== null && _k !== void 0 ? _k : 0));
        this.DataSetName = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.DataSetName, (_m !== null && _m !== void 0 ? _m : ''));
        this.DataSetWriterProperties = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.DataSetWriterProperties, (_p !== null && _p !== void 0 ? _p : null));
        this.TransportSettings = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.TransportSettings, (_r !== null && _r !== void 0 ? _r : new ExtensionObject_1.default()));
        this.MessageSettings = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.MessageSettings, (_t !== null && _t !== void 0 ? _t : new ExtensionObject_1.default()));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], DataSetWriterDataType.prototype, "Name", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], DataSetWriterDataType.prototype, "Enabled", void 0);
__decorate([
    exports.Type('uint16'),
    __metadata("design:type", typeof (_3 = typeof uint16 !== "undefined" && uint16) === "function" ? _3 : Object)
], DataSetWriterDataType.prototype, "DataSetWriterId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_4 = typeof DataSetFieldContentMask !== "undefined" && DataSetFieldContentMask) === "function" ? _4 : Object)
], DataSetWriterDataType.prototype, "DataSetFieldContentMask", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_5 = typeof uint32 !== "undefined" && uint32) === "function" ? _5 : Object)
], DataSetWriterDataType.prototype, "KeyFrameCount", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], DataSetWriterDataType.prototype, "DataSetName", void 0);
__decorate([
    exports.TypeArray('KeyValuePair'),
    __metadata("design:type", Object)
], DataSetWriterDataType.prototype, "DataSetWriterProperties", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], DataSetWriterDataType.prototype, "TransportSettings", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], DataSetWriterDataType.prototype, "MessageSettings", void 0);
exports.DataSetWriterDataType = DataSetWriterDataType;
class ApplicationDescription {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.ApplicationUri = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ApplicationUri, (_b !== null && _b !== void 0 ? _b : ''));
        this.ProductUri = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ProductUri, (_d !== null && _d !== void 0 ? _d : ''));
        this.ApplicationName = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ApplicationName, (_f !== null && _f !== void 0 ? _f : new LocalizedText_1.default()));
        this.ApplicationType = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ApplicationType, (_h !== null && _h !== void 0 ? _h : exports.ApplicationTypeServer));
        this.GatewayServerUri = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.GatewayServerUri, (_k !== null && _k !== void 0 ? _k : ''));
        this.DiscoveryProfileUri = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.DiscoveryProfileUri, (_m !== null && _m !== void 0 ? _m : ''));
        this.DiscoveryUrls = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.DiscoveryUrls, (_p !== null && _p !== void 0 ? _p : null));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], ApplicationDescription.prototype, "ApplicationUri", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], ApplicationDescription.prototype, "ProductUri", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], ApplicationDescription.prototype, "ApplicationName", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_6 = typeof ApplicationType !== "undefined" && ApplicationType) === "function" ? _6 : Object)
], ApplicationDescription.prototype, "ApplicationType", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], ApplicationDescription.prototype, "GatewayServerUri", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], ApplicationDescription.prototype, "DiscoveryProfileUri", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], ApplicationDescription.prototype, "DiscoveryUrls", void 0);
exports.ApplicationDescription = ApplicationDescription;
class UserTokenPolicy {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.PolicyId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.PolicyId, (_b !== null && _b !== void 0 ? _b : ''));
        this.TokenType = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.TokenType, (_d !== null && _d !== void 0 ? _d : exports.UserTokenTypeAnonymous));
        this.IssuedTokenType = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.IssuedTokenType, (_f !== null && _f !== void 0 ? _f : ''));
        this.IssuerEndpointUrl = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.IssuerEndpointUrl, (_h !== null && _h !== void 0 ? _h : ''));
        this.SecurityPolicyUri = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.SecurityPolicyUri, (_k !== null && _k !== void 0 ? _k : ''));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], UserTokenPolicy.prototype, "PolicyId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_7 = typeof UserTokenType !== "undefined" && UserTokenType) === "function" ? _7 : Object)
], UserTokenPolicy.prototype, "TokenType", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], UserTokenPolicy.prototype, "IssuedTokenType", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], UserTokenPolicy.prototype, "IssuerEndpointUrl", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], UserTokenPolicy.prototype, "SecurityPolicyUri", void 0);
exports.UserTokenPolicy = UserTokenPolicy;
class EndpointDescription {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        this.EndpointUrl = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.EndpointUrl, (_b !== null && _b !== void 0 ? _b : ''));
        this.Server = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Server, (_d !== null && _d !== void 0 ? _d : new ApplicationDescription()));
        this.ServerCertificate = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ServerCertificate, (_f !== null && _f !== void 0 ? _f : new Uint8Array()));
        this.SecurityMode = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.SecurityMode, (_h !== null && _h !== void 0 ? _h : exports.MessageSecurityModeInvalid));
        this.SecurityPolicyUri = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.SecurityPolicyUri, (_k !== null && _k !== void 0 ? _k : ''));
        this.UserIdentityTokens = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.UserIdentityTokens, (_m !== null && _m !== void 0 ? _m : null));
        this.TransportProfileUri = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.TransportProfileUri, (_p !== null && _p !== void 0 ? _p : ''));
        this.SecurityLevel = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.SecurityLevel, (_r !== null && _r !== void 0 ? _r : 0));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], EndpointDescription.prototype, "EndpointUrl", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ApplicationDescription)
], EndpointDescription.prototype, "Server", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_8 = typeof ByteString !== "undefined" && ByteString) === "function" ? _8 : Object)
], EndpointDescription.prototype, "ServerCertificate", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_9 = typeof MessageSecurityMode !== "undefined" && MessageSecurityMode) === "function" ? _9 : Object)
], EndpointDescription.prototype, "SecurityMode", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], EndpointDescription.prototype, "SecurityPolicyUri", void 0);
__decorate([
    exports.TypeArray('UserTokenPolicy'),
    __metadata("design:type", Object)
], EndpointDescription.prototype, "UserIdentityTokens", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], EndpointDescription.prototype, "TransportProfileUri", void 0);
__decorate([
    exports.Type('uint8'),
    __metadata("design:type", typeof (_10 = typeof uint8 !== "undefined" && uint8) === "function" ? _10 : Object)
], EndpointDescription.prototype, "SecurityLevel", void 0);
exports.EndpointDescription = EndpointDescription;
class PubSubGroupDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.Name = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Name, (_b !== null && _b !== void 0 ? _b : ''));
        this.Enabled = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Enabled, (_d !== null && _d !== void 0 ? _d : false));
        this.SecurityMode = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.SecurityMode, (_f !== null && _f !== void 0 ? _f : exports.MessageSecurityModeInvalid));
        this.SecurityGroupId = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.SecurityGroupId, (_h !== null && _h !== void 0 ? _h : ''));
        this.SecurityKeyServices = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.SecurityKeyServices, (_k !== null && _k !== void 0 ? _k : null));
        this.MaxNetworkMessageSize = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.MaxNetworkMessageSize, (_m !== null && _m !== void 0 ? _m : 0));
        this.GroupProperties = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.GroupProperties, (_p !== null && _p !== void 0 ? _p : null));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], PubSubGroupDataType.prototype, "Name", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], PubSubGroupDataType.prototype, "Enabled", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_11 = typeof MessageSecurityMode !== "undefined" && MessageSecurityMode) === "function" ? _11 : Object)
], PubSubGroupDataType.prototype, "SecurityMode", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], PubSubGroupDataType.prototype, "SecurityGroupId", void 0);
__decorate([
    exports.TypeArray('EndpointDescription'),
    __metadata("design:type", Object)
], PubSubGroupDataType.prototype, "SecurityKeyServices", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_12 = typeof uint32 !== "undefined" && uint32) === "function" ? _12 : Object)
], PubSubGroupDataType.prototype, "MaxNetworkMessageSize", void 0);
__decorate([
    exports.TypeArray('KeyValuePair'),
    __metadata("design:type", Object)
], PubSubGroupDataType.prototype, "GroupProperties", void 0);
exports.PubSubGroupDataType = PubSubGroupDataType;
class WriterGroupDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
        this.Name = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Name, (_b !== null && _b !== void 0 ? _b : ''));
        this.Enabled = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Enabled, (_d !== null && _d !== void 0 ? _d : false));
        this.SecurityMode = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.SecurityMode, (_f !== null && _f !== void 0 ? _f : exports.MessageSecurityModeInvalid));
        this.SecurityGroupId = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.SecurityGroupId, (_h !== null && _h !== void 0 ? _h : ''));
        this.SecurityKeyServices = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.SecurityKeyServices, (_k !== null && _k !== void 0 ? _k : null));
        this.MaxNetworkMessageSize = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.MaxNetworkMessageSize, (_m !== null && _m !== void 0 ? _m : 0));
        this.GroupProperties = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.GroupProperties, (_p !== null && _p !== void 0 ? _p : null));
        this.WriterGroupId = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.WriterGroupId, (_r !== null && _r !== void 0 ? _r : 0));
        this.PublishingInterval = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.PublishingInterval, (_t !== null && _t !== void 0 ? _t : 0));
        this.KeepAliveTime = (_v = (_u = options) === null || _u === void 0 ? void 0 : _u.KeepAliveTime, (_v !== null && _v !== void 0 ? _v : 0));
        this.Priority = (_x = (_w = options) === null || _w === void 0 ? void 0 : _w.Priority, (_x !== null && _x !== void 0 ? _x : 0));
        this.LocaleIds = (_z = (_y = options) === null || _y === void 0 ? void 0 : _y.LocaleIds, (_z !== null && _z !== void 0 ? _z : null));
        this.HeaderLayoutUri = (_1 = (_0 = options) === null || _0 === void 0 ? void 0 : _0.HeaderLayoutUri, (_1 !== null && _1 !== void 0 ? _1 : ''));
        this.TransportSettings = (_3 = (_2 = options) === null || _2 === void 0 ? void 0 : _2.TransportSettings, (_3 !== null && _3 !== void 0 ? _3 : new ExtensionObject_1.default()));
        this.MessageSettings = (_5 = (_4 = options) === null || _4 === void 0 ? void 0 : _4.MessageSettings, (_5 !== null && _5 !== void 0 ? _5 : new ExtensionObject_1.default()));
        this.DataSetWriters = (_7 = (_6 = options) === null || _6 === void 0 ? void 0 : _6.DataSetWriters, (_7 !== null && _7 !== void 0 ? _7 : null));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], WriterGroupDataType.prototype, "Name", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], WriterGroupDataType.prototype, "Enabled", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_13 = typeof MessageSecurityMode !== "undefined" && MessageSecurityMode) === "function" ? _13 : Object)
], WriterGroupDataType.prototype, "SecurityMode", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], WriterGroupDataType.prototype, "SecurityGroupId", void 0);
__decorate([
    exports.TypeArray('EndpointDescription'),
    __metadata("design:type", Object)
], WriterGroupDataType.prototype, "SecurityKeyServices", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_14 = typeof uint32 !== "undefined" && uint32) === "function" ? _14 : Object)
], WriterGroupDataType.prototype, "MaxNetworkMessageSize", void 0);
__decorate([
    exports.TypeArray('KeyValuePair'),
    __metadata("design:type", Object)
], WriterGroupDataType.prototype, "GroupProperties", void 0);
__decorate([
    exports.Type('uint16'),
    __metadata("design:type", typeof (_15 = typeof uint16 !== "undefined" && uint16) === "function" ? _15 : Object)
], WriterGroupDataType.prototype, "WriterGroupId", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_16 = typeof float64 !== "undefined" && float64) === "function" ? _16 : Object)
], WriterGroupDataType.prototype, "PublishingInterval", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_17 = typeof float64 !== "undefined" && float64) === "function" ? _17 : Object)
], WriterGroupDataType.prototype, "KeepAliveTime", void 0);
__decorate([
    exports.Type('uint8'),
    __metadata("design:type", typeof (_18 = typeof uint8 !== "undefined" && uint8) === "function" ? _18 : Object)
], WriterGroupDataType.prototype, "Priority", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], WriterGroupDataType.prototype, "LocaleIds", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], WriterGroupDataType.prototype, "HeaderLayoutUri", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], WriterGroupDataType.prototype, "TransportSettings", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], WriterGroupDataType.prototype, "MessageSettings", void 0);
__decorate([
    exports.TypeArray('DataSetWriterDataType'),
    __metadata("design:type", Object)
], WriterGroupDataType.prototype, "DataSetWriters", void 0);
exports.WriterGroupDataType = WriterGroupDataType;
class DataSetReaderDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9;
        this.Name = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Name, (_b !== null && _b !== void 0 ? _b : ''));
        this.Enabled = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Enabled, (_d !== null && _d !== void 0 ? _d : false));
        this.PublisherId = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.PublisherId, (_f !== null && _f !== void 0 ? _f : new Variant_1.default()));
        this.WriterGroupId = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.WriterGroupId, (_h !== null && _h !== void 0 ? _h : 0));
        this.DataSetWriterId = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.DataSetWriterId, (_k !== null && _k !== void 0 ? _k : 0));
        this.DataSetMetaData = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.DataSetMetaData, (_m !== null && _m !== void 0 ? _m : new DataSetMetaDataType()));
        this.DataSetFieldContentMask = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.DataSetFieldContentMask, (_p !== null && _p !== void 0 ? _p : exports.DataSetFieldContentMaskNone));
        this.MessageReceiveTimeout = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.MessageReceiveTimeout, (_r !== null && _r !== void 0 ? _r : 0));
        this.KeyFrameCount = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.KeyFrameCount, (_t !== null && _t !== void 0 ? _t : 0));
        this.HeaderLayoutUri = (_v = (_u = options) === null || _u === void 0 ? void 0 : _u.HeaderLayoutUri, (_v !== null && _v !== void 0 ? _v : ''));
        this.SecurityMode = (_x = (_w = options) === null || _w === void 0 ? void 0 : _w.SecurityMode, (_x !== null && _x !== void 0 ? _x : exports.MessageSecurityModeInvalid));
        this.SecurityGroupId = (_z = (_y = options) === null || _y === void 0 ? void 0 : _y.SecurityGroupId, (_z !== null && _z !== void 0 ? _z : ''));
        this.SecurityKeyServices = (_1 = (_0 = options) === null || _0 === void 0 ? void 0 : _0.SecurityKeyServices, (_1 !== null && _1 !== void 0 ? _1 : null));
        this.DataSetReaderProperties = (_3 = (_2 = options) === null || _2 === void 0 ? void 0 : _2.DataSetReaderProperties, (_3 !== null && _3 !== void 0 ? _3 : null));
        this.TransportSettings = (_5 = (_4 = options) === null || _4 === void 0 ? void 0 : _4.TransportSettings, (_5 !== null && _5 !== void 0 ? _5 : new ExtensionObject_1.default()));
        this.MessageSettings = (_7 = (_6 = options) === null || _6 === void 0 ? void 0 : _6.MessageSettings, (_7 !== null && _7 !== void 0 ? _7 : new ExtensionObject_1.default()));
        this.SubscribedDataSet = (_9 = (_8 = options) === null || _8 === void 0 ? void 0 : _8.SubscribedDataSet, (_9 !== null && _9 !== void 0 ? _9 : new ExtensionObject_1.default()));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], DataSetReaderDataType.prototype, "Name", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], DataSetReaderDataType.prototype, "Enabled", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", Variant_1.default)
], DataSetReaderDataType.prototype, "PublisherId", void 0);
__decorate([
    exports.Type('uint16'),
    __metadata("design:type", typeof (_19 = typeof uint16 !== "undefined" && uint16) === "function" ? _19 : Object)
], DataSetReaderDataType.prototype, "WriterGroupId", void 0);
__decorate([
    exports.Type('uint16'),
    __metadata("design:type", typeof (_20 = typeof uint16 !== "undefined" && uint16) === "function" ? _20 : Object)
], DataSetReaderDataType.prototype, "DataSetWriterId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", DataSetMetaDataType)
], DataSetReaderDataType.prototype, "DataSetMetaData", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_21 = typeof DataSetFieldContentMask !== "undefined" && DataSetFieldContentMask) === "function" ? _21 : Object)
], DataSetReaderDataType.prototype, "DataSetFieldContentMask", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_22 = typeof float64 !== "undefined" && float64) === "function" ? _22 : Object)
], DataSetReaderDataType.prototype, "MessageReceiveTimeout", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_23 = typeof uint32 !== "undefined" && uint32) === "function" ? _23 : Object)
], DataSetReaderDataType.prototype, "KeyFrameCount", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], DataSetReaderDataType.prototype, "HeaderLayoutUri", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_24 = typeof MessageSecurityMode !== "undefined" && MessageSecurityMode) === "function" ? _24 : Object)
], DataSetReaderDataType.prototype, "SecurityMode", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], DataSetReaderDataType.prototype, "SecurityGroupId", void 0);
__decorate([
    exports.TypeArray('EndpointDescription'),
    __metadata("design:type", Object)
], DataSetReaderDataType.prototype, "SecurityKeyServices", void 0);
__decorate([
    exports.TypeArray('KeyValuePair'),
    __metadata("design:type", Object)
], DataSetReaderDataType.prototype, "DataSetReaderProperties", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], DataSetReaderDataType.prototype, "TransportSettings", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], DataSetReaderDataType.prototype, "MessageSettings", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], DataSetReaderDataType.prototype, "SubscribedDataSet", void 0);
exports.DataSetReaderDataType = DataSetReaderDataType;
class ReaderGroupDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        this.Name = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Name, (_b !== null && _b !== void 0 ? _b : ''));
        this.Enabled = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Enabled, (_d !== null && _d !== void 0 ? _d : false));
        this.SecurityMode = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.SecurityMode, (_f !== null && _f !== void 0 ? _f : exports.MessageSecurityModeInvalid));
        this.SecurityGroupId = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.SecurityGroupId, (_h !== null && _h !== void 0 ? _h : ''));
        this.SecurityKeyServices = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.SecurityKeyServices, (_k !== null && _k !== void 0 ? _k : null));
        this.MaxNetworkMessageSize = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.MaxNetworkMessageSize, (_m !== null && _m !== void 0 ? _m : 0));
        this.GroupProperties = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.GroupProperties, (_p !== null && _p !== void 0 ? _p : null));
        this.TransportSettings = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.TransportSettings, (_r !== null && _r !== void 0 ? _r : new ExtensionObject_1.default()));
        this.MessageSettings = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.MessageSettings, (_t !== null && _t !== void 0 ? _t : new ExtensionObject_1.default()));
        this.DataSetReaders = (_v = (_u = options) === null || _u === void 0 ? void 0 : _u.DataSetReaders, (_v !== null && _v !== void 0 ? _v : null));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], ReaderGroupDataType.prototype, "Name", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], ReaderGroupDataType.prototype, "Enabled", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_25 = typeof MessageSecurityMode !== "undefined" && MessageSecurityMode) === "function" ? _25 : Object)
], ReaderGroupDataType.prototype, "SecurityMode", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], ReaderGroupDataType.prototype, "SecurityGroupId", void 0);
__decorate([
    exports.TypeArray('EndpointDescription'),
    __metadata("design:type", Object)
], ReaderGroupDataType.prototype, "SecurityKeyServices", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_26 = typeof uint32 !== "undefined" && uint32) === "function" ? _26 : Object)
], ReaderGroupDataType.prototype, "MaxNetworkMessageSize", void 0);
__decorate([
    exports.TypeArray('KeyValuePair'),
    __metadata("design:type", Object)
], ReaderGroupDataType.prototype, "GroupProperties", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], ReaderGroupDataType.prototype, "TransportSettings", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], ReaderGroupDataType.prototype, "MessageSettings", void 0);
__decorate([
    exports.TypeArray('DataSetReaderDataType'),
    __metadata("design:type", Object)
], ReaderGroupDataType.prototype, "DataSetReaders", void 0);
exports.ReaderGroupDataType = ReaderGroupDataType;
class PubSubConnectionDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        this.Name = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Name, (_b !== null && _b !== void 0 ? _b : ''));
        this.Enabled = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Enabled, (_d !== null && _d !== void 0 ? _d : false));
        this.PublisherId = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.PublisherId, (_f !== null && _f !== void 0 ? _f : new Variant_1.default()));
        this.TransportProfileUri = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.TransportProfileUri, (_h !== null && _h !== void 0 ? _h : ''));
        this.Address = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.Address, (_k !== null && _k !== void 0 ? _k : new ExtensionObject_1.default()));
        this.ConnectionProperties = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.ConnectionProperties, (_m !== null && _m !== void 0 ? _m : null));
        this.TransportSettings = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.TransportSettings, (_p !== null && _p !== void 0 ? _p : new ExtensionObject_1.default()));
        this.WriterGroups = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.WriterGroups, (_r !== null && _r !== void 0 ? _r : null));
        this.ReaderGroups = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.ReaderGroups, (_t !== null && _t !== void 0 ? _t : null));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], PubSubConnectionDataType.prototype, "Name", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], PubSubConnectionDataType.prototype, "Enabled", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", Variant_1.default)
], PubSubConnectionDataType.prototype, "PublisherId", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], PubSubConnectionDataType.prototype, "TransportProfileUri", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], PubSubConnectionDataType.prototype, "Address", void 0);
__decorate([
    exports.TypeArray('KeyValuePair'),
    __metadata("design:type", Object)
], PubSubConnectionDataType.prototype, "ConnectionProperties", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], PubSubConnectionDataType.prototype, "TransportSettings", void 0);
__decorate([
    exports.TypeArray('WriterGroupDataType'),
    __metadata("design:type", Object)
], PubSubConnectionDataType.prototype, "WriterGroups", void 0);
__decorate([
    exports.TypeArray('ReaderGroupDataType'),
    __metadata("design:type", Object)
], PubSubConnectionDataType.prototype, "ReaderGroups", void 0);
exports.PubSubConnectionDataType = PubSubConnectionDataType;
class NetworkAddressDataType {
    constructor(options) {
        var _a, _b;
        this.NetworkInterface = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.NetworkInterface, (_b !== null && _b !== void 0 ? _b : ''));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], NetworkAddressDataType.prototype, "NetworkInterface", void 0);
exports.NetworkAddressDataType = NetworkAddressDataType;
class FieldTargetDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.DataSetFieldId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.DataSetFieldId, (_b !== null && _b !== void 0 ? _b : new Guid_1.default()));
        this.ReceiverIndexRange = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ReceiverIndexRange, (_d !== null && _d !== void 0 ? _d : ''));
        this.TargetNodeId = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.TargetNodeId, (_f !== null && _f !== void 0 ? _f : new NodeId_1.default()));
        this.AttributeId = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.AttributeId, (_h !== null && _h !== void 0 ? _h : 0));
        this.WriteIndexRange = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.WriteIndexRange, (_k !== null && _k !== void 0 ? _k : ''));
        this.OverrideValueHandling = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.OverrideValueHandling, (_m !== null && _m !== void 0 ? _m : exports.OverrideValueHandlingDisabled));
        this.OverrideValue = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.OverrideValue, (_p !== null && _p !== void 0 ? _p : new Variant_1.default()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", Guid_1.default)
], FieldTargetDataType.prototype, "DataSetFieldId", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], FieldTargetDataType.prototype, "ReceiverIndexRange", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], FieldTargetDataType.prototype, "TargetNodeId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_27 = typeof uint32 !== "undefined" && uint32) === "function" ? _27 : Object)
], FieldTargetDataType.prototype, "AttributeId", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], FieldTargetDataType.prototype, "WriteIndexRange", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_28 = typeof OverrideValueHandling !== "undefined" && OverrideValueHandling) === "function" ? _28 : Object)
], FieldTargetDataType.prototype, "OverrideValueHandling", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", Variant_1.default)
], FieldTargetDataType.prototype, "OverrideValue", void 0);
exports.FieldTargetDataType = FieldTargetDataType;
class PubSubConfigurationDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.PublishedDataSets = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.PublishedDataSets, (_b !== null && _b !== void 0 ? _b : null));
        this.Connections = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Connections, (_d !== null && _d !== void 0 ? _d : null));
        this.Enabled = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.Enabled, (_f !== null && _f !== void 0 ? _f : false));
    }
}
__decorate([
    exports.TypeArray('PublishedDataSetDataType'),
    __metadata("design:type", Object)
], PubSubConfigurationDataType.prototype, "PublishedDataSets", void 0);
__decorate([
    exports.TypeArray('PubSubConnectionDataType'),
    __metadata("design:type", Object)
], PubSubConfigurationDataType.prototype, "Connections", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], PubSubConfigurationDataType.prototype, "Enabled", void 0);
exports.PubSubConfigurationDataType = PubSubConfigurationDataType;
class AliasNameDataType {
    constructor(options) {
        var _a, _b, _c, _d;
        this.AliasName = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.AliasName, (_b !== null && _b !== void 0 ? _b : new QualifiedName_1.default()));
        this.ReferencedNodes = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ReferencedNodes, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", QualifiedName_1.default)
], AliasNameDataType.prototype, "AliasName", void 0);
__decorate([
    exports.TypeArray('ExpandedNodeId'),
    __metadata("design:type", Object)
], AliasNameDataType.prototype, "ReferencedNodes", void 0);
exports.AliasNameDataType = AliasNameDataType;
class RolePermissionType {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RoleId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RoleId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.Permissions = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Permissions, (_d !== null && _d !== void 0 ? _d : exports.PermissionTypeNone));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], RolePermissionType.prototype, "RoleId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_29 = typeof PermissionType !== "undefined" && PermissionType) === "function" ? _29 : Object)
], RolePermissionType.prototype, "Permissions", void 0);
exports.RolePermissionType = RolePermissionType;
class ReferenceNode {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ReferenceTypeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ReferenceTypeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.IsInverse = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.IsInverse, (_d !== null && _d !== void 0 ? _d : false));
        this.TargetId = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.TargetId, (_f !== null && _f !== void 0 ? _f : new ExpandedNodeId_1.default()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], ReferenceNode.prototype, "ReferenceTypeId", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], ReferenceNode.prototype, "IsInverse", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExpandedNodeId_1.default)
], ReferenceNode.prototype, "TargetId", void 0);
exports.ReferenceNode = ReferenceNode;
class Node {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        this.NodeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.NodeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.NodeClass = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.NodeClass, (_d !== null && _d !== void 0 ? _d : exports.NodeClassUnspecified));
        this.BrowseName = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.BrowseName, (_f !== null && _f !== void 0 ? _f : new QualifiedName_1.default()));
        this.DisplayName = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.DisplayName, (_h !== null && _h !== void 0 ? _h : new LocalizedText_1.default()));
        this.Description = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.Description, (_k !== null && _k !== void 0 ? _k : new LocalizedText_1.default()));
        this.WriteMask = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.WriteMask, (_m !== null && _m !== void 0 ? _m : 0));
        this.UserWriteMask = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.UserWriteMask, (_p !== null && _p !== void 0 ? _p : 0));
        this.RolePermissions = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.RolePermissions, (_r !== null && _r !== void 0 ? _r : null));
        this.UserRolePermissions = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.UserRolePermissions, (_t !== null && _t !== void 0 ? _t : null));
        this.AccessRestrictions = (_v = (_u = options) === null || _u === void 0 ? void 0 : _u.AccessRestrictions, (_v !== null && _v !== void 0 ? _v : 0));
        this.References = (_x = (_w = options) === null || _w === void 0 ? void 0 : _w.References, (_x !== null && _x !== void 0 ? _x : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], Node.prototype, "NodeId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_30 = typeof NodeClass !== "undefined" && NodeClass) === "function" ? _30 : Object)
], Node.prototype, "NodeClass", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", QualifiedName_1.default)
], Node.prototype, "BrowseName", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], Node.prototype, "DisplayName", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], Node.prototype, "Description", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_31 = typeof uint32 !== "undefined" && uint32) === "function" ? _31 : Object)
], Node.prototype, "WriteMask", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_32 = typeof uint32 !== "undefined" && uint32) === "function" ? _32 : Object)
], Node.prototype, "UserWriteMask", void 0);
__decorate([
    exports.TypeArray('RolePermissionType'),
    __metadata("design:type", Object)
], Node.prototype, "RolePermissions", void 0);
__decorate([
    exports.TypeArray('RolePermissionType'),
    __metadata("design:type", Object)
], Node.prototype, "UserRolePermissions", void 0);
__decorate([
    exports.Type('uint16'),
    __metadata("design:type", typeof (_33 = typeof uint16 !== "undefined" && uint16) === "function" ? _33 : Object)
], Node.prototype, "AccessRestrictions", void 0);
__decorate([
    exports.TypeArray('ReferenceNode'),
    __metadata("design:type", Object)
], Node.prototype, "References", void 0);
exports.Node = Node;
class Argument {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.Name = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Name, (_b !== null && _b !== void 0 ? _b : ''));
        this.DataType = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.DataType, (_d !== null && _d !== void 0 ? _d : new NodeId_1.default()));
        this.ValueRank = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ValueRank, (_f !== null && _f !== void 0 ? _f : 0));
        this.ArrayDimensions = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ArrayDimensions, (_h !== null && _h !== void 0 ? _h : null));
        this.Description = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.Description, (_k !== null && _k !== void 0 ? _k : new LocalizedText_1.default()));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], Argument.prototype, "Name", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], Argument.prototype, "DataType", void 0);
__decorate([
    exports.Type('int32'),
    __metadata("design:type", typeof (_34 = typeof int32 !== "undefined" && int32) === "function" ? _34 : Object)
], Argument.prototype, "ValueRank", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], Argument.prototype, "ArrayDimensions", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], Argument.prototype, "Description", void 0);
exports.Argument = Argument;
class EnumValueType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.Value = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Value, (_b !== null && _b !== void 0 ? _b : BigInt(0)));
        this.DisplayName = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.DisplayName, (_d !== null && _d !== void 0 ? _d : new LocalizedText_1.default()));
        this.Description = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.Description, (_f !== null && _f !== void 0 ? _f : new LocalizedText_1.default()));
    }
}
__decorate([
    exports.Type('int64'),
    __metadata("design:type", typeof (_35 = typeof int64 !== "undefined" && int64) === "function" ? _35 : Object)
], EnumValueType.prototype, "Value", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], EnumValueType.prototype, "DisplayName", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], EnumValueType.prototype, "Description", void 0);
exports.EnumValueType = EnumValueType;
class OptionSet {
    constructor(options) {
        var _a, _b, _c, _d;
        this.Value = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Value, (_b !== null && _b !== void 0 ? _b : new Uint8Array()));
        this.ValidBits = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ValidBits, (_d !== null && _d !== void 0 ? _d : new Uint8Array()));
    }
}
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_36 = typeof ByteString !== "undefined" && ByteString) === "function" ? _36 : Object)
], OptionSet.prototype, "Value", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_37 = typeof ByteString !== "undefined" && ByteString) === "function" ? _37 : Object)
], OptionSet.prototype, "ValidBits", void 0);
exports.OptionSet = OptionSet;
class TimeZoneDataType {
    constructor(options) {
        var _a, _b, _c, _d;
        this.Offset = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Offset, (_b !== null && _b !== void 0 ? _b : 0));
        this.DaylightSavingInOffset = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.DaylightSavingInOffset, (_d !== null && _d !== void 0 ? _d : false));
    }
}
__decorate([
    exports.Type('int16'),
    __metadata("design:type", typeof (_38 = typeof int16 !== "undefined" && int16) === "function" ? _38 : Object)
], TimeZoneDataType.prototype, "Offset", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], TimeZoneDataType.prototype, "DaylightSavingInOffset", void 0);
exports.TimeZoneDataType = TimeZoneDataType;
class RequestHeader {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.AuthenticationToken = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.AuthenticationToken, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.Timestamp = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Timestamp, (_d !== null && _d !== void 0 ? _d : new Date()));
        this.RequestHandle = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.RequestHandle, (_f !== null && _f !== void 0 ? _f : 0));
        this.ReturnDiagnostics = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ReturnDiagnostics, (_h !== null && _h !== void 0 ? _h : 0));
        this.AuditEntryId = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.AuditEntryId, (_k !== null && _k !== void 0 ? _k : ''));
        this.TimeoutHint = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.TimeoutHint, (_m !== null && _m !== void 0 ? _m : 0));
        this.AdditionalHeader = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.AdditionalHeader, (_p !== null && _p !== void 0 ? _p : new ExtensionObject_1.default()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], RequestHeader.prototype, "AuthenticationToken", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], RequestHeader.prototype, "Timestamp", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_39 = typeof uint32 !== "undefined" && uint32) === "function" ? _39 : Object)
], RequestHeader.prototype, "RequestHandle", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_40 = typeof uint32 !== "undefined" && uint32) === "function" ? _40 : Object)
], RequestHeader.prototype, "ReturnDiagnostics", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], RequestHeader.prototype, "AuditEntryId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_41 = typeof uint32 !== "undefined" && uint32) === "function" ? _41 : Object)
], RequestHeader.prototype, "TimeoutHint", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], RequestHeader.prototype, "AdditionalHeader", void 0);
exports.RequestHeader = RequestHeader;
class ResponseHeader {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.Timestamp = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Timestamp, (_b !== null && _b !== void 0 ? _b : new Date()));
        this.RequestHandle = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.RequestHandle, (_d !== null && _d !== void 0 ? _d : 0));
        this.ServiceResult = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ServiceResult, (_f !== null && _f !== void 0 ? _f : StatusCode_1.StatusCodeOK));
        this.ServiceDiagnostics = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ServiceDiagnostics, (_h !== null && _h !== void 0 ? _h : new DiagnosticInfo_1.default()));
        this.StringTable = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.StringTable, (_k !== null && _k !== void 0 ? _k : null));
        this.AdditionalHeader = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.AdditionalHeader, (_m !== null && _m !== void 0 ? _m : new ExtensionObject_1.default()));
    }
}
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], ResponseHeader.prototype, "Timestamp", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_42 = typeof uint32 !== "undefined" && uint32) === "function" ? _42 : Object)
], ResponseHeader.prototype, "RequestHandle", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_43 = typeof StatusCode !== "undefined" && StatusCode) === "function" ? _43 : Object)
], ResponseHeader.prototype, "ServiceResult", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", DiagnosticInfo_1.default)
], ResponseHeader.prototype, "ServiceDiagnostics", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], ResponseHeader.prototype, "StringTable", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], ResponseHeader.prototype, "AdditionalHeader", void 0);
exports.ResponseHeader = ResponseHeader;
class ServiceFault {
    constructor(options) {
        var _a, _b;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], ServiceFault.prototype, "ResponseHeader", void 0);
exports.ServiceFault = ServiceFault;
class SessionlessInvokeRequestType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.UrisVersion = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.UrisVersion, (_b !== null && _b !== void 0 ? _b : null));
        this.NamespaceUris = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.NamespaceUris, (_d !== null && _d !== void 0 ? _d : null));
        this.ServerUris = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ServerUris, (_f !== null && _f !== void 0 ? _f : null));
        this.LocaleIds = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.LocaleIds, (_h !== null && _h !== void 0 ? _h : null));
        this.ServiceId = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.ServiceId, (_k !== null && _k !== void 0 ? _k : 0));
    }
}
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], SessionlessInvokeRequestType.prototype, "UrisVersion", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], SessionlessInvokeRequestType.prototype, "NamespaceUris", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], SessionlessInvokeRequestType.prototype, "ServerUris", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], SessionlessInvokeRequestType.prototype, "LocaleIds", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_44 = typeof uint32 !== "undefined" && uint32) === "function" ? _44 : Object)
], SessionlessInvokeRequestType.prototype, "ServiceId", void 0);
exports.SessionlessInvokeRequestType = SessionlessInvokeRequestType;
class SessionlessInvokeResponseType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.NamespaceUris = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.NamespaceUris, (_b !== null && _b !== void 0 ? _b : null));
        this.ServerUris = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ServerUris, (_d !== null && _d !== void 0 ? _d : null));
        this.ServiceId = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ServiceId, (_f !== null && _f !== void 0 ? _f : 0));
    }
}
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], SessionlessInvokeResponseType.prototype, "NamespaceUris", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], SessionlessInvokeResponseType.prototype, "ServerUris", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_45 = typeof uint32 !== "undefined" && uint32) === "function" ? _45 : Object)
], SessionlessInvokeResponseType.prototype, "ServiceId", void 0);
exports.SessionlessInvokeResponseType = SessionlessInvokeResponseType;
class FindServersRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.EndpointUrl = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.EndpointUrl, (_d !== null && _d !== void 0 ? _d : ''));
        this.LocaleIds = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.LocaleIds, (_f !== null && _f !== void 0 ? _f : null));
        this.ServerUris = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ServerUris, (_h !== null && _h !== void 0 ? _h : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], FindServersRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], FindServersRequest.prototype, "EndpointUrl", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], FindServersRequest.prototype, "LocaleIds", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], FindServersRequest.prototype, "ServerUris", void 0);
exports.FindServersRequest = FindServersRequest;
class FindServersResponse {
    constructor(options) {
        var _a, _b, _c, _d;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Servers = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Servers, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], FindServersResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('ApplicationDescription'),
    __metadata("design:type", Object)
], FindServersResponse.prototype, "Servers", void 0);
exports.FindServersResponse = FindServersResponse;
class ServerOnNetwork {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.RecordId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RecordId, (_b !== null && _b !== void 0 ? _b : 0));
        this.ServerName = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ServerName, (_d !== null && _d !== void 0 ? _d : ''));
        this.DiscoveryUrl = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiscoveryUrl, (_f !== null && _f !== void 0 ? _f : ''));
        this.ServerCapabilities = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ServerCapabilities, (_h !== null && _h !== void 0 ? _h : null));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_46 = typeof uint32 !== "undefined" && uint32) === "function" ? _46 : Object)
], ServerOnNetwork.prototype, "RecordId", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], ServerOnNetwork.prototype, "ServerName", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], ServerOnNetwork.prototype, "DiscoveryUrl", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], ServerOnNetwork.prototype, "ServerCapabilities", void 0);
exports.ServerOnNetwork = ServerOnNetwork;
class FindServersOnNetworkRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.StartingRecordId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.StartingRecordId, (_d !== null && _d !== void 0 ? _d : 0));
        this.MaxRecordsToReturn = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.MaxRecordsToReturn, (_f !== null && _f !== void 0 ? _f : 0));
        this.ServerCapabilityFilter = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ServerCapabilityFilter, (_h !== null && _h !== void 0 ? _h : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], FindServersOnNetworkRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_47 = typeof uint32 !== "undefined" && uint32) === "function" ? _47 : Object)
], FindServersOnNetworkRequest.prototype, "StartingRecordId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_48 = typeof uint32 !== "undefined" && uint32) === "function" ? _48 : Object)
], FindServersOnNetworkRequest.prototype, "MaxRecordsToReturn", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], FindServersOnNetworkRequest.prototype, "ServerCapabilityFilter", void 0);
exports.FindServersOnNetworkRequest = FindServersOnNetworkRequest;
class FindServersOnNetworkResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.LastCounterResetTime = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.LastCounterResetTime, (_d !== null && _d !== void 0 ? _d : new Date()));
        this.Servers = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.Servers, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], FindServersOnNetworkResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], FindServersOnNetworkResponse.prototype, "LastCounterResetTime", void 0);
__decorate([
    exports.TypeArray('ServerOnNetwork'),
    __metadata("design:type", Object)
], FindServersOnNetworkResponse.prototype, "Servers", void 0);
exports.FindServersOnNetworkResponse = FindServersOnNetworkResponse;
class GetEndpointsRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.EndpointUrl = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.EndpointUrl, (_d !== null && _d !== void 0 ? _d : ''));
        this.LocaleIds = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.LocaleIds, (_f !== null && _f !== void 0 ? _f : null));
        this.ProfileUris = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ProfileUris, (_h !== null && _h !== void 0 ? _h : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], GetEndpointsRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], GetEndpointsRequest.prototype, "EndpointUrl", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], GetEndpointsRequest.prototype, "LocaleIds", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], GetEndpointsRequest.prototype, "ProfileUris", void 0);
exports.GetEndpointsRequest = GetEndpointsRequest;
class GetEndpointsResponse {
    constructor(options) {
        var _a, _b, _c, _d;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Endpoints = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Endpoints, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], GetEndpointsResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('EndpointDescription'),
    __metadata("design:type", Object)
], GetEndpointsResponse.prototype, "Endpoints", void 0);
exports.GetEndpointsResponse = GetEndpointsResponse;
class RegisteredServer {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        this.ServerUri = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ServerUri, (_b !== null && _b !== void 0 ? _b : ''));
        this.ProductUri = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ProductUri, (_d !== null && _d !== void 0 ? _d : ''));
        this.ServerNames = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ServerNames, (_f !== null && _f !== void 0 ? _f : null));
        this.ServerType = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ServerType, (_h !== null && _h !== void 0 ? _h : exports.ApplicationTypeServer));
        this.GatewayServerUri = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.GatewayServerUri, (_k !== null && _k !== void 0 ? _k : ''));
        this.DiscoveryUrls = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.DiscoveryUrls, (_m !== null && _m !== void 0 ? _m : null));
        this.SemaphoreFilePath = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.SemaphoreFilePath, (_p !== null && _p !== void 0 ? _p : ''));
        this.IsOnline = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.IsOnline, (_r !== null && _r !== void 0 ? _r : false));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], RegisteredServer.prototype, "ServerUri", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], RegisteredServer.prototype, "ProductUri", void 0);
__decorate([
    exports.TypeArray('LocalizedText'),
    __metadata("design:type", Object)
], RegisteredServer.prototype, "ServerNames", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_49 = typeof ApplicationType !== "undefined" && ApplicationType) === "function" ? _49 : Object)
], RegisteredServer.prototype, "ServerType", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], RegisteredServer.prototype, "GatewayServerUri", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], RegisteredServer.prototype, "DiscoveryUrls", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], RegisteredServer.prototype, "SemaphoreFilePath", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], RegisteredServer.prototype, "IsOnline", void 0);
exports.RegisteredServer = RegisteredServer;
class RegisterServerRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.Server = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Server, (_d !== null && _d !== void 0 ? _d : new RegisteredServer()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], RegisterServerRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", RegisteredServer)
], RegisterServerRequest.prototype, "Server", void 0);
exports.RegisterServerRequest = RegisterServerRequest;
class RegisterServerResponse {
    constructor(options) {
        var _a, _b;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], RegisterServerResponse.prototype, "ResponseHeader", void 0);
exports.RegisterServerResponse = RegisterServerResponse;
class RegisterServer2Request {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.Server = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Server, (_d !== null && _d !== void 0 ? _d : new RegisteredServer()));
        this.DiscoveryConfiguration = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiscoveryConfiguration, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], RegisterServer2Request.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", RegisteredServer)
], RegisterServer2Request.prototype, "Server", void 0);
__decorate([
    exports.TypeArray('ExtensionObject'),
    __metadata("design:type", Object)
], RegisterServer2Request.prototype, "DiscoveryConfiguration", void 0);
exports.RegisterServer2Request = RegisterServer2Request;
class RegisterServer2Response {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.ConfigurationResults = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ConfigurationResults, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], RegisterServer2Response.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], RegisterServer2Response.prototype, "ConfigurationResults", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], RegisterServer2Response.prototype, "DiagnosticInfos", void 0);
exports.RegisterServer2Response = RegisterServer2Response;
class ChannelSecurityToken {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.ChannelId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ChannelId, (_b !== null && _b !== void 0 ? _b : 0));
        this.TokenId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.TokenId, (_d !== null && _d !== void 0 ? _d : 0));
        this.CreatedAt = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.CreatedAt, (_f !== null && _f !== void 0 ? _f : new Date()));
        this.RevisedLifetime = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.RevisedLifetime, (_h !== null && _h !== void 0 ? _h : 0));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_50 = typeof uint32 !== "undefined" && uint32) === "function" ? _50 : Object)
], ChannelSecurityToken.prototype, "ChannelId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_51 = typeof uint32 !== "undefined" && uint32) === "function" ? _51 : Object)
], ChannelSecurityToken.prototype, "TokenId", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], ChannelSecurityToken.prototype, "CreatedAt", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_52 = typeof uint32 !== "undefined" && uint32) === "function" ? _52 : Object)
], ChannelSecurityToken.prototype, "RevisedLifetime", void 0);
exports.ChannelSecurityToken = ChannelSecurityToken;
class OpenSecureChannelRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.ClientProtocolVersion = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ClientProtocolVersion, (_d !== null && _d !== void 0 ? _d : 0));
        this.RequestType = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.RequestType, (_f !== null && _f !== void 0 ? _f : exports.SecurityTokenRequestTypeIssue));
        this.SecurityMode = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.SecurityMode, (_h !== null && _h !== void 0 ? _h : exports.MessageSecurityModeInvalid));
        this.ClientNonce = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.ClientNonce, (_k !== null && _k !== void 0 ? _k : new Uint8Array()));
        this.RequestedLifetime = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.RequestedLifetime, (_m !== null && _m !== void 0 ? _m : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], OpenSecureChannelRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_53 = typeof uint32 !== "undefined" && uint32) === "function" ? _53 : Object)
], OpenSecureChannelRequest.prototype, "ClientProtocolVersion", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_54 = typeof SecurityTokenRequestType !== "undefined" && SecurityTokenRequestType) === "function" ? _54 : Object)
], OpenSecureChannelRequest.prototype, "RequestType", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_55 = typeof MessageSecurityMode !== "undefined" && MessageSecurityMode) === "function" ? _55 : Object)
], OpenSecureChannelRequest.prototype, "SecurityMode", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_56 = typeof ByteString !== "undefined" && ByteString) === "function" ? _56 : Object)
], OpenSecureChannelRequest.prototype, "ClientNonce", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_57 = typeof uint32 !== "undefined" && uint32) === "function" ? _57 : Object)
], OpenSecureChannelRequest.prototype, "RequestedLifetime", void 0);
exports.OpenSecureChannelRequest = OpenSecureChannelRequest;
class OpenSecureChannelResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.ServerProtocolVersion = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ServerProtocolVersion, (_d !== null && _d !== void 0 ? _d : 0));
        this.SecurityToken = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.SecurityToken, (_f !== null && _f !== void 0 ? _f : new ChannelSecurityToken()));
        this.ServerNonce = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ServerNonce, (_h !== null && _h !== void 0 ? _h : new Uint8Array()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], OpenSecureChannelResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_58 = typeof uint32 !== "undefined" && uint32) === "function" ? _58 : Object)
], OpenSecureChannelResponse.prototype, "ServerProtocolVersion", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ChannelSecurityToken)
], OpenSecureChannelResponse.prototype, "SecurityToken", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_59 = typeof ByteString !== "undefined" && ByteString) === "function" ? _59 : Object)
], OpenSecureChannelResponse.prototype, "ServerNonce", void 0);
exports.OpenSecureChannelResponse = OpenSecureChannelResponse;
class CloseSecureChannelRequest {
    constructor(options) {
        var _a, _b;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], CloseSecureChannelRequest.prototype, "RequestHeader", void 0);
exports.CloseSecureChannelRequest = CloseSecureChannelRequest;
class CloseSecureChannelResponse {
    constructor(options) {
        var _a, _b;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], CloseSecureChannelResponse.prototype, "ResponseHeader", void 0);
exports.CloseSecureChannelResponse = CloseSecureChannelResponse;
class SignedSoftwareCertificate {
    constructor(options) {
        var _a, _b, _c, _d;
        this.CertificateData = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.CertificateData, (_b !== null && _b !== void 0 ? _b : new Uint8Array()));
        this.Signature = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Signature, (_d !== null && _d !== void 0 ? _d : new Uint8Array()));
    }
}
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_60 = typeof ByteString !== "undefined" && ByteString) === "function" ? _60 : Object)
], SignedSoftwareCertificate.prototype, "CertificateData", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_61 = typeof ByteString !== "undefined" && ByteString) === "function" ? _61 : Object)
], SignedSoftwareCertificate.prototype, "Signature", void 0);
exports.SignedSoftwareCertificate = SignedSoftwareCertificate;
class SignatureData {
    constructor(options) {
        var _a, _b, _c, _d;
        this.Algorithm = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Algorithm, (_b !== null && _b !== void 0 ? _b : ''));
        this.Signature = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Signature, (_d !== null && _d !== void 0 ? _d : new Uint8Array()));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], SignatureData.prototype, "Algorithm", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_62 = typeof ByteString !== "undefined" && ByteString) === "function" ? _62 : Object)
], SignatureData.prototype, "Signature", void 0);
exports.SignatureData = SignatureData;
class CreateSessionRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.ClientDescription = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ClientDescription, (_d !== null && _d !== void 0 ? _d : new ApplicationDescription()));
        this.ServerUri = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ServerUri, (_f !== null && _f !== void 0 ? _f : ''));
        this.EndpointUrl = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.EndpointUrl, (_h !== null && _h !== void 0 ? _h : ''));
        this.SessionName = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.SessionName, (_k !== null && _k !== void 0 ? _k : ''));
        this.ClientNonce = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.ClientNonce, (_m !== null && _m !== void 0 ? _m : new Uint8Array()));
        this.ClientCertificate = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.ClientCertificate, (_p !== null && _p !== void 0 ? _p : new Uint8Array()));
        this.RequestedSessionTimeout = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.RequestedSessionTimeout, (_r !== null && _r !== void 0 ? _r : 0));
        this.MaxResponseMessageSize = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.MaxResponseMessageSize, (_t !== null && _t !== void 0 ? _t : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], CreateSessionRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ApplicationDescription)
], CreateSessionRequest.prototype, "ClientDescription", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], CreateSessionRequest.prototype, "ServerUri", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], CreateSessionRequest.prototype, "EndpointUrl", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], CreateSessionRequest.prototype, "SessionName", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_63 = typeof ByteString !== "undefined" && ByteString) === "function" ? _63 : Object)
], CreateSessionRequest.prototype, "ClientNonce", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_64 = typeof ByteString !== "undefined" && ByteString) === "function" ? _64 : Object)
], CreateSessionRequest.prototype, "ClientCertificate", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_65 = typeof float64 !== "undefined" && float64) === "function" ? _65 : Object)
], CreateSessionRequest.prototype, "RequestedSessionTimeout", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_66 = typeof uint32 !== "undefined" && uint32) === "function" ? _66 : Object)
], CreateSessionRequest.prototype, "MaxResponseMessageSize", void 0);
exports.CreateSessionRequest = CreateSessionRequest;
class CreateSessionResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.SessionId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SessionId, (_d !== null && _d !== void 0 ? _d : new NodeId_1.default()));
        this.AuthenticationToken = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.AuthenticationToken, (_f !== null && _f !== void 0 ? _f : new NodeId_1.default()));
        this.RevisedSessionTimeout = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.RevisedSessionTimeout, (_h !== null && _h !== void 0 ? _h : 0));
        this.ServerNonce = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.ServerNonce, (_k !== null && _k !== void 0 ? _k : new Uint8Array()));
        this.ServerCertificate = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.ServerCertificate, (_m !== null && _m !== void 0 ? _m : new Uint8Array()));
        this.ServerEndpoints = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.ServerEndpoints, (_p !== null && _p !== void 0 ? _p : null));
        this.ServerSoftwareCertificates = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.ServerSoftwareCertificates, (_r !== null && _r !== void 0 ? _r : null));
        this.ServerSignature = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.ServerSignature, (_t !== null && _t !== void 0 ? _t : new SignatureData()));
        this.MaxRequestMessageSize = (_v = (_u = options) === null || _u === void 0 ? void 0 : _u.MaxRequestMessageSize, (_v !== null && _v !== void 0 ? _v : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], CreateSessionResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], CreateSessionResponse.prototype, "SessionId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], CreateSessionResponse.prototype, "AuthenticationToken", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_67 = typeof float64 !== "undefined" && float64) === "function" ? _67 : Object)
], CreateSessionResponse.prototype, "RevisedSessionTimeout", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_68 = typeof ByteString !== "undefined" && ByteString) === "function" ? _68 : Object)
], CreateSessionResponse.prototype, "ServerNonce", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_69 = typeof ByteString !== "undefined" && ByteString) === "function" ? _69 : Object)
], CreateSessionResponse.prototype, "ServerCertificate", void 0);
__decorate([
    exports.TypeArray('EndpointDescription'),
    __metadata("design:type", Object)
], CreateSessionResponse.prototype, "ServerEndpoints", void 0);
__decorate([
    exports.TypeArray('SignedSoftwareCertificate'),
    __metadata("design:type", Object)
], CreateSessionResponse.prototype, "ServerSoftwareCertificates", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", SignatureData)
], CreateSessionResponse.prototype, "ServerSignature", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_70 = typeof uint32 !== "undefined" && uint32) === "function" ? _70 : Object)
], CreateSessionResponse.prototype, "MaxRequestMessageSize", void 0);
exports.CreateSessionResponse = CreateSessionResponse;
class UserIdentityToken {
    constructor(options) {
        var _a, _b;
        this.PolicyId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.PolicyId, (_b !== null && _b !== void 0 ? _b : ''));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], UserIdentityToken.prototype, "PolicyId", void 0);
exports.UserIdentityToken = UserIdentityToken;
class AnonymousIdentityToken {
    constructor(options) {
        var _a, _b;
        this.PolicyId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.PolicyId, (_b !== null && _b !== void 0 ? _b : ''));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], AnonymousIdentityToken.prototype, "PolicyId", void 0);
exports.AnonymousIdentityToken = AnonymousIdentityToken;
class UserNameIdentityToken {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.PolicyId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.PolicyId, (_b !== null && _b !== void 0 ? _b : ''));
        this.UserName = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.UserName, (_d !== null && _d !== void 0 ? _d : ''));
        this.Password = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.Password, (_f !== null && _f !== void 0 ? _f : new Uint8Array()));
        this.EncryptionAlgorithm = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.EncryptionAlgorithm, (_h !== null && _h !== void 0 ? _h : ''));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], UserNameIdentityToken.prototype, "PolicyId", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], UserNameIdentityToken.prototype, "UserName", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_71 = typeof ByteString !== "undefined" && ByteString) === "function" ? _71 : Object)
], UserNameIdentityToken.prototype, "Password", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], UserNameIdentityToken.prototype, "EncryptionAlgorithm", void 0);
exports.UserNameIdentityToken = UserNameIdentityToken;
class X509IdentityToken {
    constructor(options) {
        var _a, _b, _c, _d;
        this.PolicyId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.PolicyId, (_b !== null && _b !== void 0 ? _b : ''));
        this.CertificateData = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.CertificateData, (_d !== null && _d !== void 0 ? _d : new Uint8Array()));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], X509IdentityToken.prototype, "PolicyId", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_72 = typeof ByteString !== "undefined" && ByteString) === "function" ? _72 : Object)
], X509IdentityToken.prototype, "CertificateData", void 0);
exports.X509IdentityToken = X509IdentityToken;
class IssuedIdentityToken {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.PolicyId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.PolicyId, (_b !== null && _b !== void 0 ? _b : ''));
        this.TokenData = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.TokenData, (_d !== null && _d !== void 0 ? _d : new Uint8Array()));
        this.EncryptionAlgorithm = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.EncryptionAlgorithm, (_f !== null && _f !== void 0 ? _f : ''));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], IssuedIdentityToken.prototype, "PolicyId", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_73 = typeof ByteString !== "undefined" && ByteString) === "function" ? _73 : Object)
], IssuedIdentityToken.prototype, "TokenData", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], IssuedIdentityToken.prototype, "EncryptionAlgorithm", void 0);
exports.IssuedIdentityToken = IssuedIdentityToken;
class ActivateSessionRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.ClientSignature = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ClientSignature, (_d !== null && _d !== void 0 ? _d : new SignatureData()));
        this.ClientSoftwareCertificates = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ClientSoftwareCertificates, (_f !== null && _f !== void 0 ? _f : null));
        this.LocaleIds = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.LocaleIds, (_h !== null && _h !== void 0 ? _h : null));
        this.UserIdentityToken = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.UserIdentityToken, (_k !== null && _k !== void 0 ? _k : new ExtensionObject_1.default()));
        this.UserTokenSignature = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.UserTokenSignature, (_m !== null && _m !== void 0 ? _m : new SignatureData()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], ActivateSessionRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", SignatureData)
], ActivateSessionRequest.prototype, "ClientSignature", void 0);
__decorate([
    exports.TypeArray('SignedSoftwareCertificate'),
    __metadata("design:type", Object)
], ActivateSessionRequest.prototype, "ClientSoftwareCertificates", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], ActivateSessionRequest.prototype, "LocaleIds", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], ActivateSessionRequest.prototype, "UserIdentityToken", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", SignatureData)
], ActivateSessionRequest.prototype, "UserTokenSignature", void 0);
exports.ActivateSessionRequest = ActivateSessionRequest;
class ActivateSessionResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.ServerNonce = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ServerNonce, (_d !== null && _d !== void 0 ? _d : new Uint8Array()));
        this.Results = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.Results, (_f !== null && _f !== void 0 ? _f : null));
        this.DiagnosticInfos = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.DiagnosticInfos, (_h !== null && _h !== void 0 ? _h : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], ActivateSessionResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_74 = typeof ByteString !== "undefined" && ByteString) === "function" ? _74 : Object)
], ActivateSessionResponse.prototype, "ServerNonce", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], ActivateSessionResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], ActivateSessionResponse.prototype, "DiagnosticInfos", void 0);
exports.ActivateSessionResponse = ActivateSessionResponse;
class CloseSessionRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.DeleteSubscriptions = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.DeleteSubscriptions, (_d !== null && _d !== void 0 ? _d : false));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], CloseSessionRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], CloseSessionRequest.prototype, "DeleteSubscriptions", void 0);
exports.CloseSessionRequest = CloseSessionRequest;
class CloseSessionResponse {
    constructor(options) {
        var _a, _b;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], CloseSessionResponse.prototype, "ResponseHeader", void 0);
exports.CloseSessionResponse = CloseSessionResponse;
class CancelRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.RequestHandle = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.RequestHandle, (_d !== null && _d !== void 0 ? _d : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], CancelRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_75 = typeof uint32 !== "undefined" && uint32) === "function" ? _75 : Object)
], CancelRequest.prototype, "RequestHandle", void 0);
exports.CancelRequest = CancelRequest;
class CancelResponse {
    constructor(options) {
        var _a, _b, _c, _d;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.CancelCount = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.CancelCount, (_d !== null && _d !== void 0 ? _d : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], CancelResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_76 = typeof uint32 !== "undefined" && uint32) === "function" ? _76 : Object)
], CancelResponse.prototype, "CancelCount", void 0);
exports.CancelResponse = CancelResponse;
class NodeAttributes {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.SpecifiedAttributes = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.SpecifiedAttributes, (_b !== null && _b !== void 0 ? _b : 0));
        this.DisplayName = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.DisplayName, (_d !== null && _d !== void 0 ? _d : new LocalizedText_1.default()));
        this.Description = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.Description, (_f !== null && _f !== void 0 ? _f : new LocalizedText_1.default()));
        this.WriteMask = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.WriteMask, (_h !== null && _h !== void 0 ? _h : 0));
        this.UserWriteMask = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.UserWriteMask, (_k !== null && _k !== void 0 ? _k : 0));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_77 = typeof uint32 !== "undefined" && uint32) === "function" ? _77 : Object)
], NodeAttributes.prototype, "SpecifiedAttributes", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], NodeAttributes.prototype, "DisplayName", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], NodeAttributes.prototype, "Description", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_78 = typeof uint32 !== "undefined" && uint32) === "function" ? _78 : Object)
], NodeAttributes.prototype, "WriteMask", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_79 = typeof uint32 !== "undefined" && uint32) === "function" ? _79 : Object)
], NodeAttributes.prototype, "UserWriteMask", void 0);
exports.NodeAttributes = NodeAttributes;
class GenericAttributeValue {
    constructor(options) {
        var _a, _b, _c, _d;
        this.AttributeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.AttributeId, (_b !== null && _b !== void 0 ? _b : 0));
        this.Value = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Value, (_d !== null && _d !== void 0 ? _d : new Variant_1.default()));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_80 = typeof uint32 !== "undefined" && uint32) === "function" ? _80 : Object)
], GenericAttributeValue.prototype, "AttributeId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", Variant_1.default)
], GenericAttributeValue.prototype, "Value", void 0);
exports.GenericAttributeValue = GenericAttributeValue;
class AddNodesItem {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.ParentNodeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ParentNodeId, (_b !== null && _b !== void 0 ? _b : new ExpandedNodeId_1.default()));
        this.ReferenceTypeId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ReferenceTypeId, (_d !== null && _d !== void 0 ? _d : new NodeId_1.default()));
        this.RequestedNewNodeId = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.RequestedNewNodeId, (_f !== null && _f !== void 0 ? _f : new ExpandedNodeId_1.default()));
        this.BrowseName = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.BrowseName, (_h !== null && _h !== void 0 ? _h : new QualifiedName_1.default()));
        this.NodeClass = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.NodeClass, (_k !== null && _k !== void 0 ? _k : exports.NodeClassUnspecified));
        this.NodeAttributes = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.NodeAttributes, (_m !== null && _m !== void 0 ? _m : new ExtensionObject_1.default()));
        this.TypeDefinition = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.TypeDefinition, (_p !== null && _p !== void 0 ? _p : new ExpandedNodeId_1.default()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExpandedNodeId_1.default)
], AddNodesItem.prototype, "ParentNodeId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], AddNodesItem.prototype, "ReferenceTypeId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExpandedNodeId_1.default)
], AddNodesItem.prototype, "RequestedNewNodeId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", QualifiedName_1.default)
], AddNodesItem.prototype, "BrowseName", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_81 = typeof NodeClass !== "undefined" && NodeClass) === "function" ? _81 : Object)
], AddNodesItem.prototype, "NodeClass", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], AddNodesItem.prototype, "NodeAttributes", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExpandedNodeId_1.default)
], AddNodesItem.prototype, "TypeDefinition", void 0);
exports.AddNodesItem = AddNodesItem;
class AddNodesResult {
    constructor(options) {
        var _a, _b, _c, _d;
        this.StatusCode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.StatusCode, (_b !== null && _b !== void 0 ? _b : StatusCode_1.StatusCodeOK));
        this.AddedNodeId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.AddedNodeId, (_d !== null && _d !== void 0 ? _d : new NodeId_1.default()));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_82 = typeof StatusCode !== "undefined" && StatusCode) === "function" ? _82 : Object)
], AddNodesResult.prototype, "StatusCode", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], AddNodesResult.prototype, "AddedNodeId", void 0);
exports.AddNodesResult = AddNodesResult;
class AddNodesRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.NodesToAdd = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.NodesToAdd, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], AddNodesRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.TypeArray('AddNodesItem'),
    __metadata("design:type", Object)
], AddNodesRequest.prototype, "NodesToAdd", void 0);
exports.AddNodesRequest = AddNodesRequest;
class AddNodesResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], AddNodesResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('AddNodesResult'),
    __metadata("design:type", Object)
], AddNodesResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], AddNodesResponse.prototype, "DiagnosticInfos", void 0);
exports.AddNodesResponse = AddNodesResponse;
class AddReferencesItem {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.SourceNodeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.SourceNodeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.ReferenceTypeId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ReferenceTypeId, (_d !== null && _d !== void 0 ? _d : new NodeId_1.default()));
        this.IsForward = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.IsForward, (_f !== null && _f !== void 0 ? _f : false));
        this.TargetServerUri = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.TargetServerUri, (_h !== null && _h !== void 0 ? _h : ''));
        this.TargetNodeId = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.TargetNodeId, (_k !== null && _k !== void 0 ? _k : new ExpandedNodeId_1.default()));
        this.TargetNodeClass = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.TargetNodeClass, (_m !== null && _m !== void 0 ? _m : exports.NodeClassUnspecified));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], AddReferencesItem.prototype, "SourceNodeId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], AddReferencesItem.prototype, "ReferenceTypeId", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], AddReferencesItem.prototype, "IsForward", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], AddReferencesItem.prototype, "TargetServerUri", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExpandedNodeId_1.default)
], AddReferencesItem.prototype, "TargetNodeId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_83 = typeof NodeClass !== "undefined" && NodeClass) === "function" ? _83 : Object)
], AddReferencesItem.prototype, "TargetNodeClass", void 0);
exports.AddReferencesItem = AddReferencesItem;
class AddReferencesRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.ReferencesToAdd = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ReferencesToAdd, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], AddReferencesRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.TypeArray('AddReferencesItem'),
    __metadata("design:type", Object)
], AddReferencesRequest.prototype, "ReferencesToAdd", void 0);
exports.AddReferencesRequest = AddReferencesRequest;
class AddReferencesResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], AddReferencesResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], AddReferencesResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], AddReferencesResponse.prototype, "DiagnosticInfos", void 0);
exports.AddReferencesResponse = AddReferencesResponse;
class DeleteNodesItem {
    constructor(options) {
        var _a, _b, _c, _d;
        this.NodeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.NodeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.DeleteTargetReferences = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.DeleteTargetReferences, (_d !== null && _d !== void 0 ? _d : false));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], DeleteNodesItem.prototype, "NodeId", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], DeleteNodesItem.prototype, "DeleteTargetReferences", void 0);
exports.DeleteNodesItem = DeleteNodesItem;
class DeleteNodesRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.NodesToDelete = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.NodesToDelete, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], DeleteNodesRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.TypeArray('DeleteNodesItem'),
    __metadata("design:type", Object)
], DeleteNodesRequest.prototype, "NodesToDelete", void 0);
exports.DeleteNodesRequest = DeleteNodesRequest;
class DeleteNodesResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], DeleteNodesResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], DeleteNodesResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], DeleteNodesResponse.prototype, "DiagnosticInfos", void 0);
exports.DeleteNodesResponse = DeleteNodesResponse;
class DeleteReferencesItem {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.SourceNodeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.SourceNodeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.ReferenceTypeId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ReferenceTypeId, (_d !== null && _d !== void 0 ? _d : new NodeId_1.default()));
        this.IsForward = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.IsForward, (_f !== null && _f !== void 0 ? _f : false));
        this.TargetNodeId = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.TargetNodeId, (_h !== null && _h !== void 0 ? _h : new ExpandedNodeId_1.default()));
        this.DeleteBidirectional = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.DeleteBidirectional, (_k !== null && _k !== void 0 ? _k : false));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], DeleteReferencesItem.prototype, "SourceNodeId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], DeleteReferencesItem.prototype, "ReferenceTypeId", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], DeleteReferencesItem.prototype, "IsForward", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExpandedNodeId_1.default)
], DeleteReferencesItem.prototype, "TargetNodeId", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], DeleteReferencesItem.prototype, "DeleteBidirectional", void 0);
exports.DeleteReferencesItem = DeleteReferencesItem;
class DeleteReferencesRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.ReferencesToDelete = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ReferencesToDelete, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], DeleteReferencesRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.TypeArray('DeleteReferencesItem'),
    __metadata("design:type", Object)
], DeleteReferencesRequest.prototype, "ReferencesToDelete", void 0);
exports.DeleteReferencesRequest = DeleteReferencesRequest;
class DeleteReferencesResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], DeleteReferencesResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], DeleteReferencesResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], DeleteReferencesResponse.prototype, "DiagnosticInfos", void 0);
exports.DeleteReferencesResponse = DeleteReferencesResponse;
class ViewDescription {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ViewId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ViewId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.Timestamp = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Timestamp, (_d !== null && _d !== void 0 ? _d : new Date()));
        this.ViewVersion = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ViewVersion, (_f !== null && _f !== void 0 ? _f : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], ViewDescription.prototype, "ViewId", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], ViewDescription.prototype, "Timestamp", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_84 = typeof uint32 !== "undefined" && uint32) === "function" ? _84 : Object)
], ViewDescription.prototype, "ViewVersion", void 0);
exports.ViewDescription = ViewDescription;
class BrowseDescription {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.NodeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.NodeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.BrowseDirection = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.BrowseDirection, (_d !== null && _d !== void 0 ? _d : exports.BrowseDirectionForward));
        this.ReferenceTypeId = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ReferenceTypeId, (_f !== null && _f !== void 0 ? _f : new NodeId_1.default()));
        this.IncludeSubtypes = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.IncludeSubtypes, (_h !== null && _h !== void 0 ? _h : false));
        this.NodeClassMask = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.NodeClassMask, (_k !== null && _k !== void 0 ? _k : 0));
        this.ResultMask = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.ResultMask, (_m !== null && _m !== void 0 ? _m : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], BrowseDescription.prototype, "NodeId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_85 = typeof BrowseDirection !== "undefined" && BrowseDirection) === "function" ? _85 : Object)
], BrowseDescription.prototype, "BrowseDirection", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], BrowseDescription.prototype, "ReferenceTypeId", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], BrowseDescription.prototype, "IncludeSubtypes", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_86 = typeof uint32 !== "undefined" && uint32) === "function" ? _86 : Object)
], BrowseDescription.prototype, "NodeClassMask", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_87 = typeof uint32 !== "undefined" && uint32) === "function" ? _87 : Object)
], BrowseDescription.prototype, "ResultMask", void 0);
exports.BrowseDescription = BrowseDescription;
class ReferenceDescription {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.ReferenceTypeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ReferenceTypeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.IsForward = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.IsForward, (_d !== null && _d !== void 0 ? _d : false));
        this.NodeId = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.NodeId, (_f !== null && _f !== void 0 ? _f : new ExpandedNodeId_1.default()));
        this.BrowseName = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.BrowseName, (_h !== null && _h !== void 0 ? _h : new QualifiedName_1.default()));
        this.DisplayName = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.DisplayName, (_k !== null && _k !== void 0 ? _k : new LocalizedText_1.default()));
        this.NodeClass = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.NodeClass, (_m !== null && _m !== void 0 ? _m : exports.NodeClassUnspecified));
        this.TypeDefinition = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.TypeDefinition, (_p !== null && _p !== void 0 ? _p : new ExpandedNodeId_1.default()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], ReferenceDescription.prototype, "ReferenceTypeId", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], ReferenceDescription.prototype, "IsForward", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExpandedNodeId_1.default)
], ReferenceDescription.prototype, "NodeId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", QualifiedName_1.default)
], ReferenceDescription.prototype, "BrowseName", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], ReferenceDescription.prototype, "DisplayName", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_88 = typeof NodeClass !== "undefined" && NodeClass) === "function" ? _88 : Object)
], ReferenceDescription.prototype, "NodeClass", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExpandedNodeId_1.default)
], ReferenceDescription.prototype, "TypeDefinition", void 0);
exports.ReferenceDescription = ReferenceDescription;
class BrowseResult {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.StatusCode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.StatusCode, (_b !== null && _b !== void 0 ? _b : StatusCode_1.StatusCodeOK));
        this.ContinuationPoint = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ContinuationPoint, (_d !== null && _d !== void 0 ? _d : new Uint8Array()));
        this.References = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.References, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_89 = typeof StatusCode !== "undefined" && StatusCode) === "function" ? _89 : Object)
], BrowseResult.prototype, "StatusCode", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_90 = typeof ByteString !== "undefined" && ByteString) === "function" ? _90 : Object)
], BrowseResult.prototype, "ContinuationPoint", void 0);
__decorate([
    exports.TypeArray('ReferenceDescription'),
    __metadata("design:type", Object)
], BrowseResult.prototype, "References", void 0);
exports.BrowseResult = BrowseResult;
class BrowseRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.View = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.View, (_d !== null && _d !== void 0 ? _d : new ViewDescription()));
        this.RequestedMaxReferencesPerNode = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.RequestedMaxReferencesPerNode, (_f !== null && _f !== void 0 ? _f : 0));
        this.NodesToBrowse = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.NodesToBrowse, (_h !== null && _h !== void 0 ? _h : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], BrowseRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ViewDescription)
], BrowseRequest.prototype, "View", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_91 = typeof uint32 !== "undefined" && uint32) === "function" ? _91 : Object)
], BrowseRequest.prototype, "RequestedMaxReferencesPerNode", void 0);
__decorate([
    exports.TypeArray('BrowseDescription'),
    __metadata("design:type", Object)
], BrowseRequest.prototype, "NodesToBrowse", void 0);
exports.BrowseRequest = BrowseRequest;
class BrowseResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], BrowseResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('BrowseResult'),
    __metadata("design:type", Object)
], BrowseResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], BrowseResponse.prototype, "DiagnosticInfos", void 0);
exports.BrowseResponse = BrowseResponse;
class BrowseNextRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.ReleaseContinuationPoints = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ReleaseContinuationPoints, (_d !== null && _d !== void 0 ? _d : false));
        this.ContinuationPoints = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ContinuationPoints, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], BrowseNextRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], BrowseNextRequest.prototype, "ReleaseContinuationPoints", void 0);
__decorate([
    exports.TypeArray('ByteString'),
    __metadata("design:type", Object)
], BrowseNextRequest.prototype, "ContinuationPoints", void 0);
exports.BrowseNextRequest = BrowseNextRequest;
class BrowseNextResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], BrowseNextResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('BrowseResult'),
    __metadata("design:type", Object)
], BrowseNextResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], BrowseNextResponse.prototype, "DiagnosticInfos", void 0);
exports.BrowseNextResponse = BrowseNextResponse;
class RelativePathElement {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.ReferenceTypeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ReferenceTypeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.IsInverse = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.IsInverse, (_d !== null && _d !== void 0 ? _d : false));
        this.IncludeSubtypes = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.IncludeSubtypes, (_f !== null && _f !== void 0 ? _f : false));
        this.TargetName = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.TargetName, (_h !== null && _h !== void 0 ? _h : new QualifiedName_1.default()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], RelativePathElement.prototype, "ReferenceTypeId", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], RelativePathElement.prototype, "IsInverse", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], RelativePathElement.prototype, "IncludeSubtypes", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", QualifiedName_1.default)
], RelativePathElement.prototype, "TargetName", void 0);
exports.RelativePathElement = RelativePathElement;
class RelativePath {
    constructor(options) {
        var _a, _b;
        this.Elements = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Elements, (_b !== null && _b !== void 0 ? _b : null));
    }
}
__decorate([
    exports.TypeArray('RelativePathElement'),
    __metadata("design:type", Object)
], RelativePath.prototype, "Elements", void 0);
exports.RelativePath = RelativePath;
class BrowsePath {
    constructor(options) {
        var _a, _b, _c, _d;
        this.StartingNode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.StartingNode, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.RelativePath = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.RelativePath, (_d !== null && _d !== void 0 ? _d : new RelativePath()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], BrowsePath.prototype, "StartingNode", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", RelativePath)
], BrowsePath.prototype, "RelativePath", void 0);
exports.BrowsePath = BrowsePath;
class BrowsePathTarget {
    constructor(options) {
        var _a, _b, _c, _d;
        this.TargetId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.TargetId, (_b !== null && _b !== void 0 ? _b : new ExpandedNodeId_1.default()));
        this.RemainingPathIndex = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.RemainingPathIndex, (_d !== null && _d !== void 0 ? _d : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExpandedNodeId_1.default)
], BrowsePathTarget.prototype, "TargetId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_92 = typeof uint32 !== "undefined" && uint32) === "function" ? _92 : Object)
], BrowsePathTarget.prototype, "RemainingPathIndex", void 0);
exports.BrowsePathTarget = BrowsePathTarget;
class BrowsePathResult {
    constructor(options) {
        var _a, _b, _c, _d;
        this.StatusCode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.StatusCode, (_b !== null && _b !== void 0 ? _b : StatusCode_1.StatusCodeOK));
        this.Targets = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Targets, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_93 = typeof StatusCode !== "undefined" && StatusCode) === "function" ? _93 : Object)
], BrowsePathResult.prototype, "StatusCode", void 0);
__decorate([
    exports.TypeArray('BrowsePathTarget'),
    __metadata("design:type", Object)
], BrowsePathResult.prototype, "Targets", void 0);
exports.BrowsePathResult = BrowsePathResult;
class TranslateBrowsePathsToNodeIdsRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.BrowsePaths = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.BrowsePaths, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], TranslateBrowsePathsToNodeIdsRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.TypeArray('BrowsePath'),
    __metadata("design:type", Object)
], TranslateBrowsePathsToNodeIdsRequest.prototype, "BrowsePaths", void 0);
exports.TranslateBrowsePathsToNodeIdsRequest = TranslateBrowsePathsToNodeIdsRequest;
class TranslateBrowsePathsToNodeIdsResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], TranslateBrowsePathsToNodeIdsResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('BrowsePathResult'),
    __metadata("design:type", Object)
], TranslateBrowsePathsToNodeIdsResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], TranslateBrowsePathsToNodeIdsResponse.prototype, "DiagnosticInfos", void 0);
exports.TranslateBrowsePathsToNodeIdsResponse = TranslateBrowsePathsToNodeIdsResponse;
class RegisterNodesRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.NodesToRegister = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.NodesToRegister, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], RegisterNodesRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.TypeArray('NodeId'),
    __metadata("design:type", Object)
], RegisterNodesRequest.prototype, "NodesToRegister", void 0);
exports.RegisterNodesRequest = RegisterNodesRequest;
class RegisterNodesResponse {
    constructor(options) {
        var _a, _b, _c, _d;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.RegisteredNodeIds = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.RegisteredNodeIds, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], RegisterNodesResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('NodeId'),
    __metadata("design:type", Object)
], RegisterNodesResponse.prototype, "RegisteredNodeIds", void 0);
exports.RegisterNodesResponse = RegisterNodesResponse;
class UnregisterNodesRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.NodesToUnregister = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.NodesToUnregister, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], UnregisterNodesRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.TypeArray('NodeId'),
    __metadata("design:type", Object)
], UnregisterNodesRequest.prototype, "NodesToUnregister", void 0);
exports.UnregisterNodesRequest = UnregisterNodesRequest;
class UnregisterNodesResponse {
    constructor(options) {
        var _a, _b;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], UnregisterNodesResponse.prototype, "ResponseHeader", void 0);
exports.UnregisterNodesResponse = UnregisterNodesResponse;
class EndpointConfiguration {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        this.OperationTimeout = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.OperationTimeout, (_b !== null && _b !== void 0 ? _b : 0));
        this.UseBinaryEncoding = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.UseBinaryEncoding, (_d !== null && _d !== void 0 ? _d : false));
        this.MaxStringLength = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.MaxStringLength, (_f !== null && _f !== void 0 ? _f : 0));
        this.MaxByteStringLength = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.MaxByteStringLength, (_h !== null && _h !== void 0 ? _h : 0));
        this.MaxArrayLength = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.MaxArrayLength, (_k !== null && _k !== void 0 ? _k : 0));
        this.MaxMessageSize = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.MaxMessageSize, (_m !== null && _m !== void 0 ? _m : 0));
        this.MaxBufferSize = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.MaxBufferSize, (_p !== null && _p !== void 0 ? _p : 0));
        this.ChannelLifetime = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.ChannelLifetime, (_r !== null && _r !== void 0 ? _r : 0));
        this.SecurityTokenLifetime = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.SecurityTokenLifetime, (_t !== null && _t !== void 0 ? _t : 0));
    }
}
__decorate([
    exports.Type('int32'),
    __metadata("design:type", typeof (_94 = typeof int32 !== "undefined" && int32) === "function" ? _94 : Object)
], EndpointConfiguration.prototype, "OperationTimeout", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], EndpointConfiguration.prototype, "UseBinaryEncoding", void 0);
__decorate([
    exports.Type('int32'),
    __metadata("design:type", typeof (_95 = typeof int32 !== "undefined" && int32) === "function" ? _95 : Object)
], EndpointConfiguration.prototype, "MaxStringLength", void 0);
__decorate([
    exports.Type('int32'),
    __metadata("design:type", typeof (_96 = typeof int32 !== "undefined" && int32) === "function" ? _96 : Object)
], EndpointConfiguration.prototype, "MaxByteStringLength", void 0);
__decorate([
    exports.Type('int32'),
    __metadata("design:type", typeof (_97 = typeof int32 !== "undefined" && int32) === "function" ? _97 : Object)
], EndpointConfiguration.prototype, "MaxArrayLength", void 0);
__decorate([
    exports.Type('int32'),
    __metadata("design:type", typeof (_98 = typeof int32 !== "undefined" && int32) === "function" ? _98 : Object)
], EndpointConfiguration.prototype, "MaxMessageSize", void 0);
__decorate([
    exports.Type('int32'),
    __metadata("design:type", typeof (_99 = typeof int32 !== "undefined" && int32) === "function" ? _99 : Object)
], EndpointConfiguration.prototype, "MaxBufferSize", void 0);
__decorate([
    exports.Type('int32'),
    __metadata("design:type", typeof (_100 = typeof int32 !== "undefined" && int32) === "function" ? _100 : Object)
], EndpointConfiguration.prototype, "ChannelLifetime", void 0);
__decorate([
    exports.Type('int32'),
    __metadata("design:type", typeof (_101 = typeof int32 !== "undefined" && int32) === "function" ? _101 : Object)
], EndpointConfiguration.prototype, "SecurityTokenLifetime", void 0);
exports.EndpointConfiguration = EndpointConfiguration;
class QueryDataDescription {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.RelativePath = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RelativePath, (_b !== null && _b !== void 0 ? _b : new RelativePath()));
        this.AttributeId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.AttributeId, (_d !== null && _d !== void 0 ? _d : 0));
        this.IndexRange = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.IndexRange, (_f !== null && _f !== void 0 ? _f : ''));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RelativePath)
], QueryDataDescription.prototype, "RelativePath", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_102 = typeof uint32 !== "undefined" && uint32) === "function" ? _102 : Object)
], QueryDataDescription.prototype, "AttributeId", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], QueryDataDescription.prototype, "IndexRange", void 0);
exports.QueryDataDescription = QueryDataDescription;
class NodeTypeDescription {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.TypeDefinitionNode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.TypeDefinitionNode, (_b !== null && _b !== void 0 ? _b : new ExpandedNodeId_1.default()));
        this.IncludeSubTypes = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.IncludeSubTypes, (_d !== null && _d !== void 0 ? _d : false));
        this.DataToReturn = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DataToReturn, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExpandedNodeId_1.default)
], NodeTypeDescription.prototype, "TypeDefinitionNode", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], NodeTypeDescription.prototype, "IncludeSubTypes", void 0);
__decorate([
    exports.TypeArray('QueryDataDescription'),
    __metadata("design:type", Object)
], NodeTypeDescription.prototype, "DataToReturn", void 0);
exports.NodeTypeDescription = NodeTypeDescription;
class QueryDataSet {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.NodeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.NodeId, (_b !== null && _b !== void 0 ? _b : new ExpandedNodeId_1.default()));
        this.TypeDefinitionNode = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.TypeDefinitionNode, (_d !== null && _d !== void 0 ? _d : new ExpandedNodeId_1.default()));
        this.Values = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.Values, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExpandedNodeId_1.default)
], QueryDataSet.prototype, "NodeId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExpandedNodeId_1.default)
], QueryDataSet.prototype, "TypeDefinitionNode", void 0);
__decorate([
    exports.TypeArray('Variant'),
    __metadata("design:type", Object)
], QueryDataSet.prototype, "Values", void 0);
exports.QueryDataSet = QueryDataSet;
class NodeReference {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.NodeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.NodeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.ReferenceTypeId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ReferenceTypeId, (_d !== null && _d !== void 0 ? _d : new NodeId_1.default()));
        this.IsForward = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.IsForward, (_f !== null && _f !== void 0 ? _f : false));
        this.ReferencedNodeIds = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ReferencedNodeIds, (_h !== null && _h !== void 0 ? _h : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], NodeReference.prototype, "NodeId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], NodeReference.prototype, "ReferenceTypeId", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], NodeReference.prototype, "IsForward", void 0);
__decorate([
    exports.TypeArray('NodeId'),
    __metadata("design:type", Object)
], NodeReference.prototype, "ReferencedNodeIds", void 0);
exports.NodeReference = NodeReference;
class ContentFilterElement {
    constructor(options) {
        var _a, _b, _c, _d;
        this.FilterOperator = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.FilterOperator, (_b !== null && _b !== void 0 ? _b : exports.FilterOperatorEquals));
        this.FilterOperands = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.FilterOperands, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_103 = typeof FilterOperator !== "undefined" && FilterOperator) === "function" ? _103 : Object)
], ContentFilterElement.prototype, "FilterOperator", void 0);
__decorate([
    exports.TypeArray('ExtensionObject'),
    __metadata("design:type", Object)
], ContentFilterElement.prototype, "FilterOperands", void 0);
exports.ContentFilterElement = ContentFilterElement;
class ContentFilter {
    constructor(options) {
        var _a, _b;
        this.Elements = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Elements, (_b !== null && _b !== void 0 ? _b : null));
    }
}
__decorate([
    exports.TypeArray('ContentFilterElement'),
    __metadata("design:type", Object)
], ContentFilter.prototype, "Elements", void 0);
exports.ContentFilter = ContentFilter;
class ContentFilterElementResult {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.StatusCode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.StatusCode, (_b !== null && _b !== void 0 ? _b : StatusCode_1.StatusCodeOK));
        this.OperandStatusCodes = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.OperandStatusCodes, (_d !== null && _d !== void 0 ? _d : null));
        this.OperandDiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.OperandDiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_104 = typeof StatusCode !== "undefined" && StatusCode) === "function" ? _104 : Object)
], ContentFilterElementResult.prototype, "StatusCode", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], ContentFilterElementResult.prototype, "OperandStatusCodes", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], ContentFilterElementResult.prototype, "OperandDiagnosticInfos", void 0);
exports.ContentFilterElementResult = ContentFilterElementResult;
class ContentFilterResult {
    constructor(options) {
        var _a, _b, _c, _d;
        this.ElementResults = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ElementResults, (_b !== null && _b !== void 0 ? _b : null));
        this.ElementDiagnosticInfos = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ElementDiagnosticInfos, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.TypeArray('ContentFilterElementResult'),
    __metadata("design:type", Object)
], ContentFilterResult.prototype, "ElementResults", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], ContentFilterResult.prototype, "ElementDiagnosticInfos", void 0);
exports.ContentFilterResult = ContentFilterResult;
class ParsingResult {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.StatusCode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.StatusCode, (_b !== null && _b !== void 0 ? _b : StatusCode_1.StatusCodeOK));
        this.DataStatusCodes = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.DataStatusCodes, (_d !== null && _d !== void 0 ? _d : null));
        this.DataDiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DataDiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_105 = typeof StatusCode !== "undefined" && StatusCode) === "function" ? _105 : Object)
], ParsingResult.prototype, "StatusCode", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], ParsingResult.prototype, "DataStatusCodes", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], ParsingResult.prototype, "DataDiagnosticInfos", void 0);
exports.ParsingResult = ParsingResult;
class QueryFirstRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.View = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.View, (_d !== null && _d !== void 0 ? _d : new ViewDescription()));
        this.NodeTypes = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.NodeTypes, (_f !== null && _f !== void 0 ? _f : null));
        this.Filter = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.Filter, (_h !== null && _h !== void 0 ? _h : new ContentFilter()));
        this.MaxDataSetsToReturn = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.MaxDataSetsToReturn, (_k !== null && _k !== void 0 ? _k : 0));
        this.MaxReferencesToReturn = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.MaxReferencesToReturn, (_m !== null && _m !== void 0 ? _m : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], QueryFirstRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ViewDescription)
], QueryFirstRequest.prototype, "View", void 0);
__decorate([
    exports.TypeArray('NodeTypeDescription'),
    __metadata("design:type", Object)
], QueryFirstRequest.prototype, "NodeTypes", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ContentFilter)
], QueryFirstRequest.prototype, "Filter", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_106 = typeof uint32 !== "undefined" && uint32) === "function" ? _106 : Object)
], QueryFirstRequest.prototype, "MaxDataSetsToReturn", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_107 = typeof uint32 !== "undefined" && uint32) === "function" ? _107 : Object)
], QueryFirstRequest.prototype, "MaxReferencesToReturn", void 0);
exports.QueryFirstRequest = QueryFirstRequest;
class QueryFirstResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.QueryDataSets = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.QueryDataSets, (_d !== null && _d !== void 0 ? _d : null));
        this.ContinuationPoint = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ContinuationPoint, (_f !== null && _f !== void 0 ? _f : new Uint8Array()));
        this.ParsingResults = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ParsingResults, (_h !== null && _h !== void 0 ? _h : null));
        this.DiagnosticInfos = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.DiagnosticInfos, (_k !== null && _k !== void 0 ? _k : null));
        this.FilterResult = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.FilterResult, (_m !== null && _m !== void 0 ? _m : new ContentFilterResult()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], QueryFirstResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('QueryDataSet'),
    __metadata("design:type", Object)
], QueryFirstResponse.prototype, "QueryDataSets", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_108 = typeof ByteString !== "undefined" && ByteString) === "function" ? _108 : Object)
], QueryFirstResponse.prototype, "ContinuationPoint", void 0);
__decorate([
    exports.TypeArray('ParsingResult'),
    __metadata("design:type", Object)
], QueryFirstResponse.prototype, "ParsingResults", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], QueryFirstResponse.prototype, "DiagnosticInfos", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ContentFilterResult)
], QueryFirstResponse.prototype, "FilterResult", void 0);
exports.QueryFirstResponse = QueryFirstResponse;
class QueryNextRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.ReleaseContinuationPoint = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ReleaseContinuationPoint, (_d !== null && _d !== void 0 ? _d : false));
        this.ContinuationPoint = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ContinuationPoint, (_f !== null && _f !== void 0 ? _f : new Uint8Array()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], QueryNextRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], QueryNextRequest.prototype, "ReleaseContinuationPoint", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_109 = typeof ByteString !== "undefined" && ByteString) === "function" ? _109 : Object)
], QueryNextRequest.prototype, "ContinuationPoint", void 0);
exports.QueryNextRequest = QueryNextRequest;
class QueryNextResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.QueryDataSets = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.QueryDataSets, (_d !== null && _d !== void 0 ? _d : null));
        this.RevisedContinuationPoint = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.RevisedContinuationPoint, (_f !== null && _f !== void 0 ? _f : new Uint8Array()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], QueryNextResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('QueryDataSet'),
    __metadata("design:type", Object)
], QueryNextResponse.prototype, "QueryDataSets", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_110 = typeof ByteString !== "undefined" && ByteString) === "function" ? _110 : Object)
], QueryNextResponse.prototype, "RevisedContinuationPoint", void 0);
exports.QueryNextResponse = QueryNextResponse;
class ReadValueId {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.NodeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.NodeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.AttributeId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.AttributeId, (_d !== null && _d !== void 0 ? _d : 0));
        this.IndexRange = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.IndexRange, (_f !== null && _f !== void 0 ? _f : ''));
        this.DataEncoding = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.DataEncoding, (_h !== null && _h !== void 0 ? _h : new QualifiedName_1.default()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], ReadValueId.prototype, "NodeId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_111 = typeof uint32 !== "undefined" && uint32) === "function" ? _111 : Object)
], ReadValueId.prototype, "AttributeId", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], ReadValueId.prototype, "IndexRange", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", QualifiedName_1.default)
], ReadValueId.prototype, "DataEncoding", void 0);
exports.ReadValueId = ReadValueId;
class ReadRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.MaxAge = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.MaxAge, (_d !== null && _d !== void 0 ? _d : 0));
        this.TimestampsToReturn = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.TimestampsToReturn, (_f !== null && _f !== void 0 ? _f : exports.TimestampsToReturnSource));
        this.NodesToRead = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.NodesToRead, (_h !== null && _h !== void 0 ? _h : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], ReadRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_112 = typeof float64 !== "undefined" && float64) === "function" ? _112 : Object)
], ReadRequest.prototype, "MaxAge", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_113 = typeof TimestampsToReturn !== "undefined" && TimestampsToReturn) === "function" ? _113 : Object)
], ReadRequest.prototype, "TimestampsToReturn", void 0);
__decorate([
    exports.TypeArray('ReadValueId'),
    __metadata("design:type", Object)
], ReadRequest.prototype, "NodesToRead", void 0);
exports.ReadRequest = ReadRequest;
class ReadResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], ReadResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('DataValue'),
    __metadata("design:type", Object)
], ReadResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], ReadResponse.prototype, "DiagnosticInfos", void 0);
exports.ReadResponse = ReadResponse;
class HistoryReadValueId {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.NodeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.NodeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.IndexRange = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.IndexRange, (_d !== null && _d !== void 0 ? _d : ''));
        this.DataEncoding = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DataEncoding, (_f !== null && _f !== void 0 ? _f : new QualifiedName_1.default()));
        this.ContinuationPoint = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ContinuationPoint, (_h !== null && _h !== void 0 ? _h : new Uint8Array()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], HistoryReadValueId.prototype, "NodeId", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], HistoryReadValueId.prototype, "IndexRange", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", QualifiedName_1.default)
], HistoryReadValueId.prototype, "DataEncoding", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_114 = typeof ByteString !== "undefined" && ByteString) === "function" ? _114 : Object)
], HistoryReadValueId.prototype, "ContinuationPoint", void 0);
exports.HistoryReadValueId = HistoryReadValueId;
class HistoryReadResult {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.StatusCode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.StatusCode, (_b !== null && _b !== void 0 ? _b : StatusCode_1.StatusCodeOK));
        this.ContinuationPoint = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ContinuationPoint, (_d !== null && _d !== void 0 ? _d : new Uint8Array()));
        this.HistoryData = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.HistoryData, (_f !== null && _f !== void 0 ? _f : new ExtensionObject_1.default()));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_115 = typeof StatusCode !== "undefined" && StatusCode) === "function" ? _115 : Object)
], HistoryReadResult.prototype, "StatusCode", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_116 = typeof ByteString !== "undefined" && ByteString) === "function" ? _116 : Object)
], HistoryReadResult.prototype, "ContinuationPoint", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], HistoryReadResult.prototype, "HistoryData", void 0);
exports.HistoryReadResult = HistoryReadResult;
class HistoryData {
    constructor(options) {
        var _a, _b;
        this.DataValues = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.DataValues, (_b !== null && _b !== void 0 ? _b : null));
    }
}
__decorate([
    exports.TypeArray('DataValue'),
    __metadata("design:type", Object)
], HistoryData.prototype, "DataValues", void 0);
exports.HistoryData = HistoryData;
class ModificationInfo {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ModificationTime = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ModificationTime, (_b !== null && _b !== void 0 ? _b : new Date()));
        this.UpdateType = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.UpdateType, (_d !== null && _d !== void 0 ? _d : exports.HistoryUpdateTypeInsert));
        this.UserName = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.UserName, (_f !== null && _f !== void 0 ? _f : ''));
    }
}
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], ModificationInfo.prototype, "ModificationTime", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_117 = typeof HistoryUpdateType !== "undefined" && HistoryUpdateType) === "function" ? _117 : Object)
], ModificationInfo.prototype, "UpdateType", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], ModificationInfo.prototype, "UserName", void 0);
exports.ModificationInfo = ModificationInfo;
class HistoryEventFieldList {
    constructor(options) {
        var _a, _b;
        this.EventFields = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.EventFields, (_b !== null && _b !== void 0 ? _b : null));
    }
}
__decorate([
    exports.TypeArray('Variant'),
    __metadata("design:type", Object)
], HistoryEventFieldList.prototype, "EventFields", void 0);
exports.HistoryEventFieldList = HistoryEventFieldList;
class HistoryEvent {
    constructor(options) {
        var _a, _b;
        this.Events = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Events, (_b !== null && _b !== void 0 ? _b : null));
    }
}
__decorate([
    exports.TypeArray('HistoryEventFieldList'),
    __metadata("design:type", Object)
], HistoryEvent.prototype, "Events", void 0);
exports.HistoryEvent = HistoryEvent;
class HistoryReadRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.HistoryReadDetails = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.HistoryReadDetails, (_d !== null && _d !== void 0 ? _d : new ExtensionObject_1.default()));
        this.TimestampsToReturn = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.TimestampsToReturn, (_f !== null && _f !== void 0 ? _f : exports.TimestampsToReturnSource));
        this.ReleaseContinuationPoints = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ReleaseContinuationPoints, (_h !== null && _h !== void 0 ? _h : false));
        this.NodesToRead = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.NodesToRead, (_k !== null && _k !== void 0 ? _k : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], HistoryReadRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], HistoryReadRequest.prototype, "HistoryReadDetails", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_118 = typeof TimestampsToReturn !== "undefined" && TimestampsToReturn) === "function" ? _118 : Object)
], HistoryReadRequest.prototype, "TimestampsToReturn", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], HistoryReadRequest.prototype, "ReleaseContinuationPoints", void 0);
__decorate([
    exports.TypeArray('HistoryReadValueId'),
    __metadata("design:type", Object)
], HistoryReadRequest.prototype, "NodesToRead", void 0);
exports.HistoryReadRequest = HistoryReadRequest;
class HistoryReadResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], HistoryReadResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('HistoryReadResult'),
    __metadata("design:type", Object)
], HistoryReadResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], HistoryReadResponse.prototype, "DiagnosticInfos", void 0);
exports.HistoryReadResponse = HistoryReadResponse;
class WriteValue {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.NodeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.NodeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.AttributeId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.AttributeId, (_d !== null && _d !== void 0 ? _d : 0));
        this.IndexRange = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.IndexRange, (_f !== null && _f !== void 0 ? _f : ''));
        this.Value = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.Value, (_h !== null && _h !== void 0 ? _h : new DataValue_1.default()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], WriteValue.prototype, "NodeId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_119 = typeof uint32 !== "undefined" && uint32) === "function" ? _119 : Object)
], WriteValue.prototype, "AttributeId", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], WriteValue.prototype, "IndexRange", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", DataValue_1.default)
], WriteValue.prototype, "Value", void 0);
exports.WriteValue = WriteValue;
class WriteRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.NodesToWrite = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.NodesToWrite, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], WriteRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.TypeArray('WriteValue'),
    __metadata("design:type", Object)
], WriteRequest.prototype, "NodesToWrite", void 0);
exports.WriteRequest = WriteRequest;
class WriteResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], WriteResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], WriteResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], WriteResponse.prototype, "DiagnosticInfos", void 0);
exports.WriteResponse = WriteResponse;
class HistoryUpdateDetails {
    constructor(options) {
        var _a, _b;
        this.NodeId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.NodeId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], HistoryUpdateDetails.prototype, "NodeId", void 0);
exports.HistoryUpdateDetails = HistoryUpdateDetails;
class HistoryUpdateResult {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.StatusCode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.StatusCode, (_b !== null && _b !== void 0 ? _b : StatusCode_1.StatusCodeOK));
        this.OperationResults = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.OperationResults, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_120 = typeof StatusCode !== "undefined" && StatusCode) === "function" ? _120 : Object)
], HistoryUpdateResult.prototype, "StatusCode", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], HistoryUpdateResult.prototype, "OperationResults", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], HistoryUpdateResult.prototype, "DiagnosticInfos", void 0);
exports.HistoryUpdateResult = HistoryUpdateResult;
class HistoryUpdateRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.HistoryUpdateDetails = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.HistoryUpdateDetails, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], HistoryUpdateRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.TypeArray('ExtensionObject'),
    __metadata("design:type", Object)
], HistoryUpdateRequest.prototype, "HistoryUpdateDetails", void 0);
exports.HistoryUpdateRequest = HistoryUpdateRequest;
class HistoryUpdateResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], HistoryUpdateResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('HistoryUpdateResult'),
    __metadata("design:type", Object)
], HistoryUpdateResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], HistoryUpdateResponse.prototype, "DiagnosticInfos", void 0);
exports.HistoryUpdateResponse = HistoryUpdateResponse;
class CallMethodRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ObjectId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ObjectId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.MethodId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.MethodId, (_d !== null && _d !== void 0 ? _d : new NodeId_1.default()));
        this.InputArguments = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.InputArguments, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], CallMethodRequest.prototype, "ObjectId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], CallMethodRequest.prototype, "MethodId", void 0);
__decorate([
    exports.TypeArray('Variant'),
    __metadata("design:type", Object)
], CallMethodRequest.prototype, "InputArguments", void 0);
exports.CallMethodRequest = CallMethodRequest;
class CallMethodResult {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.StatusCode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.StatusCode, (_b !== null && _b !== void 0 ? _b : StatusCode_1.StatusCodeOK));
        this.InputArgumentResults = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.InputArgumentResults, (_d !== null && _d !== void 0 ? _d : null));
        this.InputArgumentDiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.InputArgumentDiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
        this.OutputArguments = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.OutputArguments, (_h !== null && _h !== void 0 ? _h : null));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_121 = typeof StatusCode !== "undefined" && StatusCode) === "function" ? _121 : Object)
], CallMethodResult.prototype, "StatusCode", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], CallMethodResult.prototype, "InputArgumentResults", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], CallMethodResult.prototype, "InputArgumentDiagnosticInfos", void 0);
__decorate([
    exports.TypeArray('Variant'),
    __metadata("design:type", Object)
], CallMethodResult.prototype, "OutputArguments", void 0);
exports.CallMethodResult = CallMethodResult;
class CallRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.MethodsToCall = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.MethodsToCall, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], CallRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.TypeArray('CallMethodRequest'),
    __metadata("design:type", Object)
], CallRequest.prototype, "MethodsToCall", void 0);
exports.CallRequest = CallRequest;
class CallResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], CallResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('CallMethodResult'),
    __metadata("design:type", Object)
], CallResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], CallResponse.prototype, "DiagnosticInfos", void 0);
exports.CallResponse = CallResponse;
class AggregateConfiguration {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.UseServerCapabilitiesDefaults = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.UseServerCapabilitiesDefaults, (_b !== null && _b !== void 0 ? _b : false));
        this.TreatUncertainAsBad = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.TreatUncertainAsBad, (_d !== null && _d !== void 0 ? _d : false));
        this.PercentDataBad = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.PercentDataBad, (_f !== null && _f !== void 0 ? _f : 0));
        this.PercentDataGood = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.PercentDataGood, (_h !== null && _h !== void 0 ? _h : 0));
        this.UseSlopedExtrapolation = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.UseSlopedExtrapolation, (_k !== null && _k !== void 0 ? _k : false));
    }
}
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], AggregateConfiguration.prototype, "UseServerCapabilitiesDefaults", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], AggregateConfiguration.prototype, "TreatUncertainAsBad", void 0);
__decorate([
    exports.Type('uint8'),
    __metadata("design:type", typeof (_122 = typeof uint8 !== "undefined" && uint8) === "function" ? _122 : Object)
], AggregateConfiguration.prototype, "PercentDataBad", void 0);
__decorate([
    exports.Type('uint8'),
    __metadata("design:type", typeof (_123 = typeof uint8 !== "undefined" && uint8) === "function" ? _123 : Object)
], AggregateConfiguration.prototype, "PercentDataGood", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], AggregateConfiguration.prototype, "UseSlopedExtrapolation", void 0);
exports.AggregateConfiguration = AggregateConfiguration;
class MonitoringParameters {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.ClientHandle = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ClientHandle, (_b !== null && _b !== void 0 ? _b : 0));
        this.SamplingInterval = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SamplingInterval, (_d !== null && _d !== void 0 ? _d : 0));
        this.Filter = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.Filter, (_f !== null && _f !== void 0 ? _f : new ExtensionObject_1.default()));
        this.QueueSize = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.QueueSize, (_h !== null && _h !== void 0 ? _h : 0));
        this.DiscardOldest = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.DiscardOldest, (_k !== null && _k !== void 0 ? _k : false));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_124 = typeof uint32 !== "undefined" && uint32) === "function" ? _124 : Object)
], MonitoringParameters.prototype, "ClientHandle", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_125 = typeof float64 !== "undefined" && float64) === "function" ? _125 : Object)
], MonitoringParameters.prototype, "SamplingInterval", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], MonitoringParameters.prototype, "Filter", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_126 = typeof uint32 !== "undefined" && uint32) === "function" ? _126 : Object)
], MonitoringParameters.prototype, "QueueSize", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], MonitoringParameters.prototype, "DiscardOldest", void 0);
exports.MonitoringParameters = MonitoringParameters;
class MonitoredItemCreateRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ItemToMonitor = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ItemToMonitor, (_b !== null && _b !== void 0 ? _b : new ReadValueId()));
        this.MonitoringMode = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.MonitoringMode, (_d !== null && _d !== void 0 ? _d : exports.MonitoringModeDisabled));
        this.RequestedParameters = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.RequestedParameters, (_f !== null && _f !== void 0 ? _f : new MonitoringParameters()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ReadValueId)
], MonitoredItemCreateRequest.prototype, "ItemToMonitor", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_127 = typeof MonitoringMode !== "undefined" && MonitoringMode) === "function" ? _127 : Object)
], MonitoredItemCreateRequest.prototype, "MonitoringMode", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", MonitoringParameters)
], MonitoredItemCreateRequest.prototype, "RequestedParameters", void 0);
exports.MonitoredItemCreateRequest = MonitoredItemCreateRequest;
class MonitoredItemCreateResult {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.StatusCode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.StatusCode, (_b !== null && _b !== void 0 ? _b : StatusCode_1.StatusCodeOK));
        this.MonitoredItemId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.MonitoredItemId, (_d !== null && _d !== void 0 ? _d : 0));
        this.RevisedSamplingInterval = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.RevisedSamplingInterval, (_f !== null && _f !== void 0 ? _f : 0));
        this.RevisedQueueSize = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.RevisedQueueSize, (_h !== null && _h !== void 0 ? _h : 0));
        this.FilterResult = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.FilterResult, (_k !== null && _k !== void 0 ? _k : new ExtensionObject_1.default()));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_128 = typeof StatusCode !== "undefined" && StatusCode) === "function" ? _128 : Object)
], MonitoredItemCreateResult.prototype, "StatusCode", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_129 = typeof uint32 !== "undefined" && uint32) === "function" ? _129 : Object)
], MonitoredItemCreateResult.prototype, "MonitoredItemId", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_130 = typeof float64 !== "undefined" && float64) === "function" ? _130 : Object)
], MonitoredItemCreateResult.prototype, "RevisedSamplingInterval", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_131 = typeof uint32 !== "undefined" && uint32) === "function" ? _131 : Object)
], MonitoredItemCreateResult.prototype, "RevisedQueueSize", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], MonitoredItemCreateResult.prototype, "FilterResult", void 0);
exports.MonitoredItemCreateResult = MonitoredItemCreateResult;
class CreateMonitoredItemsRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.SubscriptionId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SubscriptionId, (_d !== null && _d !== void 0 ? _d : 0));
        this.TimestampsToReturn = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.TimestampsToReturn, (_f !== null && _f !== void 0 ? _f : exports.TimestampsToReturnSource));
        this.ItemsToCreate = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ItemsToCreate, (_h !== null && _h !== void 0 ? _h : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], CreateMonitoredItemsRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_132 = typeof uint32 !== "undefined" && uint32) === "function" ? _132 : Object)
], CreateMonitoredItemsRequest.prototype, "SubscriptionId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_133 = typeof TimestampsToReturn !== "undefined" && TimestampsToReturn) === "function" ? _133 : Object)
], CreateMonitoredItemsRequest.prototype, "TimestampsToReturn", void 0);
__decorate([
    exports.TypeArray('MonitoredItemCreateRequest'),
    __metadata("design:type", Object)
], CreateMonitoredItemsRequest.prototype, "ItemsToCreate", void 0);
exports.CreateMonitoredItemsRequest = CreateMonitoredItemsRequest;
class CreateMonitoredItemsResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], CreateMonitoredItemsResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('MonitoredItemCreateResult'),
    __metadata("design:type", Object)
], CreateMonitoredItemsResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], CreateMonitoredItemsResponse.prototype, "DiagnosticInfos", void 0);
exports.CreateMonitoredItemsResponse = CreateMonitoredItemsResponse;
class MonitoredItemModifyRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.MonitoredItemId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.MonitoredItemId, (_b !== null && _b !== void 0 ? _b : 0));
        this.RequestedParameters = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.RequestedParameters, (_d !== null && _d !== void 0 ? _d : new MonitoringParameters()));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_134 = typeof uint32 !== "undefined" && uint32) === "function" ? _134 : Object)
], MonitoredItemModifyRequest.prototype, "MonitoredItemId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", MonitoringParameters)
], MonitoredItemModifyRequest.prototype, "RequestedParameters", void 0);
exports.MonitoredItemModifyRequest = MonitoredItemModifyRequest;
class MonitoredItemModifyResult {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.StatusCode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.StatusCode, (_b !== null && _b !== void 0 ? _b : StatusCode_1.StatusCodeOK));
        this.RevisedSamplingInterval = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.RevisedSamplingInterval, (_d !== null && _d !== void 0 ? _d : 0));
        this.RevisedQueueSize = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.RevisedQueueSize, (_f !== null && _f !== void 0 ? _f : 0));
        this.FilterResult = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.FilterResult, (_h !== null && _h !== void 0 ? _h : new ExtensionObject_1.default()));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_135 = typeof StatusCode !== "undefined" && StatusCode) === "function" ? _135 : Object)
], MonitoredItemModifyResult.prototype, "StatusCode", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_136 = typeof float64 !== "undefined" && float64) === "function" ? _136 : Object)
], MonitoredItemModifyResult.prototype, "RevisedSamplingInterval", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_137 = typeof uint32 !== "undefined" && uint32) === "function" ? _137 : Object)
], MonitoredItemModifyResult.prototype, "RevisedQueueSize", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ExtensionObject_1.default)
], MonitoredItemModifyResult.prototype, "FilterResult", void 0);
exports.MonitoredItemModifyResult = MonitoredItemModifyResult;
class ModifyMonitoredItemsRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.SubscriptionId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SubscriptionId, (_d !== null && _d !== void 0 ? _d : 0));
        this.TimestampsToReturn = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.TimestampsToReturn, (_f !== null && _f !== void 0 ? _f : exports.TimestampsToReturnSource));
        this.ItemsToModify = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ItemsToModify, (_h !== null && _h !== void 0 ? _h : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], ModifyMonitoredItemsRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_138 = typeof uint32 !== "undefined" && uint32) === "function" ? _138 : Object)
], ModifyMonitoredItemsRequest.prototype, "SubscriptionId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_139 = typeof TimestampsToReturn !== "undefined" && TimestampsToReturn) === "function" ? _139 : Object)
], ModifyMonitoredItemsRequest.prototype, "TimestampsToReturn", void 0);
__decorate([
    exports.TypeArray('MonitoredItemModifyRequest'),
    __metadata("design:type", Object)
], ModifyMonitoredItemsRequest.prototype, "ItemsToModify", void 0);
exports.ModifyMonitoredItemsRequest = ModifyMonitoredItemsRequest;
class ModifyMonitoredItemsResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], ModifyMonitoredItemsResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('MonitoredItemModifyResult'),
    __metadata("design:type", Object)
], ModifyMonitoredItemsResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], ModifyMonitoredItemsResponse.prototype, "DiagnosticInfos", void 0);
exports.ModifyMonitoredItemsResponse = ModifyMonitoredItemsResponse;
class SetMonitoringModeRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.SubscriptionId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SubscriptionId, (_d !== null && _d !== void 0 ? _d : 0));
        this.MonitoringMode = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.MonitoringMode, (_f !== null && _f !== void 0 ? _f : exports.MonitoringModeDisabled));
        this.MonitoredItemIds = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.MonitoredItemIds, (_h !== null && _h !== void 0 ? _h : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], SetMonitoringModeRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_140 = typeof uint32 !== "undefined" && uint32) === "function" ? _140 : Object)
], SetMonitoringModeRequest.prototype, "SubscriptionId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_141 = typeof MonitoringMode !== "undefined" && MonitoringMode) === "function" ? _141 : Object)
], SetMonitoringModeRequest.prototype, "MonitoringMode", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], SetMonitoringModeRequest.prototype, "MonitoredItemIds", void 0);
exports.SetMonitoringModeRequest = SetMonitoringModeRequest;
class SetMonitoringModeResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], SetMonitoringModeResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], SetMonitoringModeResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], SetMonitoringModeResponse.prototype, "DiagnosticInfos", void 0);
exports.SetMonitoringModeResponse = SetMonitoringModeResponse;
class SetTriggeringRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.SubscriptionId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SubscriptionId, (_d !== null && _d !== void 0 ? _d : 0));
        this.TriggeringItemId = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.TriggeringItemId, (_f !== null && _f !== void 0 ? _f : 0));
        this.LinksToAdd = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.LinksToAdd, (_h !== null && _h !== void 0 ? _h : null));
        this.LinksToRemove = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.LinksToRemove, (_k !== null && _k !== void 0 ? _k : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], SetTriggeringRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_142 = typeof uint32 !== "undefined" && uint32) === "function" ? _142 : Object)
], SetTriggeringRequest.prototype, "SubscriptionId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_143 = typeof uint32 !== "undefined" && uint32) === "function" ? _143 : Object)
], SetTriggeringRequest.prototype, "TriggeringItemId", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], SetTriggeringRequest.prototype, "LinksToAdd", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], SetTriggeringRequest.prototype, "LinksToRemove", void 0);
exports.SetTriggeringRequest = SetTriggeringRequest;
class SetTriggeringResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.AddResults = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.AddResults, (_d !== null && _d !== void 0 ? _d : null));
        this.AddDiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.AddDiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
        this.RemoveResults = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.RemoveResults, (_h !== null && _h !== void 0 ? _h : null));
        this.RemoveDiagnosticInfos = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.RemoveDiagnosticInfos, (_k !== null && _k !== void 0 ? _k : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], SetTriggeringResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], SetTriggeringResponse.prototype, "AddResults", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], SetTriggeringResponse.prototype, "AddDiagnosticInfos", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], SetTriggeringResponse.prototype, "RemoveResults", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], SetTriggeringResponse.prototype, "RemoveDiagnosticInfos", void 0);
exports.SetTriggeringResponse = SetTriggeringResponse;
class DeleteMonitoredItemsRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.SubscriptionId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SubscriptionId, (_d !== null && _d !== void 0 ? _d : 0));
        this.MonitoredItemIds = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.MonitoredItemIds, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], DeleteMonitoredItemsRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_144 = typeof uint32 !== "undefined" && uint32) === "function" ? _144 : Object)
], DeleteMonitoredItemsRequest.prototype, "SubscriptionId", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], DeleteMonitoredItemsRequest.prototype, "MonitoredItemIds", void 0);
exports.DeleteMonitoredItemsRequest = DeleteMonitoredItemsRequest;
class DeleteMonitoredItemsResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], DeleteMonitoredItemsResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], DeleteMonitoredItemsResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], DeleteMonitoredItemsResponse.prototype, "DiagnosticInfos", void 0);
exports.DeleteMonitoredItemsResponse = DeleteMonitoredItemsResponse;
class CreateSubscriptionRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.RequestedPublishingInterval = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.RequestedPublishingInterval, (_d !== null && _d !== void 0 ? _d : 0));
        this.RequestedLifetimeCount = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.RequestedLifetimeCount, (_f !== null && _f !== void 0 ? _f : 0));
        this.RequestedMaxKeepAliveCount = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.RequestedMaxKeepAliveCount, (_h !== null && _h !== void 0 ? _h : 0));
        this.MaxNotificationsPerPublish = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.MaxNotificationsPerPublish, (_k !== null && _k !== void 0 ? _k : 0));
        this.PublishingEnabled = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.PublishingEnabled, (_m !== null && _m !== void 0 ? _m : false));
        this.Priority = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.Priority, (_p !== null && _p !== void 0 ? _p : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], CreateSubscriptionRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_145 = typeof float64 !== "undefined" && float64) === "function" ? _145 : Object)
], CreateSubscriptionRequest.prototype, "RequestedPublishingInterval", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_146 = typeof uint32 !== "undefined" && uint32) === "function" ? _146 : Object)
], CreateSubscriptionRequest.prototype, "RequestedLifetimeCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_147 = typeof uint32 !== "undefined" && uint32) === "function" ? _147 : Object)
], CreateSubscriptionRequest.prototype, "RequestedMaxKeepAliveCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_148 = typeof uint32 !== "undefined" && uint32) === "function" ? _148 : Object)
], CreateSubscriptionRequest.prototype, "MaxNotificationsPerPublish", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], CreateSubscriptionRequest.prototype, "PublishingEnabled", void 0);
__decorate([
    exports.Type('uint8'),
    __metadata("design:type", typeof (_149 = typeof uint8 !== "undefined" && uint8) === "function" ? _149 : Object)
], CreateSubscriptionRequest.prototype, "Priority", void 0);
exports.CreateSubscriptionRequest = CreateSubscriptionRequest;
class CreateSubscriptionResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.SubscriptionId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SubscriptionId, (_d !== null && _d !== void 0 ? _d : 0));
        this.RevisedPublishingInterval = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.RevisedPublishingInterval, (_f !== null && _f !== void 0 ? _f : 0));
        this.RevisedLifetimeCount = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.RevisedLifetimeCount, (_h !== null && _h !== void 0 ? _h : 0));
        this.RevisedMaxKeepAliveCount = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.RevisedMaxKeepAliveCount, (_k !== null && _k !== void 0 ? _k : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], CreateSubscriptionResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_150 = typeof uint32 !== "undefined" && uint32) === "function" ? _150 : Object)
], CreateSubscriptionResponse.prototype, "SubscriptionId", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_151 = typeof float64 !== "undefined" && float64) === "function" ? _151 : Object)
], CreateSubscriptionResponse.prototype, "RevisedPublishingInterval", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_152 = typeof uint32 !== "undefined" && uint32) === "function" ? _152 : Object)
], CreateSubscriptionResponse.prototype, "RevisedLifetimeCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_153 = typeof uint32 !== "undefined" && uint32) === "function" ? _153 : Object)
], CreateSubscriptionResponse.prototype, "RevisedMaxKeepAliveCount", void 0);
exports.CreateSubscriptionResponse = CreateSubscriptionResponse;
class ModifySubscriptionRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.SubscriptionId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SubscriptionId, (_d !== null && _d !== void 0 ? _d : 0));
        this.RequestedPublishingInterval = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.RequestedPublishingInterval, (_f !== null && _f !== void 0 ? _f : 0));
        this.RequestedLifetimeCount = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.RequestedLifetimeCount, (_h !== null && _h !== void 0 ? _h : 0));
        this.RequestedMaxKeepAliveCount = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.RequestedMaxKeepAliveCount, (_k !== null && _k !== void 0 ? _k : 0));
        this.MaxNotificationsPerPublish = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.MaxNotificationsPerPublish, (_m !== null && _m !== void 0 ? _m : 0));
        this.Priority = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.Priority, (_p !== null && _p !== void 0 ? _p : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], ModifySubscriptionRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_154 = typeof uint32 !== "undefined" && uint32) === "function" ? _154 : Object)
], ModifySubscriptionRequest.prototype, "SubscriptionId", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_155 = typeof float64 !== "undefined" && float64) === "function" ? _155 : Object)
], ModifySubscriptionRequest.prototype, "RequestedPublishingInterval", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_156 = typeof uint32 !== "undefined" && uint32) === "function" ? _156 : Object)
], ModifySubscriptionRequest.prototype, "RequestedLifetimeCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_157 = typeof uint32 !== "undefined" && uint32) === "function" ? _157 : Object)
], ModifySubscriptionRequest.prototype, "RequestedMaxKeepAliveCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_158 = typeof uint32 !== "undefined" && uint32) === "function" ? _158 : Object)
], ModifySubscriptionRequest.prototype, "MaxNotificationsPerPublish", void 0);
__decorate([
    exports.Type('uint8'),
    __metadata("design:type", typeof (_159 = typeof uint8 !== "undefined" && uint8) === "function" ? _159 : Object)
], ModifySubscriptionRequest.prototype, "Priority", void 0);
exports.ModifySubscriptionRequest = ModifySubscriptionRequest;
class ModifySubscriptionResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.RevisedPublishingInterval = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.RevisedPublishingInterval, (_d !== null && _d !== void 0 ? _d : 0));
        this.RevisedLifetimeCount = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.RevisedLifetimeCount, (_f !== null && _f !== void 0 ? _f : 0));
        this.RevisedMaxKeepAliveCount = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.RevisedMaxKeepAliveCount, (_h !== null && _h !== void 0 ? _h : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], ModifySubscriptionResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_160 = typeof float64 !== "undefined" && float64) === "function" ? _160 : Object)
], ModifySubscriptionResponse.prototype, "RevisedPublishingInterval", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_161 = typeof uint32 !== "undefined" && uint32) === "function" ? _161 : Object)
], ModifySubscriptionResponse.prototype, "RevisedLifetimeCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_162 = typeof uint32 !== "undefined" && uint32) === "function" ? _162 : Object)
], ModifySubscriptionResponse.prototype, "RevisedMaxKeepAliveCount", void 0);
exports.ModifySubscriptionResponse = ModifySubscriptionResponse;
class SetPublishingModeRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.PublishingEnabled = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.PublishingEnabled, (_d !== null && _d !== void 0 ? _d : false));
        this.SubscriptionIds = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.SubscriptionIds, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], SetPublishingModeRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], SetPublishingModeRequest.prototype, "PublishingEnabled", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], SetPublishingModeRequest.prototype, "SubscriptionIds", void 0);
exports.SetPublishingModeRequest = SetPublishingModeRequest;
class SetPublishingModeResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], SetPublishingModeResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], SetPublishingModeResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], SetPublishingModeResponse.prototype, "DiagnosticInfos", void 0);
exports.SetPublishingModeResponse = SetPublishingModeResponse;
class NotificationMessage {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.SequenceNumber = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.SequenceNumber, (_b !== null && _b !== void 0 ? _b : 0));
        this.PublishTime = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.PublishTime, (_d !== null && _d !== void 0 ? _d : new Date()));
        this.NotificationData = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.NotificationData, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_163 = typeof uint32 !== "undefined" && uint32) === "function" ? _163 : Object)
], NotificationMessage.prototype, "SequenceNumber", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], NotificationMessage.prototype, "PublishTime", void 0);
__decorate([
    exports.TypeArray('ExtensionObject'),
    __metadata("design:type", Object)
], NotificationMessage.prototype, "NotificationData", void 0);
exports.NotificationMessage = NotificationMessage;
class MonitoredItemNotification {
    constructor(options) {
        var _a, _b, _c, _d;
        this.ClientHandle = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ClientHandle, (_b !== null && _b !== void 0 ? _b : 0));
        this.Value = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Value, (_d !== null && _d !== void 0 ? _d : new DataValue_1.default()));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_164 = typeof uint32 !== "undefined" && uint32) === "function" ? _164 : Object)
], MonitoredItemNotification.prototype, "ClientHandle", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", DataValue_1.default)
], MonitoredItemNotification.prototype, "Value", void 0);
exports.MonitoredItemNotification = MonitoredItemNotification;
class EventFieldList {
    constructor(options) {
        var _a, _b, _c, _d;
        this.ClientHandle = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ClientHandle, (_b !== null && _b !== void 0 ? _b : 0));
        this.EventFields = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.EventFields, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_165 = typeof uint32 !== "undefined" && uint32) === "function" ? _165 : Object)
], EventFieldList.prototype, "ClientHandle", void 0);
__decorate([
    exports.TypeArray('Variant'),
    __metadata("design:type", Object)
], EventFieldList.prototype, "EventFields", void 0);
exports.EventFieldList = EventFieldList;
class SubscriptionAcknowledgement {
    constructor(options) {
        var _a, _b, _c, _d;
        this.SubscriptionId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.SubscriptionId, (_b !== null && _b !== void 0 ? _b : 0));
        this.SequenceNumber = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SequenceNumber, (_d !== null && _d !== void 0 ? _d : 0));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_166 = typeof uint32 !== "undefined" && uint32) === "function" ? _166 : Object)
], SubscriptionAcknowledgement.prototype, "SubscriptionId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_167 = typeof uint32 !== "undefined" && uint32) === "function" ? _167 : Object)
], SubscriptionAcknowledgement.prototype, "SequenceNumber", void 0);
exports.SubscriptionAcknowledgement = SubscriptionAcknowledgement;
class PublishRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.SubscriptionAcknowledgements = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SubscriptionAcknowledgements, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], PublishRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.TypeArray('SubscriptionAcknowledgement'),
    __metadata("design:type", Object)
], PublishRequest.prototype, "SubscriptionAcknowledgements", void 0);
exports.PublishRequest = PublishRequest;
class PublishResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.SubscriptionId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SubscriptionId, (_d !== null && _d !== void 0 ? _d : 0));
        this.AvailableSequenceNumbers = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.AvailableSequenceNumbers, (_f !== null && _f !== void 0 ? _f : null));
        this.MoreNotifications = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.MoreNotifications, (_h !== null && _h !== void 0 ? _h : false));
        this.NotificationMessage = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.NotificationMessage, (_k !== null && _k !== void 0 ? _k : new NotificationMessage()));
        this.Results = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.Results, (_m !== null && _m !== void 0 ? _m : null));
        this.DiagnosticInfos = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.DiagnosticInfos, (_p !== null && _p !== void 0 ? _p : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], PublishResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_168 = typeof uint32 !== "undefined" && uint32) === "function" ? _168 : Object)
], PublishResponse.prototype, "SubscriptionId", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], PublishResponse.prototype, "AvailableSequenceNumbers", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], PublishResponse.prototype, "MoreNotifications", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NotificationMessage)
], PublishResponse.prototype, "NotificationMessage", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], PublishResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], PublishResponse.prototype, "DiagnosticInfos", void 0);
exports.PublishResponse = PublishResponse;
class RepublishRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.SubscriptionId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SubscriptionId, (_d !== null && _d !== void 0 ? _d : 0));
        this.RetransmitSequenceNumber = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.RetransmitSequenceNumber, (_f !== null && _f !== void 0 ? _f : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], RepublishRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_169 = typeof uint32 !== "undefined" && uint32) === "function" ? _169 : Object)
], RepublishRequest.prototype, "SubscriptionId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_170 = typeof uint32 !== "undefined" && uint32) === "function" ? _170 : Object)
], RepublishRequest.prototype, "RetransmitSequenceNumber", void 0);
exports.RepublishRequest = RepublishRequest;
class RepublishResponse {
    constructor(options) {
        var _a, _b, _c, _d;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.NotificationMessage = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.NotificationMessage, (_d !== null && _d !== void 0 ? _d : new NotificationMessage()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], RepublishResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NotificationMessage)
], RepublishResponse.prototype, "NotificationMessage", void 0);
exports.RepublishResponse = RepublishResponse;
class TransferResult {
    constructor(options) {
        var _a, _b, _c, _d;
        this.StatusCode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.StatusCode, (_b !== null && _b !== void 0 ? _b : StatusCode_1.StatusCodeOK));
        this.AvailableSequenceNumbers = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.AvailableSequenceNumbers, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_171 = typeof StatusCode !== "undefined" && StatusCode) === "function" ? _171 : Object)
], TransferResult.prototype, "StatusCode", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], TransferResult.prototype, "AvailableSequenceNumbers", void 0);
exports.TransferResult = TransferResult;
class TransferSubscriptionsRequest {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.SubscriptionIds = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SubscriptionIds, (_d !== null && _d !== void 0 ? _d : null));
        this.SendInitialValues = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.SendInitialValues, (_f !== null && _f !== void 0 ? _f : false));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], TransferSubscriptionsRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], TransferSubscriptionsRequest.prototype, "SubscriptionIds", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], TransferSubscriptionsRequest.prototype, "SendInitialValues", void 0);
exports.TransferSubscriptionsRequest = TransferSubscriptionsRequest;
class TransferSubscriptionsResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], TransferSubscriptionsResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('TransferResult'),
    __metadata("design:type", Object)
], TransferSubscriptionsResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], TransferSubscriptionsResponse.prototype, "DiagnosticInfos", void 0);
exports.TransferSubscriptionsResponse = TransferSubscriptionsResponse;
class DeleteSubscriptionsRequest {
    constructor(options) {
        var _a, _b, _c, _d;
        this.RequestHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.RequestHeader, (_b !== null && _b !== void 0 ? _b : new RequestHeader()));
        this.SubscriptionIds = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SubscriptionIds, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", RequestHeader)
], DeleteSubscriptionsRequest.prototype, "RequestHeader", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], DeleteSubscriptionsRequest.prototype, "SubscriptionIds", void 0);
exports.DeleteSubscriptionsRequest = DeleteSubscriptionsRequest;
class DeleteSubscriptionsResponse {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ResponseHeader = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ResponseHeader, (_b !== null && _b !== void 0 ? _b : new ResponseHeader()));
        this.Results = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Results, (_d !== null && _d !== void 0 ? _d : null));
        this.DiagnosticInfos = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DiagnosticInfos, (_f !== null && _f !== void 0 ? _f : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", ResponseHeader)
], DeleteSubscriptionsResponse.prototype, "ResponseHeader", void 0);
__decorate([
    exports.TypeArray('uint32'),
    __metadata("design:type", Object)
], DeleteSubscriptionsResponse.prototype, "Results", void 0);
__decorate([
    exports.TypeArray('DiagnosticInfo'),
    __metadata("design:type", Object)
], DeleteSubscriptionsResponse.prototype, "DiagnosticInfos", void 0);
exports.DeleteSubscriptionsResponse = DeleteSubscriptionsResponse;
class BuildInfo {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.ProductUri = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ProductUri, (_b !== null && _b !== void 0 ? _b : ''));
        this.ManufacturerName = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ManufacturerName, (_d !== null && _d !== void 0 ? _d : ''));
        this.ProductName = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ProductName, (_f !== null && _f !== void 0 ? _f : ''));
        this.SoftwareVersion = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.SoftwareVersion, (_h !== null && _h !== void 0 ? _h : ''));
        this.BuildNumber = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.BuildNumber, (_k !== null && _k !== void 0 ? _k : ''));
        this.BuildDate = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.BuildDate, (_m !== null && _m !== void 0 ? _m : new Date()));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], BuildInfo.prototype, "ProductUri", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], BuildInfo.prototype, "ManufacturerName", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], BuildInfo.prototype, "ProductName", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], BuildInfo.prototype, "SoftwareVersion", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], BuildInfo.prototype, "BuildNumber", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], BuildInfo.prototype, "BuildDate", void 0);
exports.BuildInfo = BuildInfo;
class RedundantServerDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.ServerId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ServerId, (_b !== null && _b !== void 0 ? _b : ''));
        this.ServiceLevel = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ServiceLevel, (_d !== null && _d !== void 0 ? _d : 0));
        this.ServerState = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ServerState, (_f !== null && _f !== void 0 ? _f : exports.ServerStateRunning));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], RedundantServerDataType.prototype, "ServerId", void 0);
__decorate([
    exports.Type('uint8'),
    __metadata("design:type", typeof (_172 = typeof uint8 !== "undefined" && uint8) === "function" ? _172 : Object)
], RedundantServerDataType.prototype, "ServiceLevel", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_173 = typeof ServerState !== "undefined" && ServerState) === "function" ? _173 : Object)
], RedundantServerDataType.prototype, "ServerState", void 0);
exports.RedundantServerDataType = RedundantServerDataType;
class EndpointUrlListDataType {
    constructor(options) {
        var _a, _b;
        this.EndpointUrlList = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.EndpointUrlList, (_b !== null && _b !== void 0 ? _b : null));
    }
}
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], EndpointUrlListDataType.prototype, "EndpointUrlList", void 0);
exports.EndpointUrlListDataType = EndpointUrlListDataType;
class NetworkGroupDataType {
    constructor(options) {
        var _a, _b, _c, _d;
        this.ServerUri = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ServerUri, (_b !== null && _b !== void 0 ? _b : ''));
        this.NetworkPaths = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.NetworkPaths, (_d !== null && _d !== void 0 ? _d : null));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], NetworkGroupDataType.prototype, "ServerUri", void 0);
__decorate([
    exports.TypeArray('EndpointUrlListDataType'),
    __metadata("design:type", Object)
], NetworkGroupDataType.prototype, "NetworkPaths", void 0);
exports.NetworkGroupDataType = NetworkGroupDataType;
class SamplingIntervalDiagnosticsDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.SamplingInterval = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.SamplingInterval, (_b !== null && _b !== void 0 ? _b : 0));
        this.MonitoredItemCount = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.MonitoredItemCount, (_d !== null && _d !== void 0 ? _d : 0));
        this.MaxMonitoredItemCount = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.MaxMonitoredItemCount, (_f !== null && _f !== void 0 ? _f : 0));
        this.DisabledMonitoredItemCount = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.DisabledMonitoredItemCount, (_h !== null && _h !== void 0 ? _h : 0));
    }
}
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_174 = typeof float64 !== "undefined" && float64) === "function" ? _174 : Object)
], SamplingIntervalDiagnosticsDataType.prototype, "SamplingInterval", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_175 = typeof uint32 !== "undefined" && uint32) === "function" ? _175 : Object)
], SamplingIntervalDiagnosticsDataType.prototype, "MonitoredItemCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_176 = typeof uint32 !== "undefined" && uint32) === "function" ? _176 : Object)
], SamplingIntervalDiagnosticsDataType.prototype, "MaxMonitoredItemCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_177 = typeof uint32 !== "undefined" && uint32) === "function" ? _177 : Object)
], SamplingIntervalDiagnosticsDataType.prototype, "DisabledMonitoredItemCount", void 0);
exports.SamplingIntervalDiagnosticsDataType = SamplingIntervalDiagnosticsDataType;
class ServerDiagnosticsSummaryDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        this.ServerViewCount = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.ServerViewCount, (_b !== null && _b !== void 0 ? _b : 0));
        this.CurrentSessionCount = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.CurrentSessionCount, (_d !== null && _d !== void 0 ? _d : 0));
        this.CumulatedSessionCount = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.CumulatedSessionCount, (_f !== null && _f !== void 0 ? _f : 0));
        this.SecurityRejectedSessionCount = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.SecurityRejectedSessionCount, (_h !== null && _h !== void 0 ? _h : 0));
        this.RejectedSessionCount = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.RejectedSessionCount, (_k !== null && _k !== void 0 ? _k : 0));
        this.SessionTimeoutCount = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.SessionTimeoutCount, (_m !== null && _m !== void 0 ? _m : 0));
        this.SessionAbortCount = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.SessionAbortCount, (_p !== null && _p !== void 0 ? _p : 0));
        this.CurrentSubscriptionCount = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.CurrentSubscriptionCount, (_r !== null && _r !== void 0 ? _r : 0));
        this.CumulatedSubscriptionCount = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.CumulatedSubscriptionCount, (_t !== null && _t !== void 0 ? _t : 0));
        this.PublishingIntervalCount = (_v = (_u = options) === null || _u === void 0 ? void 0 : _u.PublishingIntervalCount, (_v !== null && _v !== void 0 ? _v : 0));
        this.SecurityRejectedRequestsCount = (_x = (_w = options) === null || _w === void 0 ? void 0 : _w.SecurityRejectedRequestsCount, (_x !== null && _x !== void 0 ? _x : 0));
        this.RejectedRequestsCount = (_z = (_y = options) === null || _y === void 0 ? void 0 : _y.RejectedRequestsCount, (_z !== null && _z !== void 0 ? _z : 0));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_178 = typeof uint32 !== "undefined" && uint32) === "function" ? _178 : Object)
], ServerDiagnosticsSummaryDataType.prototype, "ServerViewCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_179 = typeof uint32 !== "undefined" && uint32) === "function" ? _179 : Object)
], ServerDiagnosticsSummaryDataType.prototype, "CurrentSessionCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_180 = typeof uint32 !== "undefined" && uint32) === "function" ? _180 : Object)
], ServerDiagnosticsSummaryDataType.prototype, "CumulatedSessionCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_181 = typeof uint32 !== "undefined" && uint32) === "function" ? _181 : Object)
], ServerDiagnosticsSummaryDataType.prototype, "SecurityRejectedSessionCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_182 = typeof uint32 !== "undefined" && uint32) === "function" ? _182 : Object)
], ServerDiagnosticsSummaryDataType.prototype, "RejectedSessionCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_183 = typeof uint32 !== "undefined" && uint32) === "function" ? _183 : Object)
], ServerDiagnosticsSummaryDataType.prototype, "SessionTimeoutCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_184 = typeof uint32 !== "undefined" && uint32) === "function" ? _184 : Object)
], ServerDiagnosticsSummaryDataType.prototype, "SessionAbortCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_185 = typeof uint32 !== "undefined" && uint32) === "function" ? _185 : Object)
], ServerDiagnosticsSummaryDataType.prototype, "CurrentSubscriptionCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_186 = typeof uint32 !== "undefined" && uint32) === "function" ? _186 : Object)
], ServerDiagnosticsSummaryDataType.prototype, "CumulatedSubscriptionCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_187 = typeof uint32 !== "undefined" && uint32) === "function" ? _187 : Object)
], ServerDiagnosticsSummaryDataType.prototype, "PublishingIntervalCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_188 = typeof uint32 !== "undefined" && uint32) === "function" ? _188 : Object)
], ServerDiagnosticsSummaryDataType.prototype, "SecurityRejectedRequestsCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_189 = typeof uint32 !== "undefined" && uint32) === "function" ? _189 : Object)
], ServerDiagnosticsSummaryDataType.prototype, "RejectedRequestsCount", void 0);
exports.ServerDiagnosticsSummaryDataType = ServerDiagnosticsSummaryDataType;
class ServerStatusDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.StartTime = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.StartTime, (_b !== null && _b !== void 0 ? _b : new Date()));
        this.CurrentTime = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.CurrentTime, (_d !== null && _d !== void 0 ? _d : new Date()));
        this.State = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.State, (_f !== null && _f !== void 0 ? _f : exports.ServerStateRunning));
        this.BuildInfo = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.BuildInfo, (_h !== null && _h !== void 0 ? _h : new BuildInfo()));
        this.SecondsTillShutdown = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.SecondsTillShutdown, (_k !== null && _k !== void 0 ? _k : 0));
        this.ShutdownReason = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.ShutdownReason, (_m !== null && _m !== void 0 ? _m : new LocalizedText_1.default()));
    }
}
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], ServerStatusDataType.prototype, "StartTime", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], ServerStatusDataType.prototype, "CurrentTime", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_190 = typeof ServerState !== "undefined" && ServerState) === "function" ? _190 : Object)
], ServerStatusDataType.prototype, "State", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", BuildInfo)
], ServerStatusDataType.prototype, "BuildInfo", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_191 = typeof uint32 !== "undefined" && uint32) === "function" ? _191 : Object)
], ServerStatusDataType.prototype, "SecondsTillShutdown", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], ServerStatusDataType.prototype, "ShutdownReason", void 0);
exports.ServerStatusDataType = ServerStatusDataType;
class ServiceCounterDataType {
    constructor(options) {
        var _a, _b, _c, _d;
        this.TotalCount = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.TotalCount, (_b !== null && _b !== void 0 ? _b : 0));
        this.ErrorCount = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ErrorCount, (_d !== null && _d !== void 0 ? _d : 0));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_192 = typeof uint32 !== "undefined" && uint32) === "function" ? _192 : Object)
], ServiceCounterDataType.prototype, "TotalCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_193 = typeof uint32 !== "undefined" && uint32) === "function" ? _193 : Object)
], ServiceCounterDataType.prototype, "ErrorCount", void 0);
exports.ServiceCounterDataType = ServiceCounterDataType;
class SessionDiagnosticsDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61;
        this.SessionId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.SessionId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.SessionName = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SessionName, (_d !== null && _d !== void 0 ? _d : ''));
        this.ClientDescription = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ClientDescription, (_f !== null && _f !== void 0 ? _f : new ApplicationDescription()));
        this.ServerUri = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.ServerUri, (_h !== null && _h !== void 0 ? _h : ''));
        this.EndpointUrl = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.EndpointUrl, (_k !== null && _k !== void 0 ? _k : ''));
        this.LocaleIds = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.LocaleIds, (_m !== null && _m !== void 0 ? _m : null));
        this.ActualSessionTimeout = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.ActualSessionTimeout, (_p !== null && _p !== void 0 ? _p : 0));
        this.MaxResponseMessageSize = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.MaxResponseMessageSize, (_r !== null && _r !== void 0 ? _r : 0));
        this.ClientConnectionTime = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.ClientConnectionTime, (_t !== null && _t !== void 0 ? _t : new Date()));
        this.ClientLastContactTime = (_v = (_u = options) === null || _u === void 0 ? void 0 : _u.ClientLastContactTime, (_v !== null && _v !== void 0 ? _v : new Date()));
        this.CurrentSubscriptionsCount = (_x = (_w = options) === null || _w === void 0 ? void 0 : _w.CurrentSubscriptionsCount, (_x !== null && _x !== void 0 ? _x : 0));
        this.CurrentMonitoredItemsCount = (_z = (_y = options) === null || _y === void 0 ? void 0 : _y.CurrentMonitoredItemsCount, (_z !== null && _z !== void 0 ? _z : 0));
        this.CurrentPublishRequestsInQueue = (_1 = (_0 = options) === null || _0 === void 0 ? void 0 : _0.CurrentPublishRequestsInQueue, (_1 !== null && _1 !== void 0 ? _1 : 0));
        this.TotalRequestCount = (_3 = (_2 = options) === null || _2 === void 0 ? void 0 : _2.TotalRequestCount, (_3 !== null && _3 !== void 0 ? _3 : new ServiceCounterDataType()));
        this.UnauthorizedRequestCount = (_5 = (_4 = options) === null || _4 === void 0 ? void 0 : _4.UnauthorizedRequestCount, (_5 !== null && _5 !== void 0 ? _5 : 0));
        this.ReadCount = (_7 = (_6 = options) === null || _6 === void 0 ? void 0 : _6.ReadCount, (_7 !== null && _7 !== void 0 ? _7 : new ServiceCounterDataType()));
        this.HistoryReadCount = (_9 = (_8 = options) === null || _8 === void 0 ? void 0 : _8.HistoryReadCount, (_9 !== null && _9 !== void 0 ? _9 : new ServiceCounterDataType()));
        this.WriteCount = (_11 = (_10 = options) === null || _10 === void 0 ? void 0 : _10.WriteCount, (_11 !== null && _11 !== void 0 ? _11 : new ServiceCounterDataType()));
        this.HistoryUpdateCount = (_13 = (_12 = options) === null || _12 === void 0 ? void 0 : _12.HistoryUpdateCount, (_13 !== null && _13 !== void 0 ? _13 : new ServiceCounterDataType()));
        this.CallCount = (_15 = (_14 = options) === null || _14 === void 0 ? void 0 : _14.CallCount, (_15 !== null && _15 !== void 0 ? _15 : new ServiceCounterDataType()));
        this.CreateMonitoredItemsCount = (_17 = (_16 = options) === null || _16 === void 0 ? void 0 : _16.CreateMonitoredItemsCount, (_17 !== null && _17 !== void 0 ? _17 : new ServiceCounterDataType()));
        this.ModifyMonitoredItemsCount = (_19 = (_18 = options) === null || _18 === void 0 ? void 0 : _18.ModifyMonitoredItemsCount, (_19 !== null && _19 !== void 0 ? _19 : new ServiceCounterDataType()));
        this.SetMonitoringModeCount = (_21 = (_20 = options) === null || _20 === void 0 ? void 0 : _20.SetMonitoringModeCount, (_21 !== null && _21 !== void 0 ? _21 : new ServiceCounterDataType()));
        this.SetTriggeringCount = (_23 = (_22 = options) === null || _22 === void 0 ? void 0 : _22.SetTriggeringCount, (_23 !== null && _23 !== void 0 ? _23 : new ServiceCounterDataType()));
        this.DeleteMonitoredItemsCount = (_25 = (_24 = options) === null || _24 === void 0 ? void 0 : _24.DeleteMonitoredItemsCount, (_25 !== null && _25 !== void 0 ? _25 : new ServiceCounterDataType()));
        this.CreateSubscriptionCount = (_27 = (_26 = options) === null || _26 === void 0 ? void 0 : _26.CreateSubscriptionCount, (_27 !== null && _27 !== void 0 ? _27 : new ServiceCounterDataType()));
        this.ModifySubscriptionCount = (_29 = (_28 = options) === null || _28 === void 0 ? void 0 : _28.ModifySubscriptionCount, (_29 !== null && _29 !== void 0 ? _29 : new ServiceCounterDataType()));
        this.SetPublishingModeCount = (_31 = (_30 = options) === null || _30 === void 0 ? void 0 : _30.SetPublishingModeCount, (_31 !== null && _31 !== void 0 ? _31 : new ServiceCounterDataType()));
        this.PublishCount = (_33 = (_32 = options) === null || _32 === void 0 ? void 0 : _32.PublishCount, (_33 !== null && _33 !== void 0 ? _33 : new ServiceCounterDataType()));
        this.RepublishCount = (_35 = (_34 = options) === null || _34 === void 0 ? void 0 : _34.RepublishCount, (_35 !== null && _35 !== void 0 ? _35 : new ServiceCounterDataType()));
        this.TransferSubscriptionsCount = (_37 = (_36 = options) === null || _36 === void 0 ? void 0 : _36.TransferSubscriptionsCount, (_37 !== null && _37 !== void 0 ? _37 : new ServiceCounterDataType()));
        this.DeleteSubscriptionsCount = (_39 = (_38 = options) === null || _38 === void 0 ? void 0 : _38.DeleteSubscriptionsCount, (_39 !== null && _39 !== void 0 ? _39 : new ServiceCounterDataType()));
        this.AddNodesCount = (_41 = (_40 = options) === null || _40 === void 0 ? void 0 : _40.AddNodesCount, (_41 !== null && _41 !== void 0 ? _41 : new ServiceCounterDataType()));
        this.AddReferencesCount = (_43 = (_42 = options) === null || _42 === void 0 ? void 0 : _42.AddReferencesCount, (_43 !== null && _43 !== void 0 ? _43 : new ServiceCounterDataType()));
        this.DeleteNodesCount = (_45 = (_44 = options) === null || _44 === void 0 ? void 0 : _44.DeleteNodesCount, (_45 !== null && _45 !== void 0 ? _45 : new ServiceCounterDataType()));
        this.DeleteReferencesCount = (_47 = (_46 = options) === null || _46 === void 0 ? void 0 : _46.DeleteReferencesCount, (_47 !== null && _47 !== void 0 ? _47 : new ServiceCounterDataType()));
        this.BrowseCount = (_49 = (_48 = options) === null || _48 === void 0 ? void 0 : _48.BrowseCount, (_49 !== null && _49 !== void 0 ? _49 : new ServiceCounterDataType()));
        this.BrowseNextCount = (_51 = (_50 = options) === null || _50 === void 0 ? void 0 : _50.BrowseNextCount, (_51 !== null && _51 !== void 0 ? _51 : new ServiceCounterDataType()));
        this.TranslateBrowsePathsToNodeIdsCount = (_53 = (_52 = options) === null || _52 === void 0 ? void 0 : _52.TranslateBrowsePathsToNodeIdsCount, (_53 !== null && _53 !== void 0 ? _53 : new ServiceCounterDataType()));
        this.QueryFirstCount = (_55 = (_54 = options) === null || _54 === void 0 ? void 0 : _54.QueryFirstCount, (_55 !== null && _55 !== void 0 ? _55 : new ServiceCounterDataType()));
        this.QueryNextCount = (_57 = (_56 = options) === null || _56 === void 0 ? void 0 : _56.QueryNextCount, (_57 !== null && _57 !== void 0 ? _57 : new ServiceCounterDataType()));
        this.RegisterNodesCount = (_59 = (_58 = options) === null || _58 === void 0 ? void 0 : _58.RegisterNodesCount, (_59 !== null && _59 !== void 0 ? _59 : new ServiceCounterDataType()));
        this.UnregisterNodesCount = (_61 = (_60 = options) === null || _60 === void 0 ? void 0 : _60.UnregisterNodesCount, (_61 !== null && _61 !== void 0 ? _61 : new ServiceCounterDataType()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], SessionDiagnosticsDataType.prototype, "SessionId", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], SessionDiagnosticsDataType.prototype, "SessionName", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ApplicationDescription)
], SessionDiagnosticsDataType.prototype, "ClientDescription", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], SessionDiagnosticsDataType.prototype, "ServerUri", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], SessionDiagnosticsDataType.prototype, "EndpointUrl", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], SessionDiagnosticsDataType.prototype, "LocaleIds", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_194 = typeof float64 !== "undefined" && float64) === "function" ? _194 : Object)
], SessionDiagnosticsDataType.prototype, "ActualSessionTimeout", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_195 = typeof uint32 !== "undefined" && uint32) === "function" ? _195 : Object)
], SessionDiagnosticsDataType.prototype, "MaxResponseMessageSize", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], SessionDiagnosticsDataType.prototype, "ClientConnectionTime", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], SessionDiagnosticsDataType.prototype, "ClientLastContactTime", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_196 = typeof uint32 !== "undefined" && uint32) === "function" ? _196 : Object)
], SessionDiagnosticsDataType.prototype, "CurrentSubscriptionsCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_197 = typeof uint32 !== "undefined" && uint32) === "function" ? _197 : Object)
], SessionDiagnosticsDataType.prototype, "CurrentMonitoredItemsCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_198 = typeof uint32 !== "undefined" && uint32) === "function" ? _198 : Object)
], SessionDiagnosticsDataType.prototype, "CurrentPublishRequestsInQueue", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "TotalRequestCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_199 = typeof uint32 !== "undefined" && uint32) === "function" ? _199 : Object)
], SessionDiagnosticsDataType.prototype, "UnauthorizedRequestCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "ReadCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "HistoryReadCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "WriteCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "HistoryUpdateCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "CallCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "CreateMonitoredItemsCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "ModifyMonitoredItemsCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "SetMonitoringModeCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "SetTriggeringCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "DeleteMonitoredItemsCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "CreateSubscriptionCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "ModifySubscriptionCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "SetPublishingModeCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "PublishCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "RepublishCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "TransferSubscriptionsCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "DeleteSubscriptionsCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "AddNodesCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "AddReferencesCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "DeleteNodesCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "DeleteReferencesCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "BrowseCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "BrowseNextCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "TranslateBrowsePathsToNodeIdsCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "QueryFirstCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "QueryNextCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "RegisterNodesCount", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", ServiceCounterDataType)
], SessionDiagnosticsDataType.prototype, "UnregisterNodesCount", void 0);
exports.SessionDiagnosticsDataType = SessionDiagnosticsDataType;
class SessionSecurityDiagnosticsDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        this.SessionId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.SessionId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.ClientUserIdOfSession = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.ClientUserIdOfSession, (_d !== null && _d !== void 0 ? _d : ''));
        this.ClientUserIdHistory = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.ClientUserIdHistory, (_f !== null && _f !== void 0 ? _f : null));
        this.AuthenticationMechanism = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.AuthenticationMechanism, (_h !== null && _h !== void 0 ? _h : ''));
        this.Encoding = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.Encoding, (_k !== null && _k !== void 0 ? _k : ''));
        this.TransportProtocol = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.TransportProtocol, (_m !== null && _m !== void 0 ? _m : ''));
        this.SecurityMode = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.SecurityMode, (_p !== null && _p !== void 0 ? _p : exports.MessageSecurityModeInvalid));
        this.SecurityPolicyUri = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.SecurityPolicyUri, (_r !== null && _r !== void 0 ? _r : ''));
        this.ClientCertificate = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.ClientCertificate, (_t !== null && _t !== void 0 ? _t : new Uint8Array()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], SessionSecurityDiagnosticsDataType.prototype, "SessionId", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], SessionSecurityDiagnosticsDataType.prototype, "ClientUserIdOfSession", void 0);
__decorate([
    exports.TypeArray('string'),
    __metadata("design:type", Object)
], SessionSecurityDiagnosticsDataType.prototype, "ClientUserIdHistory", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], SessionSecurityDiagnosticsDataType.prototype, "AuthenticationMechanism", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], SessionSecurityDiagnosticsDataType.prototype, "Encoding", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], SessionSecurityDiagnosticsDataType.prototype, "TransportProtocol", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_200 = typeof MessageSecurityMode !== "undefined" && MessageSecurityMode) === "function" ? _200 : Object)
], SessionSecurityDiagnosticsDataType.prototype, "SecurityMode", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], SessionSecurityDiagnosticsDataType.prototype, "SecurityPolicyUri", void 0);
__decorate([
    exports.Type('ByteString'),
    __metadata("design:type", typeof (_201 = typeof ByteString !== "undefined" && ByteString) === "function" ? _201 : Object)
], SessionSecurityDiagnosticsDataType.prototype, "ClientCertificate", void 0);
exports.SessionSecurityDiagnosticsDataType = SessionSecurityDiagnosticsDataType;
class StatusResult {
    constructor(options) {
        var _a, _b, _c, _d;
        this.StatusCode = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.StatusCode, (_b !== null && _b !== void 0 ? _b : StatusCode_1.StatusCodeOK));
        this.DiagnosticInfo = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.DiagnosticInfo, (_d !== null && _d !== void 0 ? _d : new DiagnosticInfo_1.default()));
    }
}
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_202 = typeof StatusCode !== "undefined" && StatusCode) === "function" ? _202 : Object)
], StatusResult.prototype, "StatusCode", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", DiagnosticInfo_1.default)
], StatusResult.prototype, "DiagnosticInfo", void 0);
exports.StatusResult = StatusResult;
class SubscriptionDiagnosticsDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37;
        this.SessionId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.SessionId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.SubscriptionId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.SubscriptionId, (_d !== null && _d !== void 0 ? _d : 0));
        this.Priority = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.Priority, (_f !== null && _f !== void 0 ? _f : 0));
        this.PublishingInterval = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.PublishingInterval, (_h !== null && _h !== void 0 ? _h : 0));
        this.MaxKeepAliveCount = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.MaxKeepAliveCount, (_k !== null && _k !== void 0 ? _k : 0));
        this.MaxLifetimeCount = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.MaxLifetimeCount, (_m !== null && _m !== void 0 ? _m : 0));
        this.MaxNotificationsPerPublish = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.MaxNotificationsPerPublish, (_p !== null && _p !== void 0 ? _p : 0));
        this.PublishingEnabled = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.PublishingEnabled, (_r !== null && _r !== void 0 ? _r : false));
        this.ModifyCount = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.ModifyCount, (_t !== null && _t !== void 0 ? _t : 0));
        this.EnableCount = (_v = (_u = options) === null || _u === void 0 ? void 0 : _u.EnableCount, (_v !== null && _v !== void 0 ? _v : 0));
        this.DisableCount = (_x = (_w = options) === null || _w === void 0 ? void 0 : _w.DisableCount, (_x !== null && _x !== void 0 ? _x : 0));
        this.RepublishRequestCount = (_z = (_y = options) === null || _y === void 0 ? void 0 : _y.RepublishRequestCount, (_z !== null && _z !== void 0 ? _z : 0));
        this.RepublishMessageRequestCount = (_1 = (_0 = options) === null || _0 === void 0 ? void 0 : _0.RepublishMessageRequestCount, (_1 !== null && _1 !== void 0 ? _1 : 0));
        this.RepublishMessageCount = (_3 = (_2 = options) === null || _2 === void 0 ? void 0 : _2.RepublishMessageCount, (_3 !== null && _3 !== void 0 ? _3 : 0));
        this.TransferRequestCount = (_5 = (_4 = options) === null || _4 === void 0 ? void 0 : _4.TransferRequestCount, (_5 !== null && _5 !== void 0 ? _5 : 0));
        this.TransferredToAltClientCount = (_7 = (_6 = options) === null || _6 === void 0 ? void 0 : _6.TransferredToAltClientCount, (_7 !== null && _7 !== void 0 ? _7 : 0));
        this.TransferredToSameClientCount = (_9 = (_8 = options) === null || _8 === void 0 ? void 0 : _8.TransferredToSameClientCount, (_9 !== null && _9 !== void 0 ? _9 : 0));
        this.PublishRequestCount = (_11 = (_10 = options) === null || _10 === void 0 ? void 0 : _10.PublishRequestCount, (_11 !== null && _11 !== void 0 ? _11 : 0));
        this.DataChangeNotificationsCount = (_13 = (_12 = options) === null || _12 === void 0 ? void 0 : _12.DataChangeNotificationsCount, (_13 !== null && _13 !== void 0 ? _13 : 0));
        this.EventNotificationsCount = (_15 = (_14 = options) === null || _14 === void 0 ? void 0 : _14.EventNotificationsCount, (_15 !== null && _15 !== void 0 ? _15 : 0));
        this.NotificationsCount = (_17 = (_16 = options) === null || _16 === void 0 ? void 0 : _16.NotificationsCount, (_17 !== null && _17 !== void 0 ? _17 : 0));
        this.LatePublishRequestCount = (_19 = (_18 = options) === null || _18 === void 0 ? void 0 : _18.LatePublishRequestCount, (_19 !== null && _19 !== void 0 ? _19 : 0));
        this.CurrentKeepAliveCount = (_21 = (_20 = options) === null || _20 === void 0 ? void 0 : _20.CurrentKeepAliveCount, (_21 !== null && _21 !== void 0 ? _21 : 0));
        this.CurrentLifetimeCount = (_23 = (_22 = options) === null || _22 === void 0 ? void 0 : _22.CurrentLifetimeCount, (_23 !== null && _23 !== void 0 ? _23 : 0));
        this.UnacknowledgedMessageCount = (_25 = (_24 = options) === null || _24 === void 0 ? void 0 : _24.UnacknowledgedMessageCount, (_25 !== null && _25 !== void 0 ? _25 : 0));
        this.DiscardedMessageCount = (_27 = (_26 = options) === null || _26 === void 0 ? void 0 : _26.DiscardedMessageCount, (_27 !== null && _27 !== void 0 ? _27 : 0));
        this.MonitoredItemCount = (_29 = (_28 = options) === null || _28 === void 0 ? void 0 : _28.MonitoredItemCount, (_29 !== null && _29 !== void 0 ? _29 : 0));
        this.DisabledMonitoredItemCount = (_31 = (_30 = options) === null || _30 === void 0 ? void 0 : _30.DisabledMonitoredItemCount, (_31 !== null && _31 !== void 0 ? _31 : 0));
        this.MonitoringQueueOverflowCount = (_33 = (_32 = options) === null || _32 === void 0 ? void 0 : _32.MonitoringQueueOverflowCount, (_33 !== null && _33 !== void 0 ? _33 : 0));
        this.NextSequenceNumber = (_35 = (_34 = options) === null || _34 === void 0 ? void 0 : _34.NextSequenceNumber, (_35 !== null && _35 !== void 0 ? _35 : 0));
        this.EventQueueOverFlowCount = (_37 = (_36 = options) === null || _36 === void 0 ? void 0 : _36.EventQueueOverFlowCount, (_37 !== null && _37 !== void 0 ? _37 : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], SubscriptionDiagnosticsDataType.prototype, "SessionId", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_203 = typeof uint32 !== "undefined" && uint32) === "function" ? _203 : Object)
], SubscriptionDiagnosticsDataType.prototype, "SubscriptionId", void 0);
__decorate([
    exports.Type('uint8'),
    __metadata("design:type", typeof (_204 = typeof uint8 !== "undefined" && uint8) === "function" ? _204 : Object)
], SubscriptionDiagnosticsDataType.prototype, "Priority", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_205 = typeof float64 !== "undefined" && float64) === "function" ? _205 : Object)
], SubscriptionDiagnosticsDataType.prototype, "PublishingInterval", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_206 = typeof uint32 !== "undefined" && uint32) === "function" ? _206 : Object)
], SubscriptionDiagnosticsDataType.prototype, "MaxKeepAliveCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_207 = typeof uint32 !== "undefined" && uint32) === "function" ? _207 : Object)
], SubscriptionDiagnosticsDataType.prototype, "MaxLifetimeCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_208 = typeof uint32 !== "undefined" && uint32) === "function" ? _208 : Object)
], SubscriptionDiagnosticsDataType.prototype, "MaxNotificationsPerPublish", void 0);
__decorate([
    exports.Type('boolean'),
    __metadata("design:type", Boolean)
], SubscriptionDiagnosticsDataType.prototype, "PublishingEnabled", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_209 = typeof uint32 !== "undefined" && uint32) === "function" ? _209 : Object)
], SubscriptionDiagnosticsDataType.prototype, "ModifyCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_210 = typeof uint32 !== "undefined" && uint32) === "function" ? _210 : Object)
], SubscriptionDiagnosticsDataType.prototype, "EnableCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_211 = typeof uint32 !== "undefined" && uint32) === "function" ? _211 : Object)
], SubscriptionDiagnosticsDataType.prototype, "DisableCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_212 = typeof uint32 !== "undefined" && uint32) === "function" ? _212 : Object)
], SubscriptionDiagnosticsDataType.prototype, "RepublishRequestCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_213 = typeof uint32 !== "undefined" && uint32) === "function" ? _213 : Object)
], SubscriptionDiagnosticsDataType.prototype, "RepublishMessageRequestCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_214 = typeof uint32 !== "undefined" && uint32) === "function" ? _214 : Object)
], SubscriptionDiagnosticsDataType.prototype, "RepublishMessageCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_215 = typeof uint32 !== "undefined" && uint32) === "function" ? _215 : Object)
], SubscriptionDiagnosticsDataType.prototype, "TransferRequestCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_216 = typeof uint32 !== "undefined" && uint32) === "function" ? _216 : Object)
], SubscriptionDiagnosticsDataType.prototype, "TransferredToAltClientCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_217 = typeof uint32 !== "undefined" && uint32) === "function" ? _217 : Object)
], SubscriptionDiagnosticsDataType.prototype, "TransferredToSameClientCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_218 = typeof uint32 !== "undefined" && uint32) === "function" ? _218 : Object)
], SubscriptionDiagnosticsDataType.prototype, "PublishRequestCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_219 = typeof uint32 !== "undefined" && uint32) === "function" ? _219 : Object)
], SubscriptionDiagnosticsDataType.prototype, "DataChangeNotificationsCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_220 = typeof uint32 !== "undefined" && uint32) === "function" ? _220 : Object)
], SubscriptionDiagnosticsDataType.prototype, "EventNotificationsCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_221 = typeof uint32 !== "undefined" && uint32) === "function" ? _221 : Object)
], SubscriptionDiagnosticsDataType.prototype, "NotificationsCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_222 = typeof uint32 !== "undefined" && uint32) === "function" ? _222 : Object)
], SubscriptionDiagnosticsDataType.prototype, "LatePublishRequestCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_223 = typeof uint32 !== "undefined" && uint32) === "function" ? _223 : Object)
], SubscriptionDiagnosticsDataType.prototype, "CurrentKeepAliveCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_224 = typeof uint32 !== "undefined" && uint32) === "function" ? _224 : Object)
], SubscriptionDiagnosticsDataType.prototype, "CurrentLifetimeCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_225 = typeof uint32 !== "undefined" && uint32) === "function" ? _225 : Object)
], SubscriptionDiagnosticsDataType.prototype, "UnacknowledgedMessageCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_226 = typeof uint32 !== "undefined" && uint32) === "function" ? _226 : Object)
], SubscriptionDiagnosticsDataType.prototype, "DiscardedMessageCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_227 = typeof uint32 !== "undefined" && uint32) === "function" ? _227 : Object)
], SubscriptionDiagnosticsDataType.prototype, "MonitoredItemCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_228 = typeof uint32 !== "undefined" && uint32) === "function" ? _228 : Object)
], SubscriptionDiagnosticsDataType.prototype, "DisabledMonitoredItemCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_229 = typeof uint32 !== "undefined" && uint32) === "function" ? _229 : Object)
], SubscriptionDiagnosticsDataType.prototype, "MonitoringQueueOverflowCount", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_230 = typeof uint32 !== "undefined" && uint32) === "function" ? _230 : Object)
], SubscriptionDiagnosticsDataType.prototype, "NextSequenceNumber", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_231 = typeof uint32 !== "undefined" && uint32) === "function" ? _231 : Object)
], SubscriptionDiagnosticsDataType.prototype, "EventQueueOverFlowCount", void 0);
exports.SubscriptionDiagnosticsDataType = SubscriptionDiagnosticsDataType;
class ModelChangeStructureDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.Affected = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Affected, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.AffectedType = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.AffectedType, (_d !== null && _d !== void 0 ? _d : new NodeId_1.default()));
        this.Verb = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.Verb, (_f !== null && _f !== void 0 ? _f : 0));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], ModelChangeStructureDataType.prototype, "Affected", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], ModelChangeStructureDataType.prototype, "AffectedType", void 0);
__decorate([
    exports.Type('uint8'),
    __metadata("design:type", typeof (_232 = typeof uint8 !== "undefined" && uint8) === "function" ? _232 : Object)
], ModelChangeStructureDataType.prototype, "Verb", void 0);
exports.ModelChangeStructureDataType = ModelChangeStructureDataType;
class SemanticChangeStructureDataType {
    constructor(options) {
        var _a, _b, _c, _d;
        this.Affected = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Affected, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.AffectedType = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.AffectedType, (_d !== null && _d !== void 0 ? _d : new NodeId_1.default()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], SemanticChangeStructureDataType.prototype, "Affected", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], SemanticChangeStructureDataType.prototype, "AffectedType", void 0);
exports.SemanticChangeStructureDataType = SemanticChangeStructureDataType;
class Range {
    constructor(options) {
        var _a, _b, _c, _d;
        this.Low = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Low, (_b !== null && _b !== void 0 ? _b : 0));
        this.High = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.High, (_d !== null && _d !== void 0 ? _d : 0));
    }
}
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_233 = typeof float64 !== "undefined" && float64) === "function" ? _233 : Object)
], Range.prototype, "Low", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_234 = typeof float64 !== "undefined" && float64) === "function" ? _234 : Object)
], Range.prototype, "High", void 0);
exports.Range = Range;
class EUInformation {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.NamespaceUri = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.NamespaceUri, (_b !== null && _b !== void 0 ? _b : ''));
        this.UnitId = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.UnitId, (_d !== null && _d !== void 0 ? _d : 0));
        this.DisplayName = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.DisplayName, (_f !== null && _f !== void 0 ? _f : new LocalizedText_1.default()));
        this.Description = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.Description, (_h !== null && _h !== void 0 ? _h : new LocalizedText_1.default()));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], EUInformation.prototype, "NamespaceUri", void 0);
__decorate([
    exports.Type('int32'),
    __metadata("design:type", typeof (_235 = typeof int32 !== "undefined" && int32) === "function" ? _235 : Object)
], EUInformation.prototype, "UnitId", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], EUInformation.prototype, "DisplayName", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], EUInformation.prototype, "Description", void 0);
exports.EUInformation = EUInformation;
class ComplexNumberType {
    constructor(options) {
        var _a, _b, _c, _d;
        this.Real = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Real, (_b !== null && _b !== void 0 ? _b : 0));
        this.Imaginary = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Imaginary, (_d !== null && _d !== void 0 ? _d : 0));
    }
}
__decorate([
    exports.Type('float32'),
    __metadata("design:type", typeof (_236 = typeof float32 !== "undefined" && float32) === "function" ? _236 : Object)
], ComplexNumberType.prototype, "Real", void 0);
__decorate([
    exports.Type('float32'),
    __metadata("design:type", typeof (_237 = typeof float32 !== "undefined" && float32) === "function" ? _237 : Object)
], ComplexNumberType.prototype, "Imaginary", void 0);
exports.ComplexNumberType = ComplexNumberType;
class DoubleComplexNumberType {
    constructor(options) {
        var _a, _b, _c, _d;
        this.Real = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Real, (_b !== null && _b !== void 0 ? _b : 0));
        this.Imaginary = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Imaginary, (_d !== null && _d !== void 0 ? _d : 0));
    }
}
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_238 = typeof float64 !== "undefined" && float64) === "function" ? _238 : Object)
], DoubleComplexNumberType.prototype, "Real", void 0);
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_239 = typeof float64 !== "undefined" && float64) === "function" ? _239 : Object)
], DoubleComplexNumberType.prototype, "Imaginary", void 0);
exports.DoubleComplexNumberType = DoubleComplexNumberType;
class AxisInformation {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.EngineeringUnits = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.EngineeringUnits, (_b !== null && _b !== void 0 ? _b : new EUInformation()));
        this.EURange = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.EURange, (_d !== null && _d !== void 0 ? _d : new Range()));
        this.Title = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.Title, (_f !== null && _f !== void 0 ? _f : new LocalizedText_1.default()));
        this.AxisScaleType = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.AxisScaleType, (_h !== null && _h !== void 0 ? _h : exports.AxisScaleEnumerationLinear));
        this.AxisSteps = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.AxisSteps, (_k !== null && _k !== void 0 ? _k : null));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", EUInformation)
], AxisInformation.prototype, "EngineeringUnits", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", Range)
], AxisInformation.prototype, "EURange", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", LocalizedText_1.default)
], AxisInformation.prototype, "Title", void 0);
__decorate([
    exports.Type('uint32'),
    __metadata("design:type", typeof (_240 = typeof AxisScaleEnumeration !== "undefined" && AxisScaleEnumeration) === "function" ? _240 : Object)
], AxisInformation.prototype, "AxisScaleType", void 0);
__decorate([
    exports.TypeArray('float64'),
    __metadata("design:type", Object)
], AxisInformation.prototype, "AxisSteps", void 0);
exports.AxisInformation = AxisInformation;
class XVType {
    constructor(options) {
        var _a, _b, _c, _d;
        this.X = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.X, (_b !== null && _b !== void 0 ? _b : 0));
        this.Value = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.Value, (_d !== null && _d !== void 0 ? _d : 0));
    }
}
__decorate([
    exports.Type('float64'),
    __metadata("design:type", typeof (_241 = typeof float64 !== "undefined" && float64) === "function" ? _241 : Object)
], XVType.prototype, "X", void 0);
__decorate([
    exports.Type('float32'),
    __metadata("design:type", typeof (_242 = typeof float32 !== "undefined" && float32) === "function" ? _242 : Object)
], XVType.prototype, "Value", void 0);
exports.XVType = XVType;
class ProgramDiagnosticDataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        this.CreateSessionId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.CreateSessionId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.CreateClientName = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.CreateClientName, (_d !== null && _d !== void 0 ? _d : ''));
        this.InvocationCreationTime = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.InvocationCreationTime, (_f !== null && _f !== void 0 ? _f : new Date()));
        this.LastTransitionTime = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.LastTransitionTime, (_h !== null && _h !== void 0 ? _h : new Date()));
        this.LastMethodCall = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.LastMethodCall, (_k !== null && _k !== void 0 ? _k : ''));
        this.LastMethodSessionId = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.LastMethodSessionId, (_m !== null && _m !== void 0 ? _m : new NodeId_1.default()));
        this.LastMethodInputArguments = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.LastMethodInputArguments, (_p !== null && _p !== void 0 ? _p : null));
        this.LastMethodOutputArguments = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.LastMethodOutputArguments, (_r !== null && _r !== void 0 ? _r : null));
        this.LastMethodCallTime = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.LastMethodCallTime, (_t !== null && _t !== void 0 ? _t : new Date()));
        this.LastMethodReturnStatus = (_v = (_u = options) === null || _u === void 0 ? void 0 : _u.LastMethodReturnStatus, (_v !== null && _v !== void 0 ? _v : new StatusResult()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], ProgramDiagnosticDataType.prototype, "CreateSessionId", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], ProgramDiagnosticDataType.prototype, "CreateClientName", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], ProgramDiagnosticDataType.prototype, "InvocationCreationTime", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], ProgramDiagnosticDataType.prototype, "LastTransitionTime", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], ProgramDiagnosticDataType.prototype, "LastMethodCall", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], ProgramDiagnosticDataType.prototype, "LastMethodSessionId", void 0);
__decorate([
    exports.TypeArray('Argument'),
    __metadata("design:type", Object)
], ProgramDiagnosticDataType.prototype, "LastMethodInputArguments", void 0);
__decorate([
    exports.TypeArray('Argument'),
    __metadata("design:type", Object)
], ProgramDiagnosticDataType.prototype, "LastMethodOutputArguments", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], ProgramDiagnosticDataType.prototype, "LastMethodCallTime", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", StatusResult)
], ProgramDiagnosticDataType.prototype, "LastMethodReturnStatus", void 0);
exports.ProgramDiagnosticDataType = ProgramDiagnosticDataType;
class ProgramDiagnostic2DataType {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        this.CreateSessionId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.CreateSessionId, (_b !== null && _b !== void 0 ? _b : new NodeId_1.default()));
        this.CreateClientName = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.CreateClientName, (_d !== null && _d !== void 0 ? _d : ''));
        this.InvocationCreationTime = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.InvocationCreationTime, (_f !== null && _f !== void 0 ? _f : new Date()));
        this.LastTransitionTime = (_h = (_g = options) === null || _g === void 0 ? void 0 : _g.LastTransitionTime, (_h !== null && _h !== void 0 ? _h : new Date()));
        this.LastMethodCall = (_k = (_j = options) === null || _j === void 0 ? void 0 : _j.LastMethodCall, (_k !== null && _k !== void 0 ? _k : ''));
        this.LastMethodSessionId = (_m = (_l = options) === null || _l === void 0 ? void 0 : _l.LastMethodSessionId, (_m !== null && _m !== void 0 ? _m : new NodeId_1.default()));
        this.LastMethodInputArguments = (_p = (_o = options) === null || _o === void 0 ? void 0 : _o.LastMethodInputArguments, (_p !== null && _p !== void 0 ? _p : null));
        this.LastMethodOutputArguments = (_r = (_q = options) === null || _q === void 0 ? void 0 : _q.LastMethodOutputArguments, (_r !== null && _r !== void 0 ? _r : null));
        this.LastMethodInputValues = (_t = (_s = options) === null || _s === void 0 ? void 0 : _s.LastMethodInputValues, (_t !== null && _t !== void 0 ? _t : null));
        this.LastMethodOutputValues = (_v = (_u = options) === null || _u === void 0 ? void 0 : _u.LastMethodOutputValues, (_v !== null && _v !== void 0 ? _v : null));
        this.LastMethodCallTime = (_x = (_w = options) === null || _w === void 0 ? void 0 : _w.LastMethodCallTime, (_x !== null && _x !== void 0 ? _x : new Date()));
        this.LastMethodReturnStatus = (_z = (_y = options) === null || _y === void 0 ? void 0 : _y.LastMethodReturnStatus, (_z !== null && _z !== void 0 ? _z : new StatusResult()));
    }
}
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], ProgramDiagnostic2DataType.prototype, "CreateSessionId", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], ProgramDiagnostic2DataType.prototype, "CreateClientName", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], ProgramDiagnostic2DataType.prototype, "InvocationCreationTime", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], ProgramDiagnostic2DataType.prototype, "LastTransitionTime", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], ProgramDiagnostic2DataType.prototype, "LastMethodCall", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", NodeId_1.default)
], ProgramDiagnostic2DataType.prototype, "LastMethodSessionId", void 0);
__decorate([
    exports.TypeArray('Argument'),
    __metadata("design:type", Object)
], ProgramDiagnostic2DataType.prototype, "LastMethodInputArguments", void 0);
__decorate([
    exports.TypeArray('Argument'),
    __metadata("design:type", Object)
], ProgramDiagnostic2DataType.prototype, "LastMethodOutputArguments", void 0);
__decorate([
    exports.TypeArray('Variant'),
    __metadata("design:type", Object)
], ProgramDiagnostic2DataType.prototype, "LastMethodInputValues", void 0);
__decorate([
    exports.TypeArray('Variant'),
    __metadata("design:type", Object)
], ProgramDiagnostic2DataType.prototype, "LastMethodOutputValues", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], ProgramDiagnostic2DataType.prototype, "LastMethodCallTime", void 0);
__decorate([
    exports.Type('object'),
    __metadata("design:type", StatusResult)
], ProgramDiagnostic2DataType.prototype, "LastMethodReturnStatus", void 0);
exports.ProgramDiagnostic2DataType = ProgramDiagnostic2DataType;
class Annotation {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.Message = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.Message, (_b !== null && _b !== void 0 ? _b : ''));
        this.UserName = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.UserName, (_d !== null && _d !== void 0 ? _d : ''));
        this.AnnotationTime = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.AnnotationTime, (_f !== null && _f !== void 0 ? _f : new Date()));
    }
}
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], Annotation.prototype, "Message", void 0);
__decorate([
    exports.Type('string'),
    __metadata("design:type", String)
], Annotation.prototype, "UserName", void 0);
__decorate([
    exports.Type('Date'),
    __metadata("design:type", Date)
], Annotation.prototype, "AnnotationTime", void 0);
exports.Annotation = Annotation;
